(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-best-sellers-experience"] && !Shopify.designMode) return;
  try {
    
  (()=>{const roots=document.querySelectorAll('[data-av-bs]');roots.forEach(root=>{const reveals=root.querySelectorAll('.av-bs-reveal');if('IntersectionObserver'in window){const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target)}}),{threshold:.12});reveals.forEach(el=>io.observe(el))}else{reveals.forEach(el=>el.classList.add('is-visible'))}const stage=root.querySelector('[data-av-stage]');if(stage&&matchMedia('(pointer:fine) and (prefers-reduced-motion:no-preference)').matches){stage.addEventListener('pointermove',event=>{const r=stage.getBoundingClientRect(),x=(event.clientX-r.left)/r.width-.5,y=(event.clientY-r.top)/r.height-.5;stage.querySelectorAll('[data-av-orbit-card]').forEach((card,index)=>{const d=(index+1)*1.5;card.style.marginLeft=`${x*d}px`;card.style.marginTop=`${y*d}px`})});stage.addEventListener('pointerleave',()=>stage.querySelectorAll('[data-av-orbit-card]').forEach(card=>{card.style.marginLeft='';card.style.marginTop=''}))}})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-b2b-search-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-avsc]').forEach((root) => {
      const reveals = root.querySelectorAll('[data-avsc-reveal]');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 });
        reveals.forEach((element) => observer.observe(element));
      } else {
        reveals.forEach((element) => element.classList.add('is-visible'));
      }

      const stage = root.querySelector('[data-avsc-stage]');
      if (stage && matchMedia('(pointer:fine) and (prefers-reduced-motion:no-preference)').matches) {
        stage.addEventListener('pointermove', (event) => {
          const bounds = stage.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width - 0.5;
          const y = (event.clientY - bounds.top) / bounds.height - 0.5;
          stage.style.setProperty('--avsc-x', `${x * 9}px`);
          stage.style.setProperty('--avsc-y', `${y * 7}px`);
          const rhino = stage.querySelector('[data-avsc-rhino]');
          if (rhino) rhino.style.margin = `${y * 7}px 0 0 ${x * 9}px`;
        });
        stage.addEventListener('pointerleave', () => {
          const rhino = stage.querySelector('[data-avsc-rhino]');
          if (rhino) rhino.style.margin = '';
        });
      }

      root.querySelectorAll('[data-avsc-case]').forEach((link) => {
        link.addEventListener('click', () => {
          const select = root.querySelector('[data-avsc-case-select]');
          if (select) select.value = link.dataset.avscCase || '';
        });
      });

      const entry = root.querySelector('[data-avsc-entry-context]');
      if (entry) {
        const params = new URLSearchParams(window.location.search);
        const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
        const context = keys.map((key) => params.get(key) ? `${key}: ${params.get(key)}` : '').filter(Boolean);
        context.push(`landing_page: ${window.location.pathname}`);
        entry.value = context.join(' | ');
      }

      if (root.querySelector('[data-avsc-success]')) {
        const trackingKey = `avsc-quote-${window.location.pathname}`;
        if (!sessionStorage.getItem(trackingKey)) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'b2b_quote_submitted', source: 'business_ipad_cases_search' });
          window.dispatchEvent(new CustomEvent('avontic:b2b-quote-submitted', { detail: { source: 'business_ipad_cases_search' } }));
          sessionStorage.setItem(trackingKey, '1');
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-bundle-studio"] && !Shopify.designMode) return;
  try {
    
function avSetupOpenHash(){const key=decodeURIComponent(location.hash.slice(1));if(!key)return;const target=document.getElementById(key);if(target&&target.matches('.av-setup-family'))target.open=true;}
avSetupOpenHash();window.addEventListener('hashchange',avSetupOpenHash);document.addEventListener('shopify:section:load',avSetupOpenHash);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-case-concierge"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const selector = '[data-av-case-concierge]';
  const featureKeys = ['stand','hand','shoulder','handle','rugged','rotation','pencil','magnetic','detachable','raised','folio','kids'];
  const useKeys = ['work','school','field','kids','travel','creative','everyday'];
  const extraKeys = ['keyboard','stylus','privacy','mouse'];
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function packUnits(entry, quantity) {
    if (!entry.pack) return 1;
    if (entry.pack > 0) return quantity >= entry.pack && quantity % entry.pack === 0 ? entry.pack : 0;
    return quantity >= 5 && quantity % 5 === 0 ? 5 : quantity >= 3 && quantity % 3 === 0 ? 3 : 0;
  }
  function modelNames(entry, codes) {
    return Object.keys(entry.models).filter(name => codes.length && codes.every(code => entry.models[name].includes(code)));
  }
  function rankEntries(catalog, state) {
    const codes = state.code ? [state.code] : catalog.models[state.model]?.codes || [];
    return catalog.products.flatMap((entry, index) => {
      const names = modelNames(entry, codes), units = packUnits(entry, state.quantity);
      if (!names.length || !units) return [];
      const family = catalog.families[entry.family];
      const included = entry.includes.slice();
      if (entry.optionalStylus && state.extras.includes('stylus')) included.push('stylus');
      const missingFeatures = state.features.filter(f => !family.features.includes(f));
      const missingExtras = state.extras.filter(f => !included.includes(f));
      const unusedExtras = included.filter(f => !state.extras.includes(f));
      const useIndex = family.uses.indexOf(state.use);
      const score = (useIndex < 0 ? 0 : 34 - useIndex * 3) + (state.features.length - missingFeatures.length) * 15 - missingFeatures.length * 24 + (state.extras.length - missingExtras.length) * 24 - missingExtras.length * 45 - unusedExtras.length * (state.extras.length ? 8 : 32) + (units > 1 ? 9 : 0) - index / 1000;
      return [{...entry,names,units,included,missingFeatures,missingExtras,score}];
    }).sort((a,b) => a.missingExtras.length - b.missingExtras.length || a.missingFeatures.length - b.missingFeatures.length || b.score - a.score);
  }
  function restorePreferences(value, catalog, currency) {
    if(!value || value.version!==2 || !Number.isFinite(value.updatedAt) || Date.now()-value.updatedAt>43200000) return null;
    const model=catalog.models.findIndex(m=>m.label===value.model);
    if(model<0)return null;
    return {model,family:catalog.models[model].family,code:catalog.models[model].codes.includes(value.code)?value.code:'',
      step:Number.isInteger(value.step)?Math.max(0,Math.min(3,value.step)):0,
      use:useKeys.includes(value.use)?value.use:'everyday',
      features:featureKeys.filter(k=>Array.isArray(value.features)&&value.features.includes(k)),
      extras:extraKeys.filter(k=>Array.isArray(value.extras)&&value.extras.includes(k)),
      quantity:Number.isInteger(value.quantity)&&value.quantity>=1&&value.quantity<=999?value.quantity:1,
      budget:value.currency===currency&&[0,100,150,200,300].includes(value.budget)?value.budget:0};
  }
  function init(root) {
    if (root.dataset.ready) return;
    const catalog = JSON.parse(root.querySelector('[data-concierge-catalog]').textContent);
    const decode = document.createElement('textarea');
    const t = Object.fromEntries(Object.entries(JSON.parse(root.querySelector('[data-concierge-copy]').textContent)).map(([key,value])=>{decode.innerHTML=value;return [key,decode.value];}));
    const body = root.querySelector('[data-concierge-body]');
    const dialog = root.querySelector('[data-concierge-dialog]');
    const launch = root.querySelector('[data-concierge-start]');
    const state = {step:0,family:'',model:-1,code:'',use:'everyday',features:[],extras:[],quantity:1,budget:0};
    const cache = new Map();
    const storageKey='avontic:case-concierge:v2', currency=root.dataset.currency||'USD';
    try {Object.assign(state,restorePreferences(JSON.parse(sessionStorage.getItem(storageKey)),catalog,currency)||{});} catch(_) {}
    let run = 0, cards = [], cartBusy = false, opener=null, maxStep=state.step;
    function syncEntries(){
      const model=catalog.models[state.model];
      document.querySelectorAll('[data-concierge-entry]').forEach(el=>el.hidden=false);
      document.querySelectorAll('[data-concierge-open], [data-concierge-start]').forEach(b=>{
        b.disabled=false;
        const label=b.querySelector('[data-concierge-label]');
        if(label)label.textContent=model?t.resume:b.matches('[data-concierge-start]')?t.start:t.compactAction;
      });
      document.querySelectorAll('[data-concierge-saved]').forEach(el=>{el.hidden=!model;el.textContent=model?fmt('remembered',{model:model.label}):'';});
    }
    function savePreferences(){
      try {if(state.model<0)sessionStorage.removeItem(storageKey);else sessionStorage.setItem(storageKey,JSON.stringify({...state,version:2,updatedAt:Date.now(),currency,model:catalog.models[state.model].label}));}catch(_){}
      syncEntries();
    }
    const fmt = (key, values={}) => Object.entries(values).reduce((s,[k,v]) => s.replaceAll('{'+k+'}',String(v)), t[key] || key);
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency || 'USD'}).format(cents/100);
    const url = (handle, values, view=true) => {
      const u = new URL(root.dataset.root + 'products/' + handle, location.origin);
      if (view) u.searchParams.set('view','avontic-case-match');
      if (values?.length) u.searchParams.set('option_values',values.join(','));
      for (const key of ['preview_theme_id','_fd','pb','currency','country','locale']) if (new URLSearchParams(location.search).has(key)) u.searchParams.set(key,new URLSearchParams(location.search).get(key));
      return u;
    };
    const event = (action, extra={}) => {
      root.dispatchEvent(new CustomEvent('avontic:case-concierge',{bubbles:true,detail:{action,model:catalog.models[state.model]?.label,use:state.use,quantity:state.quantity,features:[...state.features],extras:[...state.extras],budget:state.budget,step:state.step,...extra}}));
      window.AvonticAnalytics?.track('av_case_concierge_'+action,{component:'case_concierge',surface:root.dataset.surface,quantity:state.quantity,product_handle:extra.handle||root.dataset.product,variant_id:extra.variant,result_count:extra.handles?.length,compatibility_key:catalog.models[state.model]?.label});
    };
    function focusTitle() { dialog.scrollTop=0;body.querySelector('h3')?.focus({preventScroll:true}); }
    function stepHeading(title, intro) { return `<div class="avcc-step-heading"><h3 tabindex="-1">${escape(t[title])}</h3><p>${escape(t[intro])}</p></div>`; }
    function nav(nextLabel='next') { return `<div class="avcc-nav"><button type="button" class="avcc-back" data-back>${escape(t.back)}</button><button type="button" class="avcc-primary" data-next>${escape(t[nextLabel])}<span aria-hidden="true"> →</span></button></div>`; }
    function drawProgress() {
      root.querySelectorAll('[data-step]').forEach((el,i)=>{el.classList.toggle('is-active',i===state.step);el.classList.toggle('is-done',i<state.step);el.setAttribute('aria-current',i===state.step?'step':'false');});
      maxStep=Math.max(maxStep,state.step);
      root.querySelectorAll('[data-goto]').forEach(b=>b.disabled=cartBusy||Number(b.dataset.goto)>maxStep||(Number(b.dataset.goto)>0&&state.model<0)||(Number(b.dataset.goto)===3&&!cards.length));
      root.querySelector('[data-concierge-progress]').style.width = (state.step+1)*25+'%';
    }
    function render(focus=true) {
      drawProgress();
      if(state.step===0) {
        body.innerHTML=stepHeading('modelTitle','modelIntro')+`<div class="avcc-model-grid"><label>${escape(t.family)}<select data-family><option value="">${escape(t.chooseFamily)}</option>${['iPad','iPad Air','iPad Pro','iPad mini'].map(x=>`<option${x===state.family?' selected':''}>${x}</option>`).join('')}</select></label><label>${escape(t.model)}<select data-model ${state.family?'':'disabled'}><option value="">${escape(t.chooseModel)}</option>${catalog.models.map((m,i)=>m.family===state.family?`<option value="${i}"${i===state.model?' selected':''}>${escape(m.label)}</option>`:'').join('')}</select></label></div><div class="avcc-lookup"><span>${escape(t.or)}</span><div><label class="avcc-sr" for="avcc-code-${escape(root.dataset.section)}">${escape(t.codeLabel)}</label><input id="avcc-code-${escape(root.dataset.section)}" type="text" maxlength="5" inputmode="text" autocomplete="off" spellcheck="false" data-code placeholder="${escape(t.codePlaceholder)}" value="${escape(state.code)}"><button type="button" data-lookup>${escape(t.lookup)}<span aria-hidden="true"> ↗</span></button></div></div><details class="avcc-help" open><summary>${escape(t.modelHelp)}</summary><p>${escape(t.modelHelpText)}</p></details><div class="avcc-fit" data-fit ${state.model<0?'hidden':''}><span aria-hidden="true">✓</span><div><small>${escape(t.fitSelected)}</small><strong>${escape(catalog.models[state.model]?.label||'')}</strong></div></div><p class="avcc-error" data-error role="alert"></p><div class="avcc-nav avcc-nav-end"><button class="avcc-primary" type="button" data-next>${escape(t.next)} →</button></div>`;
      } else if(state.step===1) {
        body.innerHTML=stepHeading('dayTitle','dayIntro')+`<fieldset class="avcc-uses"><legend class="avcc-sr">${escape(t.dayTitle)}</legend>${useKeys.map((k,i)=>`<label class="avcc-choice"><input type="radio" name="avcc-use-${escape(root.dataset.section)}" value="${k}"${state.use===k?' checked':''}><span><i aria-hidden="true">${['▤','▥','◇','♡','↗','✧','☷'][i]}</i><strong>${escape(t['use_'+k])}</strong><small>${escape(t['use_'+k+'_sub'])}</small><b aria-hidden="true">✓</b></span></label>`).join('')}</fieldset><fieldset class="avcc-features"><legend>${escape(t.priorities)}</legend><p>${escape(t.prioritiesHint)}</p><div>${featureKeys.map(k=>`<label class="avcc-chip"><input type="checkbox" data-feature value="${k}"${state.features.includes(k)?' checked':''}><span><b aria-hidden="true">+</b>${escape(t['feature_'+k])}</span></label>`).join('')}</div></fieldset>${nav()}`;
      } else if(state.step===2) {
        body.innerHTML=stepHeading('setupTitle','setupIntro')+`<fieldset class="avcc-extras"><legend class="avcc-sr">${escape(t.setupTitle)}</legend>${extraKeys.map((k,i)=>`<label class="avcc-choice"><input type="checkbox" data-extra value="${k}"${state.extras.includes(k)?' checked':''}><span><i aria-hidden="true">${['⌨','✎','◈','↖'][i]}</i><strong>${escape(t['extra_'+k])}</strong><small>${escape(t['extra_'+k+'_sub'])}</small><b aria-hidden="true">✓</b></span></label>`).join('')}</fieldset><p class="avcc-small">${escape(t.caseOnly)}</p><div class="avcc-order-grid"><label>${escape(t.quantity)}<input type="number" min="1" max="999" step="1" value="${state.quantity}" data-quantity><small>${escape(t.quantityHint)}</small></label><label>${escape(t.budget)}<select data-budget><option value="0">${escape(t.budgetAny)}</option>${[100,150,200,300].map(n=>`<option value="${n}"${state.budget===n?' selected':''}>${escape(t.upTo)} ${escape(money(n*100))}</option>`).join('')}</select></label></div><p class="avcc-small">${escape(t.stylusNote)}</p><p data-error class="avcc-error" role="alert"></p>${nav('find')}`;
      }
      savePreferences();
      if(focus)focusTitle();
    }
    function modelChanged(index, code='') {
      state.model=index; state.code=code; state.family=catalog.models[index]?.family||state.family;
      render(false);
    }
    function codes() {return state.code?[state.code]:catalog.models[state.model]?.codes||[];}
    async function fetchProduct(entry, values, fresh=false) {
      const u=url(entry.handle,values); const key=u.toString();
      if(!fresh&&cache.has(key))return cache.get(key);
      const request=fetch(key,{credentials:'same-origin',signal:AbortSignal.timeout(15000)}).then(async res=>{
        if(!res.ok)throw new Error('load');
        const d=await res.json();if(d.handle!==entry.handle||!Array.isArray(d.options))throw new Error('load');return d;
      }).catch(error=>{cache.delete(key);throw error;});
      cache.set(key,request);return request;
    }
    function liveModelNames(entry, data) {
      return (data.options[entry.modelIndex]?.values||[]).filter(v=>{
        const live=Array.isArray(v.models)&&v.models.length?v.models:entry.models[v.name];
        return live&&codes().every(c=>live.includes(c));
      }).map(v=>v.name);
    }
    function allowed(entry, options, names) {
      if(!names.includes(options[entry.modelIndex]))return false;
      if(entry.optionalStylus){const opt=entry.optionalStylus;const wanted=state.extras.includes('stylus')?(entry.pack===-1?entry.units+' Black Styluses':opt.with[0]):opt.without;if(options[opt.index]!==wanted)return false;}
      if(entry.pack===-1){
        const pack=options.find(x=>/^[35]-Case Pack$/.test(x));
        if(pack!==entry.units+'-Case Pack')return false;
        const pen=options.find(x=>/Stylus|Styluses/.test(x));
        if(pen!==(state.extras.includes('stylus')?entry.units+' Black Styluses':'No Stylus'))return false;
      }
      return true;
    }
    async function prepare(entry) {
      const data=await fetchProduct(entry);
      const names=liveModelNames(entry,data); if(!names.length)return null;
      let variant=data.complete?data.variants.find(v=>v.available&&allowed(entry,v.options,names)):null;
      let selected;
      if(data.complete&&!variant)return null;
      if(variant)selected=variant.options.map((v,i)=>data.options[i].values.find(x=>x.name===v)?.id);
      else {
        selected=data.options.map((o,i)=>(i===entry.modelIndex?o.values.find(v=>names.includes(v.name)):i===entry.optionalStylus?.index?o.values.find(v=>v.name===(state.extras.includes('stylus')?entry.optionalStylus.with[0]:entry.optionalStylus.without)):o.values.find(v=>v.available)||o.values[0])?.id);
        const resolved=await fetchProduct(entry,selected);variant=resolved.variant;
        const expected=selected.map((id,i)=>data.options[i].values.find(v=>v.id===id)?.name);
        if(!variant?.available||!expected.every((name,i)=>variant.options[i]===name)||!allowed(entry,variant.options,names))return null;
      }
      return {entry,data,names,variant,selected,revision:0,pending:false};
    }
    function chip(text, cls='') {return `<span class="avcc-tag ${cls}">${escape(text)}</span>`;}
    function cardHTML(card,index) {
      const {entry,data,variant}=card, family=catalog.families[entry.family];
      const label=entry.units>1?t.pack:entry.included.length?t.bundle:t.case;
      const missFeatures=entry.missingFeatures.map(k=>t['feature_'+k]);
      const missExtras=entry.missingExtras.map(k=>t['extra_'+k]);
      const total=variant.price*state.quantity/entry.units;
      const over=state.budget&&variant.price/entry.units>state.budget*100;
      const includeText=entry.included.map(k=>t['extra_'+k]).join(' + ');
      const reason=t['reason_'+entry.family]||family.reason;
      return `<article class="avcc-card${index===0?' avcc-card-best':''}" data-card="${index}"><div class="avcc-card-rank">${escape(index===0?t.recommended:t.alternative)}<span>0${index+1}</span></div><div class="avcc-card-media"><img src="${escape(variant.image||data.image||'')}" alt="${escape(data.title)}" width="600" height="600" loading="lazy"><span>${escape(label)}</span></div><div class="avcc-card-body"><h4>${escape(family.title)}${entry.units>1?' · '+escape(t.teamName):''}</h4><p class="avcc-card-reason">${escape(reason)}</p><div class="avcc-tags">${[...family.features.filter(f=>state.features.includes(f)),...family.features.filter(f=>!state.features.includes(f))].slice(0,4).map(f=>chip(t['feature_'+f],state.features.includes(f)?'is-match':'')).join('')}</div><div class="avcc-included"><small>${escape(t.includes)}</small><strong>${escape(family.title)}${includeText?' + '+escape(includeText):''}</strong>${entry.units>1?`<span>${escape(fmt('packCount',{count:state.quantity/entry.units,units:entry.units}))}</span>`:''}</div>${missFeatures.length?`<p class="avcc-tradeoff"><b>${escape(t.missingFeatures)}:</b> ${escape(missFeatures.join(', '))}</p>`:''}${missExtras.length?`<p class="avcc-tradeoff"><b>${escape(t.missingExtras)}:</b> ${escape(missExtras.join(', '))}</p>`:''}<p class="avcc-fit-line">✓ ${escape(t.fits)}: ${escape(catalog.models[state.model].label)}</p><div class="avcc-card-options">${data.options.map((o,i)=>{
        if(i===entry.modelIndex||entry.pack===-1||i===entry.optionalStylus?.index)return '';
        if(o.values.length===1)return `<p class="avcc-fixed">${escape(o.name)}: ${escape(o.values[0].name)}</p>`;
        return `<label>${escape(o.name)}<select data-option="${i}" aria-label="${escape(o.name+' — '+data.title)}">${o.values.map(v=>`<option value="${v.id}"${card.selected[i]===v.id?' selected':''}>${escape(v.name)}</option>`).join('')}</select></label>`;
      }).join('')}</div><div class="avcc-card-price" data-price><strong>${escape(money(total))}</strong><span>${escape(state.quantity===1?t.oneTotal:fmt('total',{quantity:state.quantity}))}</span>${entry.units>1?`<small>${escape(money(variant.price/entry.units))} ${escape(t.perSetup)}</small>`:''}${variant.compare>variant.price?`<small>${escape(fmt('save',{amount:money((variant.compare-variant.price)*state.quantity/entry.units)}))}</small>`:''}${over?`<small class="avcc-tradeoff">${escape(t.overBudget)}</small>`:''}</div><p class="avcc-card-status" data-card-status role="status"></p><button type="button" class="avcc-primary" data-add>${escape(t.add)} <span aria-hidden="true">→</span></button><a class="avcc-product-link" data-product-link href="${escape(productLink(card))}">${escape(t.details)} ↗</a></div></article>`;
    }
    function productLink(card) {const u=url(card.entry.handle,card.selected,false);if(card.variant?.id)u.searchParams.set('variant',card.variant.id);if(state.code)u.searchParams.set('model',state.code);return u.toString();}
    let guideResultId='',guideShownAt=0,guideSessionId=crypto.randomUUID(),guideRequest=null;
    function resultSnapshot(){
      return {resultId:guideResultId,shownAt:guideShownAt,capturedAt:Date.now(),currency,locale:document.documentElement.lang||'en',choices:{model:catalog.models[state.model]?.label,use:state.use,features:[...state.features],extras:[...state.extras],quantity:state.quantity,budget:state.budget},products:cards.map(card=>{
        const {entry,data,variant}=card,family=catalog.families[entry.family];
        return {handle:entry.handle,title:data.title,displayTitle:family.title+(entry.units>1?' · '+t.teamName:''),variantId:String(variant.id),variantTitle:variant.options.join(' / '),image:variant.image||data.image,url:productLink(card),priceCents:variant.price,units:entry.units,reason:t['reason_'+entry.family]||family.reason,matchedFeatures:family.features.filter(f=>state.features.includes(f)),missingFeatures:entry.missingFeatures,includedExtras:entry.included,missingExtras:entry.missingExtras};
      })};
    }
    function guideHTML(){return '<section class="avcc-guide"><div class="avcc-guide-copy"><p class="avcc-guide-kicker">YOUR PERSONAL CASE GUIDE</p><h4>Your shortlist.<br><em>Beautifully explained.</em></h4><p>Keep these exact case options, your selected colours and a clear breakdown of how each one fits your iPad and your needs.</p><div class="avcc-guide-details"><span>Your exact matches</span><span>Features &amp; trade-offs</span><span>Direct product links</span></div></div><form data-guide-form class="avcc-guide-form"><label for="avcc-guide-email-'+root.id+'">Where should we send your guide?</label><input id="avcc-guide-email-'+root.id+'" name="email" type="email" autocomplete="email" inputmode="email" required maxlength="254" placeholder="you@example.com"><div class="avcc-guide-hp" aria-hidden="true"><label>Website<input name="website" type="text" tabindex="-1" autocomplete="off"></label></div><button class="avcc-primary" type="submit">Email my personalized guide</button><p class="avcc-guide-consent">By requesting your guide, you agree to receive this personalized email using your answers and saved recommendations. This does not subscribe you to general marketing. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy policy</a></p><p class="avcc-guide-status" data-guide-status role="status" aria-live="polite">Optional. Your results are already here to explore.</p></form></section>';}
    body.addEventListener('submit',async e=>{
      const form=e.target.closest('[data-guide-form]');if(!form)return;e.preventDefault();
      const status=form.querySelector('[data-guide-status]'),button=form.querySelector('button[type="submit"]');
      if(cards.some(c=>c.pending||!c.variant?.available)){status.textContent='Please finish choosing an available colour for each case, then request your guide.';return;}
      if(!form.reportValidity())return;const email=form.elements.email.value.trim().toLowerCase();
      const snapshot=resultSnapshot(),fingerprint=JSON.stringify({...snapshot,capturedAt:0});
      if(!guideRequest||guideRequest.email!==email||guideRequest.fingerprint!==fingerprint)guideRequest={id:crypto.randomUUID(),email,fingerprint,snapshot};
      button.disabled=true;status.textContent='Saving your exact matches…';
      try{
        const analyticsConsent=window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
        const sessionId=window.AvonticFinderInsights?.sessionId()||guideSessionId;
        const preview=['development','demo','unpublished'].includes(String(window.AvonticAnalyticsConfig?.themeRole||window.Shopify?.theme?.role).toLowerCase())||window.Shopify?.designMode||new URLSearchParams(location.search).has('preview_theme_id')||new URLSearchParams(location.search).has('av_finder_test');
        const response=await fetch('https://avontic-finder-insights.ab112488.chatgpt.site/api/guides',{method:'POST',headers:{'Content-Type':'text/plain'},credentials:'omit',body:JSON.stringify({id:guideRequest.id,sessionId,environment:preview?'preview':'production',email,consent:true,analyticsConsent,website:form.elements.website.value,snapshot:guideRequest.snapshot}),signal:AbortSignal.timeout(20000)});
        const saved=await response.json();if(!response.ok||!saved.saved)throw Error(saved.error||'Please try again.');
        status.textContent=preview?'Preview saved. Your email, answers and exact case options are now in Finder Insights. No email has been sent.':'Your guide request is saved. We’ll email your personalized breakdown. You can keep exploring your cases below.';
        button.textContent='Guide request saved';button.disabled=true;
        form.elements.email.addEventListener('input',()=>{button.disabled=false;button.textContent='Email my personalized guide';},{once:true});
      }catch(error){status.textContent=error.name==='TimeoutError'?'That took a little too long. Please try again; your request will not be duplicated.':error.message||'We could not save your guide. Please try again.';button.disabled=false;}
    });
    function resultHeader(partial) {
      return stepHeading(!cards.length?'emptyTitle':partial?'partial':'resultsTitle',!cards.length?'noMatchesText':partial?'partialIntro':'resultsIntro')+`<div class="avcc-summary">${chip(catalog.models[state.model].label)}${chip(t['use_'+state.use])}${chip(state.quantity+' × iPad')}<button type="button" data-edit>${escape(t.edit)} ↗</button></div>`;
    }
    async function results() {
      state.step=3;drawProgress();savePreferences();const token=++run;cards=[];
      body.innerHTML=`<div class="avcc-loading" role="status"><span></span><h3 tabindex="-1">${escape(t.loading)}</h3><p>${escape(t.loadingText)}</p><button type="button" class="avcc-back" data-edit>${escape(t.cancelled)}</button></div>`;focusTitle();
      event('results_requested');
      const ranking=rankEntries(catalog,state);
      const groups=new Map();
      for(const entry of ranking){const key=entry.family+(entry.units>1?'-pack':'');if(!groups.has(key))groups.set(key,[]);if(groups.get(key).length<3)groups.get(key).push(entry);}
      const candidates=[...groups.values()].slice(0,8);
      const prepareGroup=async entries=>{let error;for(const entry of entries){if(token!==run)return null;try{const card=await prepare(entry);if(card)return card;}catch(e){error=e;}}if(error)throw error;return null;};
      let found=[],failures=0;
      for(let i=0;i<candidates.length;i+=3){
        const batch=await Promise.allSettled(candidates.slice(i,i+3).map(prepareGroup));
        if(token!==run)return;
        for(const r of batch){if(r.status==='fulfilled'&&r.value)found.push(r.value);else if(r.status==='rejected')failures++;}
        if(found.length>=3&&!state.budget&&found.filter(c=>!c.entry.missingExtras.length&&!c.entry.missingFeatures.length).length>=3)break;
      }
      if(token!==run)return;
      found.sort((a,b)=>a.entry.missingExtras.length-b.entry.missingExtras.length||a.entry.missingFeatures.length-b.entry.missingFeatures.length||(state.budget?Number(a.variant.price/a.entry.units>state.budget*100)-Number(b.variant.price/b.entry.units>state.budget*100):0)||b.entry.score-a.entry.score);
      cards=found.slice(0,3);guideResultId=crypto.randomUUID();guideShownAt=Date.now();guideRequest=null;
      const partial=cards.length&&cards[0].entry.missingFeatures.length+cards[0].entry.missingExtras.length>0;
      body.innerHTML=resultHeader(partial)+`${state.features.includes('handle')?`<p class="avcc-notice">${escape(t.noHandle)}</p>`:''}`+(cards.length?`<div class="avcc-results">${cards.map(cardHTML).join('')}</div><p class="avcc-small avcc-result-note">${escape(t.bundleNote)} ${escape(t.notIncluded)} ${escape(t.priceNote)}</p>${state.extras.includes('stylus')?`<p class="avcc-small">${escape(t.stylusNote)}</p>`:''}`:`<div class="avcc-empty"><h4>${escape(failures?t.retry:t.noMatches)}</h4><p>${escape(t.noMatchesText)}</p>${failures?`<button type="button" class="avcc-primary" data-retry>${escape(t.retryButton)}</button>`:''}<a href="${escape(root.dataset.root+'pages/contact-us')}">${escape(t.help)} ↗</a></div>`)+`${state.quantity>=10?`<div class="avcc-team"><p>${escape(t.quoteText)}</p><a href="${escape(root.dataset.root+'pages/business-solutions?quantity='+state.quantity+'&intent=formal_quote&model='+(state.code||catalog.models[state.model].codes[0])+'#avb-quote')}">${escape(t.quote)} ↗</a></div>`:''}<div class="avcc-nav"><button type="button" class="avcc-back" data-back>${escape(t.back)}</button><button type="button" class="avcc-back" data-restart>${escape(t.restart)}</button></div>`;
      if(cards.length)body.querySelector('.avcc-results').insertAdjacentHTML('beforebegin',guideHTML());
      drawProgress();focusTitle();event('results_shown',{handles:cards.map(c=>c.entry.handle),snapshot:cards.length?resultSnapshot():undefined});
    }
    async function optionChanged(card, el) {
      const revision=++card.revision;card.pending=true;
      card.selected[Number(el.dataset.option)]=el.value;
      const article=el.closest('[data-card]'), button=article.querySelector('[data-add]'), status=article.querySelector('[data-card-status]');
      button.disabled=true; status.textContent=t.checking;article.querySelector('[data-product-link]').hidden=true;
      try {
        const data=await fetchProduct(card.entry,card.selected,true);
        if(revision!==card.revision)return;
        const expected=card.selected.map((id,i)=>card.data.options[i].values.find(v=>v.id===id)?.name);
        if(!data.variant?.available||!expected.every((x,i)=>data.variant.options[i]===x)||!allowed(card.entry,data.variant.options,liveModelNames(card.entry,data)))throw new Error('unavailable');
        card.variant=data.variant;card.pending=false;
        const holder=document.createElement('div');holder.innerHTML=cardHTML(card,Number(article.dataset.card));
        article.replaceWith(holder.firstElementChild);
        guideRequest=null;const guideButton=body.querySelector('[data-guide-form] button[type=submit]');if(guideButton){guideButton.disabled=false;guideButton.textContent='Email my personalized guide';body.querySelector('[data-guide-status]').textContent='Your updated selections will be included in your guide.';}
        if(cards.every(c=>!c.pending&&c.variant?.available))event('variants_updated',{snapshot:resultSnapshot()});
        body.querySelector(`[data-card="${article.dataset.card}"] [data-option="${el.dataset.option}"]`)?.focus({preventScroll:true});
      } catch(error) {if(revision!==card.revision)return;card.variant=null;card.pending=false;status.textContent=error.message==='unavailable'?t.unavailable:t.retry;}
    }
    async function add(card,article) {
      if(cartBusy||card.pending||!card.variant?.available)return;
      cartBusy=true;dialog.querySelectorAll('button,input,select').forEach(b=>b.disabled=true);
      const status=article.querySelector('[data-card-status]');status.textContent=t.adding;
      try {
        const fresh=await fetchProduct(card.entry,card.selected,true);
        const wanted=card.selected.map((id,i)=>card.data.options[i].values.find(v=>v.id===id)?.name);
        if(!fresh.variant?.available||fresh.variant.id!==card.variant.id||!wanted.every((v,i)=>fresh.variant.options[i]===v)||!allowed(card.entry,fresh.variant.options,liveModelNames(card.entry,fresh)))throw new Error(t.unavailable);
        if(fresh.variant.price!==card.variant.price) {card.variant=fresh.variant;const holder=document.createElement('div');holder.innerHTML=cardHTML(card,Number(article.dataset.card));article.replaceWith(holder.firstElementChild);throw new Error(t.priceChanged);}
        const response=await fetch(root.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:fresh.variant.id,quantity:state.quantity/card.entry.units,properties:{'_case_concierge':'v2',...(window.AvonticFinderInsights?.sessionId()?{'_finder_session':window.AvonticFinderInsights.sessionId()}: {})}}]}),signal:AbortSignal.timeout(20000)});
        const payload=await response.json();if(!response.ok)throw new Error(payload.description||t.errorCart);
        status.textContent=t.added;event('add_to_cart',{handle:card.entry.handle,variant:fresh.variant.id});
        location.assign(root.dataset.root+'cart');
      } catch(error) {
        const liveArticle=body.querySelector(`[data-card="${article.dataset.card}"]`);if(liveArticle)liveArticle.querySelector('[data-card-status]').textContent=error.name==='TimeoutError'?t.errorCart:error.message||t.errorCart;
        cartBusy=false;dialog.querySelectorAll('button,input,select').forEach(b=>b.disabled=false);drawProgress();body.querySelectorAll('[data-card]').forEach(a=>{const c=cards[Number(a.dataset.card)];a.querySelector('[data-add]').disabled=Boolean(c.pending||!c.variant?.available);});
      }
    }
    root.dataset.ready = 'true';
    syncEntries();
    function open(button){
      if(dialog.open)return;
      opener=button;dialog.showModal();document.documentElement.classList.add('avcc-modal-open');
      document.querySelectorAll('[data-concierge-open], [data-concierge-start]').forEach(b=>b.setAttribute('aria-expanded','true'));
      if(state.step===3)results();else render();event('opened');
    }
    document.addEventListener('click',e=>{const button=e.target.closest('[data-concierge-open], [data-concierge-start]');if(button&&root.isConnected)open(button);});
    root.querySelector('[data-concierge-close]').addEventListener('click',()=>{if(!cartBusy)dialog.close();});
    dialog.addEventListener('cancel',e=>{if(cartBusy)e.preventDefault();});
    dialog.addEventListener('close',()=>{
      event('closed');run++;savePreferences();document.documentElement.classList.remove('avcc-modal-open');
      document.querySelectorAll('[data-concierge-open], [data-concierge-start]').forEach(b=>b.setAttribute('aria-expanded','false'));
      (opener?.isConnected?opener:document.querySelector('[data-concierge-open], [data-concierge-start]'))?.focus({preventScroll:true});
    });
    root.querySelectorAll('[data-goto]').forEach(button=>button.addEventListener('click',()=>{if(cartBusy)return;run++;state.step=Number(button.dataset.goto);if(state.step===3)results();else render();}));
    const entryObserver=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-concierge-entry]')||n.querySelector('[data-concierge-entry]')))))syncEntries();});
    entryObserver.observe(document.body,{childList:true,subtree:true});
    document.addEventListener('shopify:section:unload',()=>{if(!root.isConnected)entryObserver.disconnect();});
    body.addEventListener('change',e=>{
      const el=e.target;if(cartBusy)return;
      if(el.matches('[data-family]')){state.family=el.value;state.model=-1;state.code='';render(false);body.querySelector('[data-model]').focus();}
      else if(el.matches('[data-model]')){modelChanged(el.value===''?-1:Number(el.value));body.querySelector('[data-model]').focus();}
      else if(el.matches('input[type="radio"]'))state.use=el.value;
      else if(el.matches('[data-feature]'))state.features=[...body.querySelectorAll('[data-feature]:checked')].map(x=>x.value);
      else if(el.matches('[data-extra]'))state.extras=[...body.querySelectorAll('[data-extra]:checked')].map(x=>x.value);
      else if(el.matches('[data-budget]'))state.budget=Number(el.value);
      else if(el.matches('[data-quantity]')){const quantity=Number(el.value);if(Number.isInteger(quantity)&&quantity>=1&&quantity<=999)state.quantity=quantity;}
      else if(el.matches('[data-option]'))optionChanged(cards[Number(el.closest('[data-card]').dataset.card)],el);
      savePreferences();event('selection_changed');
    });
    body.addEventListener('keydown',e=>{if(e.target.matches('[data-code]')&&e.key==='Enter'){e.preventDefault();body.querySelector('[data-lookup]').click();}});
    body.addEventListener('click',e=>{
      const link=e.target.closest('[data-product-link]');if(link){const card=cards[Number(link.closest('[data-card]').dataset.card)];if(card)event('product_clicked',{handle:card.entry.handle,variant:card.variant?.id});}
      const button=e.target.closest('button');if(!button||cartBusy)return;
      if(button.matches('[data-lookup]')){
        const code=body.querySelector('[data-code]').value.trim().toUpperCase();const idx=/^A\d{4}$/.test(code)?catalog.models.findIndex(m=>m.codes.includes(code)):-1;
        if(idx<0){body.querySelector('[data-error]').textContent=t.unknown;return;}modelChanged(idx,code);body.querySelector('[data-next]').focus();
      }else if(button.matches('[data-next]')){
        if(state.step===0&&state.model<0){body.querySelector('[data-error]').textContent=t.needModel;return;}
        if(state.step===2){const value=Number(body.querySelector('[data-quantity]').value);if(!Number.isInteger(value)||value<1||value>999){body.querySelector('[data-error]').textContent=t.qtyError;return;}state.quantity=value;results();return;}
        event('step_completed');state.step++;render();
      }else if(button.matches('[data-back]')){if(state.step===2){const quantity=Number(body.querySelector('[data-quantity]').value);if(Number.isInteger(quantity)&&quantity>=1&&quantity<=999)state.quantity=quantity;}run++;state.step=Math.max(0,state.step-1);render();}
      else if(button.matches('[data-edit]')){run++;state.step=0;render();}
      else if(button.matches('[data-restart]')){event('restarted');run++;maxStep=0;cards=[];Object.assign(state,{step:0,family:'',model:-1,code:'',use:'everyday',features:[],extras:[],quantity:1,budget:0});render();}
      else if(button.matches('[data-retry]'))results();
      else if(button.matches('[data-add]')){const article=button.closest('[data-card]');add(cards[Number(article.dataset.card)],article);}
    });
  }
  document.querySelectorAll(selector).forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll(selector).forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-collection-device-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('avontic-device-navigation')) {
    customElements.define(
      'avontic-device-navigation',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();

          this.addEventListener(
            'keydown',
            (event) => {
              if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

              const links = [...this.querySelectorAll('a[href]')];
              const currentIndex = links.indexOf(document.activeElement);
              if (currentIndex < 0) return;

              event.preventDefault();
              const direction = event.key === 'ArrowRight' ? 1 : -1;
              const nextIndex = (currentIndex + direction + links.length) % links.length;
              links[nextIndex]?.focus();
            },
            { signal: this.controller.signal }
          );
        }

        disconnectedCallback() {
          this.controller?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-complete-setup-studio"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-avss]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const products = JSON.parse(root.querySelector('[data-avss-products]').textContent);
  const copy = JSON.parse(root.querySelector('[data-avss-copy]').textContent);
  const ipadDevices = [
    {id:'air-13-2024-26',label:'iPad Air 13-inch · M2 / M3 / M4 · 2024–2026',screen:'13-inch',pro:'iPad Air 13 (2024 M2 / 2025 M3 / 2026 M4)',armor:'iPad Air 13 (2024 M2 / 2025 M3 / 2026 M4)'},
    {id:'air-11-2024-26',label:'iPad Air 11-inch · M2 / M3 / M4 · 2024–2026',screen:'11-inch',pro:'iPad Air 11 (2024 M2 / 2025 M3 / 2026 M4)',armor:'iPad Air 11 (2024 M2 / 2025 M3 / 2026 M4)'},
    {id:'ipad-a16-2025',label:'iPad 11-inch · A16 / 11th Gen · 2025',screen:'11-inch',pro:'iPad 11-inch A16 / 11th Gen (2025)',armor:'iPad A16 11th Generation 2025',privacy:'A16 2025'},
    {id:'pro-13-2024-25',label:'iPad Pro 13-inch · M4 / M5 · 2024–2025',screen:'13-inch',pro:'iPad Pro 13-inch M4/M5 (2024-2025)',armor:'iPad Pro 13 2024 2025',privacy:'Pro 13 M4 M5'},
    {id:'pro-11-2024-25',label:'iPad Pro 11-inch · M4 / M5 · 2024–2025',screen:'11-inch',pro:'iPad Pro 11-inch M4/M5 (2024-2025)',armor:'iPad Pro 11 2024 2025',privacy:'Pro 11 M4 M5'},
    {id:'mini-6-7',label:'iPad mini · 6th / 7th Gen',screen:'8.3-inch',armor:'iPad Mini 6 7',privacy:'Mini 6 7'},
    {id:'ipad-10-2022',label:'iPad 10th Gen · 10.9-inch · 2022',screen:'10.9-inch',pro:'iPad 10th Gen 10.9-inch (2022)',armor:'iPad 10th 10.9 inch',privacy:'10th 10.9'},
    {id:'pro-11-2021-22',label:'iPad Pro 11-inch · 3rd / 4th Gen · 2021–2022',screen:'11-inch',pro:'iPad Pro 11-inch 3rd/4th Gen (2021-2022)',armor:'Pro11 2018-2022'},
    {id:'pro-11-2018-20',label:'iPad Pro 11-inch · 1st / 2nd Gen · 2018–2020',screen:'11-inch',pro:'iPad Pro 11-inch 1st/2nd Gen (2018-2020)',armor:'Pro11 2018-2022'},
    {id:'pro-12-9-2021-22',label:'iPad Pro 12.9-inch · 5th / 6th Gen · 2021–2022',screen:'12.9-inch',pro:'iPad Pro 12.9-inch 5th/6th Gen (2021-2022)',privacy:'Pro 12.9'},
    {id:'pro-12-9-2018-20',label:'iPad Pro 12.9-inch · 3rd / 4th Gen · 2018–2020',screen:'12.9-inch',pro:'iPad Pro 12.9-inch 3rd/4th Gen (2018-2020)',privacy:'Pro 12.9'},
    {id:'ipad-10-2-7-9',label:'iPad 10.2-inch · 7th / 8th / 9th Gen',screen:'10.2-inch',pro:'iPad 10.2-inch 7th/8th/9th Gen',armor:'iPad 10.2 7th 8th 9th',privacy:'7th 8th 9th 10.2'},
    {id:'air-5',label:'iPad Air 5th Gen · 10.9-inch',screen:'10.9-inch',pro:'iPad Air 5th Gen 10.9-inch',armor:'iPad Air 4th 5th',privacy:'Pro 11 Air 4 5'},
    {id:'air-4',label:'iPad Air 4th Gen · 10.9-inch',screen:'10.9-inch',pro:'iPad Air 4th Gen 10.9-inch',armor:'iPad Air 4th 5th',privacy:'Pro 11 Air 4 5'},
    {id:'ipad-5-6',label:'iPad 9.7-inch · 5th / 6th Gen',screen:'9.7-inch',pro:'iPad 9.7-inch 5th/6th Gen',armor:'iPad 5th 6th 9.7'},
    {id:'pro-9-7',label:'iPad Pro 9.7-inch',screen:'9.7-inch',pro:'iPad Pro 9.7-inch',armor:'iPad Pro 9.7 2016',privacy:'Air 1 2 Pro 9.7'},
    {id:'air-3-pro-10-5',label:'iPad Air 3 / Pro · 10.5-inch',screen:'10.5-inch',pro:'iPad Pro 10.5-inch / iPad Air 3 10.5-inch',privacy:'Air 3 Pro 10.5'},
    {id:'air-2',label:'iPad Air 2 · 9.7-inch',screen:'9.7-inch',pro:'iPad Air 2',privacy:'Air 1 2 Pro 9.7'}
  ].map(device => ({...device,family:'ipad',identifier:'Confirm the exact generation in Settings',match:'RhinoGuard Pro / ArmorPro',standOk:true}));
  const galaxyDevices = [
    {id:'galaxy-s11-ultra',label:'Galaxy Tab S11 Ultra · 14.6-inch · 2025',screen:'14.6-inch',identifier:'SM-X930 / SM-X936',galaxy:'S11 Ultra 14.6"'},
    {id:'galaxy-s11',label:'Galaxy Tab S11 · 11-inch · 2025',screen:'11-inch',identifier:'SM-X730 / SM-X736',galaxy:'S11 2025 11"',standOk:true},
    {id:'galaxy-s10-ultra',label:'Galaxy Tab S10 Ultra · 14.6-inch · 2024',screen:'14.6-inch',identifier:'SM-X920 / SM-X926',galaxy:'S10 Ultra 14.6"'},
    {id:'galaxy-s10-plus',label:'Galaxy Tab S10+ · 12.4-inch · 2024',screen:'12.4-inch',identifier:'SM-X820 / SM-X826',galaxy:'Tab S10 Plus 12.4"',standOk:true},
    {id:'galaxy-s10-fe-plus',label:'Galaxy Tab S10 FE+ · 13.1-inch · 2025',screen:'13.1-inch',identifier:'SM-X620 / SM-X626',galaxy:'S10 FE Plus 13.1"'},
    {id:'galaxy-s10-fe',label:'Galaxy Tab S10 FE · 10.9-inch · 2025',screen:'10.9-inch',identifier:'SM-X520 / SM-X526',galaxy:'S10 FE 10.9"',standOk:true},
    {id:'galaxy-s10-lite',label:'Galaxy Tab S10 Lite · 10.9-inch · 2025',screen:'10.9-inch',identifier:'SM-X400 / SM-X406',galaxy:'S10 Lite 10.9"',standOk:true},
    {id:'galaxy-s9-ultra',label:'Galaxy Tab S9 Ultra · 14.6-inch · 2023',screen:'14.6-inch',identifier:'SM-X910 / SM-X916',galaxy:'S9 Ultra 14.6"'},
    {id:'galaxy-s9-plus',label:'Galaxy Tab S9+ · 12.4-inch · 2023',screen:'12.4-inch',identifier:'SM-X810 / SM-X816',galaxy:'Tab S9 Plus 12.4"',standOk:true},
    {id:'galaxy-s9-fe-plus',label:'Galaxy Tab S9 FE+ · 12.4-inch · 2023',screen:'12.4-inch',identifier:'SM-X610 / SM-X616',galaxy:'Tab S9 FE Plus 12.4"',standOk:true},
    {id:'galaxy-s9',label:'Galaxy Tab S9 · 11-inch · 2023',screen:'11-inch',identifier:'SM-X710 / SM-X716',galaxy:'S9 11 S9 FE 10.9"',standOk:true},
    {id:'galaxy-s9-fe',label:'Galaxy Tab S9 FE · 10.9-inch · 2023',screen:'10.9-inch',identifier:'SM-X510 / SM-X516',galaxy:'S9 11 S9 FE 10.9"',standOk:true},
    {id:'galaxy-s8-ultra',label:'Galaxy Tab S8 Ultra · 14.6-inch · 2022',screen:'14.6-inch',identifier:'SM-X900 / SM-X906',galaxy:'S8 Ultra 14.6"'},
    {id:'galaxy-s8-plus',label:'Galaxy Tab S8+ · 12.4-inch · 2022',screen:'12.4-inch',identifier:'SM-X800 / SM-X806',galaxy:'Tab S8 Plus 12.4"',standOk:true},
    {id:'galaxy-s8',label:'Galaxy Tab S8 · 11-inch · 2022',screen:'11-inch',identifier:'SM-X700 / SM-X706',galaxy:'Tab S7 11 S8 11"',standOk:true},
    {id:'galaxy-s7',label:'Galaxy Tab S7 · 11-inch · 2020',screen:'11-inch',identifier:'SM-T870 / SM-T875 / SM-T878',galaxy:'Tab S7 11 S8 11"',standOk:true},
    {id:'galaxy-s7-plus',label:'Galaxy Tab S7+ · 12.4-inch · 2020',screen:'12.4-inch',identifier:'SM-T970 / SM-T975 / SM-T976',galaxy:'Tab S7 Plus 12.4"',standOk:true},
    {id:'galaxy-s7-fe',label:'Galaxy Tab S7 FE · 12.4-inch · 2021',screen:'12.4-inch',identifier:'SM-T730 / SM-T733 / SM-T735 / SM-T736',galaxy:'Tab S7 FE 12.4"',standOk:true}
  ].map(device => ({...device,family:'galaxy',match:'RhinoGuard Tactical 360 · '+device.galaxy}));
  const surfaceDevices = [
    {id:'surface-pro-12-2025',label:'Surface Pro · 12-inch · 2025',screen:'12-inch',identifier:'Surface app: Surface Pro, 12-inch',surface:'Surface Pro 12'},
    {id:'surface-pro-11',label:'Surface Pro · 11th Edition · 13-inch · 2024',screen:'13-inch',identifier:'Surface app: Surface Pro (11th Edition)',surface:'Surface Pro 9 10 11'},
    {id:'surface-pro-10',label:'Surface Pro 10 for Business · 13-inch · 2024',screen:'13-inch',identifier:'Surface app: Surface Pro 10 for Business',surface:'Surface Pro 9 10 11'},
    {id:'surface-pro-9',label:'Surface Pro 9 · 13-inch · 2022',screen:'13-inch',identifier:'Surface app: Surface Pro 9',surface:'Surface Pro 9 10 11'},
    {id:'surface-pro-8',label:'Surface Pro 8 · 13-inch · 2021',screen:'13-inch',identifier:'Surface app: Surface Pro 8',surface:'Surface Pro 8'},
    {id:'surface-pro-7',label:'Surface Pro 7 · 12.3-inch · 2019',screen:'12.3-inch',identifier:'Surface app: Surface Pro 7',surface:'Surface Pro 7'},
    {id:'surface-pro-6',label:'Surface Pro 6 · 12.3-inch · 2018',screen:'12.3-inch',identifier:'Surface app: Surface Pro 6',surface:'Surface Pro 4 5 6'},
    {id:'surface-pro-5',label:'Surface Pro · 5th Gen · 12.3-inch · 2017',screen:'12.3-inch',identifier:'Surface app: Surface Pro (5th Gen)',surface:'Surface Pro 4 5 6'},
    {id:'surface-pro-4',label:'Surface Pro 4 · 12.3-inch · 2015',screen:'12.3-inch',identifier:'Surface app: Surface Pro 4',surface:'Surface Pro 4 5 6'},
    {id:'surface-go-4',label:'Surface Go 4 for Business · 10.5-inch · 2023',screen:'10.5-inch',identifier:'Surface app: Surface Go 4',surface:'Surface Go 1 2 3 4'},
    {id:'surface-go-3',label:'Surface Go 3 · 10.5-inch · 2021',screen:'10.5-inch',identifier:'Surface app: Surface Go 3',surface:'Surface Go 1 2 3 4'},
    {id:'surface-go-2',label:'Surface Go 2 · 10.5-inch · 2020',screen:'10.5-inch',identifier:'Surface app: Surface Go 2',surface:'Surface Go 1 2 3 4'},
    {id:'surface-go-1',label:'Surface Go · 1st Gen · 10-inch · 2018',screen:'10-inch',identifier:'Surface app: Surface Go',surface:'Surface Go 1 2 3 4'}
  ].map(device => ({...device,family:'surface',match:'RhinoGuard Apex Shield · '+device.surface,standOk:true}));
  const devicesByFamily = {ipad:ipadDevices,galaxy:galaxyDevices,surface:surfaceDevices};
  const devices = [...ipadDevices,...galaxyDevices,...surfaceDevices];
  const caseMeta = {
    pro:{label:'RhinoGuard Pro',summary:'Maximum protection with hand and shoulder carry for demanding environments.',optionLabel:copy.caseOption},
    armor:{label:'RhinoGuard ArmorPro',summary:'Streamlined daily protection with an integrated kickstand and hand strap.',optionLabel:copy.caseOption},
    galaxy:{label:'RhinoGuard Tactical 360 Pro',summary:'Rugged Galaxy Tab protection with model-specific fit, hand control, stand support, and shoulder carry.',optionLabel:copy.caseOption},
    surface:{label:'RhinoGuard Apex Shield',summary:'Exact-generation Surface protection with your choice of strap or no-strap configuration.',optionLabel:copy.configuration}
  };
  const accessoryCopy = {
    privacy:'Limits side-angle screen visibility for supported iPad models.',
    keyboard:'A slim wireless keyboard for writing, study, and mobile work.',
    charging:'A multi-device charging station that keeps an iPad workspace organized.',
    stylus:'A universal precision stylus for compatible capacitive tablet displays.',
    stand:'An adjustable tablet stand for supported devices up to 13 inches.'
  };
  const orgEnvironments = new Set(['school','field','healthcare','warehouse']);
  const state = {step:1,maxStep:1,family:'ipad',device:null,environment:'',priorities:new Set(),quantity:1,caseChoice:'pro',caseColor:'',accessories:new Set(),accessoryVariants:{}};
  const panels = [...root.querySelectorAll('[data-avss-panel]')];
  const jumpButtons = [...root.querySelectorAll('[data-avss-jump]')];
  const deviceSelect = root.querySelector('[data-avss-device]');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:root.dataset.currency || 'USD'}).format(Number(cents || 0)/100);
  const clean = value => String(value || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  const track = (name, detail={}) => {
    window.AvonticAnalytics?.track?.(name, detail);
    document.dispatchEvent(new CustomEvent('avontic:setup-studio',{detail:{event:name,...detail}}));
  };

  const params = new URLSearchParams(window.location.search);
  const requestedDevice = params.get('verified_device') || params.get('verifiedDevice') || params.get('device');
  const requestedFamily = params.get('family');
  const requestedCase = params.get('case');
  const requestedAccessory = params.get('accessory');
  if (['ipad','galaxy','surface'].includes(requestedFamily)) state.family = requestedFamily;
  if (['armor','pro','galaxy','surface'].includes(requestedCase)) state.caseChoice = requestedCase;
  if (['privacy','keyboard','charging','stylus','stand'].includes(requestedAccessory)) state.accessories.add(requestedAccessory);

  try {
    const saved = JSON.parse(localStorage.getItem('avontic-complete-setup-studio-v2') || localStorage.getItem('avontic-complete-setup-studio-v1') || 'null');
    if (saved?.device && devices.some(item => item.id === saved.device)) {
      state.device = devices.find(item => item.id === saved.device);
      state.family = state.device.family;
      state.environment = saved.environment || '';
      state.priorities = new Set(saved.priorities || []);
      state.quantity = Number(saved.quantity || 1);
      state.caseChoice = ['armor','pro','galaxy','surface'].includes(saved.caseChoice) ? saved.caseChoice : state.caseChoice;
      state.accessories = new Set([...(saved.accessories || []),...state.accessories]);
    }
  } catch (_) {}
  if (requestedFamily && ['ipad','galaxy','surface'].includes(requestedFamily)) {
    state.family = requestedFamily;
    if (state.device?.family !== state.family) state.device = null;
  }
  if (requestedDevice && devices.some(item => item.id === requestedDevice)) {
    state.device = devices.find(item => item.id === requestedDevice);
    state.family = state.device.family;
  }
  if (state.family !== 'ipad') state.caseChoice = state.family;
  if (state.family === 'ipad' && ['pro','armor'].includes(requestedCase)) state.caseChoice = requestedCase;

  const persist = () => {
    try { localStorage.setItem('avontic-complete-setup-studio-v2',JSON.stringify({family:state.family,device:state.device?.id,environment:state.environment,priorities:[...state.priorities],quantity:state.quantity,caseChoice:state.caseChoice,accessories:[...state.accessories]})); } catch (_) {}
  };
  const compatibleVariants = (key, model) => (products[key]?.variants || []).filter(v => v.available && [v.option1,v.option2,v.option3,v.title].includes(model));
  const selectedCaseVariant = () => {
    if (!state.device) return null;
    const model = state.device[state.caseChoice];
    const matches = compatibleVariants(state.caseChoice,model);
    return matches.find(v => v.option1 === state.caseColor) || matches[0] || null;
  };
  const accessoryVariant = key => {
    if (key === 'privacy') return compatibleVariants(key,state.device?.privacy)[0] || null;
    const requestedId = Number(state.accessoryVariants[key]);
    return products[key]?.variants.find(v => v.id === requestedId && v.available) || products[key]?.variants.find(v => v.available) || null;
  };
  const availableAccessoryKeys = () => {
    const keys = state.family === 'ipad' ? ['privacy','keyboard','stylus','stand','charging'] : ['keyboard','stylus','stand'];
    return keys.filter(key => key !== 'stand' || state.device?.standOk);
  };
  const recommend = () => {
    if (state.family === 'galaxy' || state.family === 'surface') {
      state.caseChoice = state.family;
    } else {
    let pro = 0, armor = 0;
    if (['school','field','healthcare','warehouse','travel'].includes(state.environment)) pro += 2;
    if (['office','home'].includes(state.environment)) armor += 2;
    if (state.environment === 'everyday') { pro += 1; armor += 1; }
    if (state.priorities.has('maximum')) pro += 3;
    if (state.priorities.has('shoulder')) pro += 4;
    if (state.priorities.has('streamlined')) armor += 4;
    if (state.priorities.has('handheld')) { pro += 1; armor += 1; }
    if (state.priorities.has('stand')) { pro += 1; armor += 1; }
    let choice = armor > pro ? 'armor' : 'pro';
    if (!state.device?.[choice]) choice = choice === 'pro' ? 'armor' : 'pro';
    if (!state.device?.[choice]) choice = state.device?.pro ? 'pro' : 'armor';
    state.caseChoice = choice;
    }
    const defaults = [];
    if (state.priorities.has('privacy') && state.device?.privacy) defaults.push('privacy');
    if (state.priorities.has('keyboard') || ['office','school'].includes(state.environment)) defaults.push('keyboard');
    if (state.family === 'ipad' && state.priorities.has('charging')) defaults.push('charging');
    defaults.forEach(key => state.accessories.add(key));
  };
  const businessUrl = () => {
    const q = new URLSearchParams({source:'complete-setup-studio',family:state.family,device:state.device?.id || '',product:state.caseChoice,variant:String(selectedCaseVariant()?.id || ''),quantity:String(state.quantity),use_case:state.environment});
    return '/pages/business-solutions?' + q.toString() + '#avb-quote';
  };
  const validateCurrent = () => {
    const panel = root.querySelector('[data-avss-panel="' + state.step + '"]');
    const next = panel?.querySelector('[data-avss-next]');
    if (!next) return;
    if (state.step === 1) next.disabled = !state.device;
    if (state.step === 2) next.disabled = !state.environment;
    if (state.step === 4) next.disabled = !selectedCaseVariant();
  };
  const showStep = step => {
    state.step = Math.max(1,Math.min(6,step));
    state.maxStep = Math.max(state.maxStep,state.step);
    panels.forEach(panel => panel.hidden = Number(panel.dataset.avssPanel) !== state.step);
    jumpButtons.forEach(button => {
      const number = Number(button.dataset.avssJump);
      button.disabled = number > state.maxStep;
      if (number === state.step) button.setAttribute('aria-current','step'); else button.removeAttribute('aria-current');
    });
    root.querySelector('[data-avss-progress]').style.setProperty('--progress',(state.step/6*100)+'%');
    if (state.step === 4) renderCase();
    if (state.step === 5) renderAccessories();
    if (state.step === 6) renderReview();
    validateCurrent();
    persist();
    if (state.step > 1) root.querySelector('[data-avss-panel="' + state.step + '"] h3')?.focus?.({preventScroll:true});
  };
  const chooseDevice = device => {
    state.device = device || null;
    state.caseColor = '';
    renderDevice();
    persist();
    if (state.device) track('device_selected',{family:state.family,device:state.device.id});
  };
  const renderFamily = () => {
    const familyCopy = copy.families[state.family];
    const familyDevices = devicesByFamily[state.family];
    root.querySelectorAll('[data-avss-family]').forEach(button => button.classList.toggle('is-active',button.dataset.avssFamily === state.family));
    root.querySelector('[data-avss-device-label]').textContent = familyCopy.label;
    root.querySelector('[data-avss-help-title]').textContent = familyCopy.helpTitle;
    root.querySelector('[data-avss-help-copy]').textContent = familyCopy.helpCopy;
    root.querySelector('[data-avss-help-cta]').textContent = familyCopy.helpCta;
    root.querySelector('[data-avss-help-link]').href = familyCopy.helpUrl;
    root.querySelector('[data-avss-table-title]').textContent = familyCopy.tableTitle;
    root.querySelector('[data-avss-ipad-priority]').hidden = state.family !== 'ipad';
    if (state.family !== 'ipad') {
      state.priorities.delete('privacy');
      state.accessories.delete('privacy');
      state.accessories.delete('charging');
    }
    deviceSelect.replaceChildren();
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = copy.placeholder;
    deviceSelect.append(placeholder);
    familyDevices.forEach(device => {
      const option = document.createElement('option');
      option.value = device.id;
      option.textContent = device.label;
      deviceSelect.append(option);
    });
    const table = root.querySelector('[data-avss-device-table]');
    table.innerHTML = familyDevices.map(device => '<tr data-avss-device-row="'+clean(device.id)+'"><td><button type="button" data-avss-table-device="'+clean(device.id)+'">'+clean(device.label)+'</button></td><td>'+clean(device.screen)+'</td><td><code>'+clean(device.identifier)+'</code></td><td>'+clean(device.match)+'</td></tr>').join('');
    table.querySelectorAll('[data-avss-table-device]').forEach(button => button.addEventListener('click',() => {
      chooseDevice(familyDevices.find(device => device.id === button.dataset.avssTableDevice) || null);
    }));
    renderDevice();
  };
  const renderDevice = () => {
    deviceSelect.value = state.device?.id || '';
    const box = root.querySelector('[data-avss-device-selection]');
    if (state.device) {
      box.hidden = false;
      box.innerHTML = '<strong>' + clean(state.device.label) + '</strong><small>' + clean(copy.verified) + ' · ' + clean(state.device.screen) + ' ' + clean(copy.display) + ' · ' + clean(state.device.identifier) + '</small>';
    } else box.hidden = true;
    root.querySelectorAll('[data-avss-device-row]').forEach(row => row.classList.toggle('is-selected',row.dataset.avssDeviceRow === state.device?.id));
    validateCurrent();
  };
  const renderCase = () => {
    const target = root.querySelector('[data-avss-case-card]');
    const model = state.device?.[state.caseChoice];
    let variants = compatibleVariants(state.caseChoice,model);
    if (!variants.length) {
      if (state.family === 'ipad') {
        const alternate = state.caseChoice === 'pro' ? 'armor' : 'pro';
        if (compatibleVariants(alternate,state.device?.[alternate]).length) { state.caseChoice = alternate; return renderCase(); }
      }
      target.innerHTML = '<div class="avss__unavailable">' + clean(copy.unavailable) + '</div>';
      validateCurrent();
      track('no_match_encountered',{device:state.device?.id});
      return;
    }
    const colors = [...new Set(variants.map(v => v.option1))];
    if (!colors.includes(state.caseColor)) state.caseColor = colors[0];
    const variant = selectedCaseVariant();
    const product = products[state.caseChoice];
    const meta = caseMeta[state.caseChoice];
    const alternateButton = state.family === 'ipad' ? '<button type="button" class="avss__alternate" data-avss-alternate>Compare with ' + (state.caseChoice === 'pro' ? 'ArmorPro' : 'RhinoGuard Pro') + '</button>' : '';
    target.innerHTML = '<article class="avss__case-card"><a class="avss__case-media" href="' + clean(product.url) + '" target="_blank" rel="noopener" aria-label="View details for ' + clean(meta.label) + ' (opens in a new tab)"><img src="' + clean(product.image) + '" alt="' + clean(meta.label) + '" width="600" height="600"></a><div class="avss__case-copy"><p class="avss__eyebrow"><span></span>'+clean(copy.recommended)+'</p><h4><a class="avss__product-title-link" href="' + clean(product.url) + '" target="_blank" rel="noopener" aria-label="' + clean(meta.label) + ' (opens in a new tab)">' + clean(meta.label) + '</a></h4><p>' + clean(meta.summary) + '</p><div class="avss__case-proof"><span>'+clean(copy.exact)+'</span><span>'+clean(copy.stock)+'</span><span>'+clean(copy.live)+'</span></div><label class="avss__field"><span>'+clean(meta.optionLabel)+'</span><select data-avss-case-color>' + colors.map(color => '<option value="' + clean(color) + '"' + (color === state.caseColor ? ' selected' : '') + '>' + clean(color) + '</option>').join('') + '</select></label><div class="avss__case-price"><span><small>'+clean(copy.variant)+'</small><strong>' + money(variant?.price) + '</strong></span><a href="' + clean(product.url) + '" target="_blank" rel="noopener" aria-label="'+clean(copy.view)+' ' + clean(meta.label) + ' (opens in a new tab)">'+clean(copy.view)+' ↗</a></div>'+alternateButton+'</div></article>';
    target.querySelector('[data-avss-case-color]').addEventListener('change',event => {state.caseColor=event.target.value;renderCase();persist();});
    target.querySelector('[data-avss-alternate]')?.addEventListener('click',() => {const alt=state.caseChoice==='pro'?'armor':'pro';if(state.device?.[alt]){state.caseChoice=alt;state.caseColor='';renderCase();persist();}});
    track('recommendation_viewed',{device:state.device?.id,case:state.caseChoice,variant:variant?.id});
    validateCurrent();
  };
  const renderAccessories = () => {
    const target = root.querySelector('[data-avss-accessories]');
    [...state.accessories].filter(key => !availableAccessoryKeys().includes(key)).forEach(key => state.accessories.delete(key));
    target.innerHTML = availableAccessoryKeys().map(key => {
      const product = products[key], variant = accessoryVariant(key), unavailable = !variant;
      const options = key === 'privacy' ? '' : (product.variants || []).filter(v=>v.available).map(v=>'<option value="'+v.id+'"'+(variant?.id===v.id?' selected':'')+'>'+clean(v.title)+' · '+money(v.price)+'</option>').join('');
      const selected = state.accessories.has(key) && !unavailable;
      if (unavailable) state.accessories.delete(key);
      return '<article class="avss__accessory'+(selected?' is-selected':'')+'" data-accessory="'+key+'"><a class="avss__accessory-media" href="'+clean(product.url)+'" target="_blank" rel="noopener" aria-label="View details for '+clean(product.title)+' (opens in a new tab)"><img src="'+clean(product.image)+'" alt="'+clean(product.title)+'" width="100" height="100"></a><div><h4><a class="avss__product-title-link" href="'+clean(product.url)+'" target="_blank" rel="noopener" aria-label="'+clean(product.title)+' (opens in a new tab)">'+clean(product.title)+'</a></h4><p>'+(unavailable?'No verified option is currently available for this device.':accessoryCopy[key])+'</p><a href="'+clean(product.url)+'" target="_blank" rel="noopener" aria-label="View product '+clean(product.title)+' (opens in a new tab)">View product ↗</a>'+(options?'<label class="avss__field"><span>Option</span><select data-avss-accessory-variant="'+key+'">'+options+'</select></label>':'')+'</div><button class="avss__toggle" type="button" data-avss-toggle="'+key+'" '+(unavailable?'disabled':'')+'>'+(selected?'Included':'Add to setup')+'</button></article>';
    }).join('');
    target.querySelectorAll('[data-avss-toggle]').forEach(button => button.addEventListener('click',() => {
      const key=button.dataset.avssToggle;
      if(state.accessories.has(key))state.accessories.delete(key);else state.accessories.add(key);
      track('accessory_selected',{accessory:key,selected:state.accessories.has(key),device:state.device?.id});
      renderAccessories();persist();
    }));
    target.querySelectorAll('[data-avss-accessory-variant]').forEach(select => {
      state.accessoryVariants[select.dataset.avssAccessoryVariant]=Number(select.value);
      select.addEventListener('change',()=>{state.accessoryVariants[select.dataset.avssAccessoryVariant]=Number(select.value);persist();});
    });
  };
  const chosenLines = () => {
    const lines = [];
    const caseVariant = selectedCaseVariant();
    if (caseVariant) lines.push({key:state.caseChoice,title:products[state.caseChoice].title,image:products[state.caseChoice].image,variant:caseVariant});
    [...state.accessories].filter(key => availableAccessoryKeys().includes(key)).forEach(key => {const variant=accessoryVariant(key);if(variant)lines.push({key,title:products[key].title,image:products[key].image,variant});});
    return lines;
  };
  const renderReview = () => {
    const lines=chosenLines(), total=lines.reduce((sum,line)=>sum+Number(line.variant.price||0)*state.quantity,0);
    root.querySelector('[data-avss-review]').innerHTML=lines.map(line=>'<div class="avss__review-line"><img src="'+clean(line.image)+'" alt="" width="64" height="64"><span><strong>'+clean(line.title)+'</strong><small>'+clean(line.variant.title)+' · Qty '+state.quantity+'</small></span><b>'+money(Number(line.variant.price)*state.quantity)+'</b></div>').join('')+'<div class="avss__review-total"><span>Estimated setup total</span><strong>'+money(total)+'</strong></div>';
    const business=orgEnvironments.has(state.environment)||state.quantity>=10;
    root.querySelector('[data-avss-business]').hidden=!business;
    root.querySelector('[data-avss-business-link]').href=businessUrl();
    const add=root.querySelector('[data-avss-add]');
    add.disabled=!lines.length;
    add.textContent='Add complete setup · '+money(total);
  };

  deviceSelect.addEventListener('change',() => {
    chooseDevice(devicesByFamily[state.family].find(item=>item.id===deviceSelect.value)||null);
  });
  root.querySelectorAll('[data-avss-family]').forEach(button=>button.addEventListener('click',()=>{
    const family=button.dataset.avssFamily;
    if(state.family===family)return;
    state.family=family;
    state.device=null;
    state.caseChoice=family==='ipad'?'pro':family;
    state.caseColor='';
    renderFamily();persist();track('device_family_selected',{family});
  }));
  root.querySelectorAll('[data-avss-environments] button').forEach(button=>button.addEventListener('click',()=>{
    state.environment=button.dataset.value;
    root.querySelectorAll('[data-avss-environments] button').forEach(item=>item.classList.toggle('is-selected',item===button));
    validateCurrent();persist();track('use_case_selected',{use_case:state.environment});
  }));
  root.querySelectorAll('[data-avss-priorities] input').forEach(input=>input.addEventListener('change',()=>{
    if(input.checked)state.priorities.add(input.value);else state.priorities.delete(input.value);
    persist();
  }));
  root.querySelector('[data-avss-quantity]').addEventListener('change',event=>{state.quantity=Number(event.target.value);persist();});
  root.querySelectorAll('[data-avss-next]').forEach(button=>button.addEventListener('click',()=>{if(state.step===3)recommend();showStep(state.step+1);}));
  root.querySelectorAll('[data-avss-back]').forEach(button=>button.addEventListener('click',()=>showStep(state.step-1)));
  jumpButtons.forEach(button=>button.addEventListener('click',()=>{if(!button.disabled)showStep(Number(button.dataset.avssJump));}));
  root.querySelector('[data-avss-add]').addEventListener('click',async event=>{
    const button=event.currentTarget,status=root.querySelector('[data-avss-status]'),lines=chosenLines();
    if(!lines.length)return;
    button.disabled=true;status.textContent=root.dataset.adding;
    try{
      const shopRoot=window.Shopify?.routes?.root||'/';
      const sectionsToBundle=[];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:sectionsToBundle}}));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start',{bubbles:true}));
      const response=await fetch(shopRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({
        items:lines.map(line=>({id:line.variant.id,quantity:state.quantity,properties:{'_Setup':'Complete Setup Studio','Device':state.device.label}})),
        sections:sectionsToBundle.join(','),
        sections_url:window.location.pathname
      })});
      if(!response.ok)throw new Error((await response.json()).description||'Cart request failed');
      const result=await response.json();
      const cartResponse=await fetch(shopRoot+'cart.js',{headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}});
      if(!cartResponse.ok)throw new Error('Cart refresh failed');
      const cart=await cartResponse.json();
      cart.sections=result.sections||{};
      document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open',cart}}));
      document.dispatchEvent(new CustomEvent('avontic:cart-updated',{detail:{source:'complete-setup-studio',result,cart,item_count:cart.item_count,sections:cart.sections}}));
      track('setup_added_to_cart',{device:state.device.id,case:state.caseChoice,quantity:state.quantity,items:lines.length});
      status.innerHTML=clean(root.dataset.success)+' <a href="/cart">View cart →</a>';
    }catch(error){
      status.textContent=root.dataset.error+' '+String(error.message||'');
    }finally{document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end',{bubbles:true}));button.disabled=false;}
  });
  root.querySelector('[data-avss-business-link]').addEventListener('click',()=>track('business_quote_selected',{device:state.device?.id,case:state.caseChoice,quantity:state.quantity,use_case:state.environment}));

  renderFamily();
  root.querySelectorAll('[data-avss-priorities] input').forEach(input=>input.checked=state.priorities.has(input.value));
  root.querySelectorAll('[data-avss-environments] button').forEach(button=>button.classList.toggle('is-selected',button.dataset.value===state.environment));
  root.querySelector('[data-avss-quantity]').value=String(state.quantity);
  if(requestedDevice && state.device){state.maxStep=1;renderDevice();}
  showStep(1);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-decision-tools"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-avdt-root]').forEach((root) => {
        if (root.dataset.avdtReady === 'true') return;
        root.dataset.avdtReady = 'true';

        const sync = (state) => {
          const active = state?.active || window.AvonticDeviceProfile?.getActive?.();
          const label = root.querySelector('[data-avontic-profile-label]');
          if (!label) return;
          if (active?.label) {
            label.textContent = (label.dataset.profileUsing || 'Using __DEVICE__').replace('__DEVICE__', active.label);
            label.dataset.hasDevice = 'true';
          } else {
            label.textContent = label.dataset.profileEmpty || 'No device selected — identify an exact model to begin.';
            label.dataset.hasDevice = 'false';
          }
        };

        sync(window.AvonticDeviceProfile?.get?.());
        document.addEventListener('avontic:device-profile:ready', (event) => sync(event.detail?.state));
        document.addEventListener('avontic:device-profile:change', (event) => sync(event.detail?.state));

        root.addEventListener('click', (event) => {
          const link = event.target.closest('[data-avdt-action]');
          if (!link || !window.AvonticAnalytics?.track) return;
          const active = window.AvonticDeviceProfile?.getActive?.();
          window.AvonticAnalytics.track('guided_route_selected', {
            component: 'guided_shopping_router',
            action: link.dataset.avdtAction || '',
            destination: link.getAttribute('href') || '',
            compatibility_key: active?.key || '',
            compatibility_state: active?.key ? 'known' : 'unknown'
          });
        });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-formalift-universe"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('formalift-universe')) {
  class FormaLiftUniverse extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-filter]');
        if (!button || !this.contains(button)) return;
        const filter = button.dataset.filter;
        let count = 0;
        this.querySelectorAll('[data-filter]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-design-card]').forEach((card) => {
          const visible = filter === 'all' || card.dataset.groups.split(' ').includes(filter);
          card.hidden = !visible;
          if (visible) count += 1;
        });
        const status = this.querySelector('[data-result-count]');
        if (status) status.textContent = this.dataset.countTemplate.replace('__COUNT__', String(count));
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  }
  customElements.define('formalift-universe', FormaLiftUniverse);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-iphone-launch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('avontic-iphone-launch')) {
  customElements.define('avontic-iphone-launch', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.strings = JSON.parse(this.querySelector('[data-ail-strings]').textContent);
      this.cards = Array.from(this.querySelectorAll('[data-ail-card]')).map((node, order) => ({node, order, data: JSON.parse(node.querySelector('[data-ail-product]').textContent)}));
      this.grid = this.querySelector('[data-ail-grid]');
      this.model = 'all'; this.selectedStyle = 'all'; this.sort = 'featured';
      this.querySelector('[data-ail-controls]').hidden = false;
      this.addEventListener('click', event => {
        const model = event.target.closest('[data-ail-model], [data-ail-filter-model]');
        if (model) { event.preventDefault(); this.model = model.dataset.ailModel || model.dataset.ailFilterModel; this.selectedStyle = 'all'; this.querySelector('[data-ail-style]').value = 'all'; this.update(true); if (model.hasAttribute('data-ail-model')) this.scrollToShop(); }
        const style = event.target.closest('[data-ail-style-jump]');
        if (style) { event.preventDefault(); this.selectedStyle = style.dataset.ailStyleJump; this.model = 'all'; this.querySelector('[data-ail-style]').value = this.selectedStyle; this.update(true); this.scrollToShop(); }
        const reset = event.target.closest('[data-ail-reset]');
        if (reset) { this.model = 'all'; this.selectedStyle = 'all'; this.querySelector('[data-ail-style]').value = 'all'; this.update(true); }
        const swatch = event.target.closest('[data-ail-color]');
        if (swatch) { const card = this.cards.find(c => c.node === swatch.closest('[data-ail-card]')); card.color = swatch.dataset.ailColor; card.colorChosen = true; this.renderCard(card); }
      });
      this.querySelector('[data-ail-style]').addEventListener('change', event => { this.selectedStyle = event.target.value; this.update(true); });
      this.querySelector('[data-ail-sort]').addEventListener('change', event => { this.sort = event.target.value; this.update(true); });
      this.onPop = () => this.readUrl(); window.addEventListener('popstate', this.onPop);
      this.readUrl();
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPop); }
    slug(model) { return model.toLowerCase().replaceAll(' ', '-'); }
    readUrl() {
      const params = new URL(location.href).searchParams;
      const known = ['iPhone 18','iPhone 18 Pro','iPhone 18 Pro Max','iPhone Duo'];
      this.model = known.find(m => this.slug(m) === params.get('model')) || 'all';
      const styles = ['cases','magnetic','stand','wallet','metal','minimal','privacy']; this.selectedStyle = styles.includes(params.get('style')) ? params.get('style') : 'all';
      this.sort = ['price-asc','price-desc'].includes(params.get('order')) ? params.get('order') : 'featured';
      this.querySelector('[data-ail-style]').value = this.selectedStyle; this.querySelector('[data-ail-sort]').value = this.sort; this.update(false);
    }
    scrollToShop() { this.querySelector('#ail-shop').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'}); }
    matching(card) { return card.data.variants.filter(v => v.available && (this.model === 'all' || v.device === this.model)); }
    renderCard(card) {
      const matches = this.matching(card); const chosen = matches.find(v => v.color === card.color) || matches[0] || card.data.variants[0];
      if (!chosen) return;
      card.color = chosen.color;
      card.node.querySelectorAll('[data-ail-product-link]').forEach(link => { const url = new URL(card.data.url,location.origin); if (this.model !== 'all' || card.colorChosen) url.searchParams.set('variant',chosen.id); link.href = url.pathname + url.search; });
      const img = card.node.querySelector('[data-ail-main-image]');
      if (img && chosen.image && img.dataset.current !== chosen.image) { img.src = chosen.image; img.removeAttribute('srcset'); img.dataset.current = chosen.image; img.alt = card.data.title + (chosen.color ? ' — ' + chosen.color : ''); }
      card.node.querySelector('[data-ail-price]').textContent = chosen.price;
      card.node.querySelector('[data-ail-selected-color]').textContent = chosen.selectionLabel || chosen.color || '';
      card.node.querySelector('[data-ail-fit]').textContent = this.model === 'all' ? card.data.devices.join(' · ') : this.strings.forModel + ' ' + this.model;
      card.node.querySelectorAll('[data-ail-color]').forEach(button => { button.hidden = !matches.some(v => v.color === button.dataset.ailColor); button.setAttribute('aria-pressed',String(button.dataset.ailColor === chosen.color)); });
    }
    update(writeUrl) {
      let count = 0;
      this.cards.forEach(card => { const visible = this.matching(card).length > 0 && (this.selectedStyle === 'all' || card.data.styles.includes(this.selectedStyle)); card.node.hidden = !visible; if (visible) count++; this.renderCard(card); });
      const ordered = [...this.cards].sort((a,b) => this.sort === 'featured' ? a.order-b.order : this.sort === 'price-asc' ? a.data.price-b.data.price : b.data.price-a.data.price);
      ordered.forEach(card => this.grid.append(card.node));
      this.querySelector('[data-ail-count]').textContent = this.strings.count.replace('[count]',String(count)) + (this.model === 'all' ? '' : ' · ' + this.model);
      this.querySelector('[data-ail-empty]').hidden = count !== 0;
      this.querySelectorAll('[data-ail-reset]').forEach(button => button.hidden = this.model === 'all' && this.selectedStyle === 'all');
      this.querySelectorAll('[data-ail-filter-model]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.ailFilterModel === this.model)));
      this.querySelectorAll('.ail-model[data-ail-model]').forEach(link => { const matches = this.cards.filter(card => card.data.variants.some(v => v.available && v.device === link.dataset.ailModel)).length; link.querySelector('[data-ail-model-count]').textContent = this.strings.count.replace('[count]',String(matches)); if (link.dataset.ailModel === this.model) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); });
      if (writeUrl) { const url = new URL(location.href); if (this.model === 'all') url.searchParams.delete('model'); else url.searchParams.set('model',this.slug(this.model)); if (this.selectedStyle === 'all') url.searchParams.delete('style'); else url.searchParams.set('style',this.selectedStyle); if (this.sort === 'featured') url.searchParams.delete('order'); else url.searchParams.set('order',this.sort); history.pushState({},'',url); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-loadout-studio"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-avls]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const products = JSON.parse(root.querySelector('[data-avls-products]').textContent);
  const copy = JSON.parse(root.querySelector('[data-avls-copy]').textContent);
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:root.dataset.currency || 'USD'}).format(Number(cents || 0)/100);
  const clean = value => String(value == null ? '' : value).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  const ipad = [
    {id:'air-13-2024-26',brand:'iPad Air',label:'iPad Air 13-inch · M2 / M3 / M4 · 2024–2026',fit:{ipadPro:'iPad Air 13 (2024 M2 / 2025 M3 / 2026 M4)',ipadArmor:'iPad Air 13 (2024 M2 / 2025 M3 / 2026 M4)'},stand:true},
    {id:'air-11-2024-26',brand:'iPad Air',label:'iPad Air 11-inch · M2 / M3 / M4 · 2024–2026',fit:{ipadPro:'iPad Air 11 (2024 M2 / 2025 M3 / 2026 M4)',ipadArmor:'iPad Air 11 (2024 M2 / 2025 M3 / 2026 M4)'},stand:true},
    {id:'ipad-a16-2025',brand:'iPad',label:'iPad 11-inch · A16 / 11th Gen · 2025',fit:{ipadPro:'iPad 11-inch A16 / 11th Gen (2025)',ipadArmor:'iPad A16 11th Generation 2025',privacy:'A16 2025'},stand:true},
    {id:'pro-13-2024-25',brand:'iPad Pro',label:'iPad Pro 13-inch · M4 / M5 · 2024–2025',fit:{ipadPro:'iPad Pro 13-inch M4/M5 (2024-2025)',ipadArmor:'iPad Pro 13 2024 2025',privacy:'Pro 13 M4 M5'},stand:true},
    {id:'pro-11-2024-25',brand:'iPad Pro',label:'iPad Pro 11-inch · M4 / M5 · 2024–2025',fit:{ipadPro:'iPad Pro 11-inch M4/M5 (2024-2025)',ipadArmor:'iPad Pro 11 2024 2025',privacy:'Pro 11 M4 M5'},stand:true},
    {id:'mini-6-7',brand:'iPad mini',label:'iPad mini · 6th / 7th Gen',fit:{ipadArmor:'iPad Mini 6 7',privacy:'Mini 6 7'},stand:true},
    {id:'ipad-10-2022',brand:'iPad',label:'iPad 10th Gen · 10.9-inch · 2022',fit:{ipadPro:'iPad 10th Gen 10.9-inch (2022)',ipadArmor:'iPad 10th 10.9 inch',privacy:'10th 10.9'},stand:true},
    {id:'pro-11-2021-22',brand:'iPad Pro',label:'iPad Pro 11-inch · 3rd / 4th Gen · 2021–2022',fit:{ipadPro:'iPad Pro 11-inch 3rd/4th Gen (2021-2022)',ipadArmor:'Pro11 2018-2022'},stand:true},
    {id:'pro-11-2018-20',brand:'iPad Pro',label:'iPad Pro 11-inch · 1st / 2nd Gen · 2018–2020',fit:{ipadPro:'iPad Pro 11-inch 1st/2nd Gen (2018-2020)',ipadArmor:'Pro11 2018-2022'},stand:true},
    {id:'pro-12-9-2021-22',brand:'iPad Pro',label:'iPad Pro 12.9-inch · 5th / 6th Gen · 2021–2022',fit:{ipadPro:'iPad Pro 12.9-inch 5th/6th Gen (2021-2022)',privacy:'Pro 12.9'},stand:true},
    {id:'pro-12-9-2018-20',brand:'iPad Pro',label:'iPad Pro 12.9-inch · 3rd / 4th Gen · 2018–2020',fit:{ipadPro:'iPad Pro 12.9-inch 3rd/4th Gen (2018-2020)',privacy:'Pro 12.9'},stand:true},
    {id:'ipad-10-2-7-9',brand:'iPad',label:'iPad 10.2-inch · 7th / 8th / 9th Gen',fit:{ipadPro:'iPad 10.2-inch 7th/8th/9th Gen',ipadArmor:'iPad 10.2 7th 8th 9th',privacy:'7th 8th 9th 10.2'},stand:true},
    {id:'air-5',brand:'iPad Air',label:'iPad Air 5th Gen · 10.9-inch',fit:{ipadPro:'iPad Air 5th Gen 10.9-inch',ipadArmor:'iPad Air 4th 5th',privacy:'Pro 11 Air 4 5'},stand:true},
    {id:'air-4',brand:'iPad Air',label:'iPad Air 4th Gen · 10.9-inch',fit:{ipadPro:'iPad Air 4th Gen 10.9-inch',ipadArmor:'iPad Air 4th 5th',privacy:'Pro 11 Air 4 5'},stand:true},
    {id:'ipad-5-6',brand:'iPad',label:'iPad 9.7-inch · 5th / 6th Gen',fit:{ipadPro:'iPad 9.7-inch 5th/6th Gen',ipadArmor:'iPad 5th 6th 9.7'},stand:true},
    {id:'pro-9-7',brand:'iPad Pro',label:'iPad Pro 9.7-inch',fit:{ipadPro:'iPad Pro 9.7-inch',ipadArmor:'iPad Pro 9.7 2016',privacy:'Air 1 2 Pro 9.7'},stand:true},
    {id:'air-3-pro-10-5',brand:'iPad Air',label:'iPad Air 3 / iPad Pro · 10.5-inch',fit:{ipadPro:'iPad Pro 10.5-inch / iPad Air 3 10.5-inch',privacy:'Air 3 Pro 10.5'},stand:true},
    {id:'air-2',brand:'iPad Air',label:'iPad Air 2 · 9.7-inch',fit:{ipadPro:'iPad Air 2',privacy:'Air 1 2 Pro 9.7'},stand:true}
  ].map(d => ({...d,family:'tablet',group:'iPad'}));
  const galaxyTablets = [
    ['galaxy-s11-ultra','Galaxy Tab S11 Ultra · 14.6-inch · 2025','S11 Ultra 14.6"',false],['galaxy-s11','Galaxy Tab S11 · 11-inch · 2025','S11 2025 11"',true],['galaxy-s10-ultra','Galaxy Tab S10 Ultra · 14.6-inch · 2024','S10 Ultra 14.6"',false],['galaxy-s10-plus','Galaxy Tab S10+ · 12.4-inch · 2024','Tab S10 Plus 12.4"',true],['galaxy-s10-fe-plus','Galaxy Tab S10 FE+ · 13.1-inch · 2025','S10 FE Plus 13.1"',false],['galaxy-s10-fe','Galaxy Tab S10 FE · 10.9-inch · 2025','S10 FE 10.9"',true],['galaxy-s10-lite','Galaxy Tab S10 Lite · 10.9-inch · 2025','S10 Lite 10.9"',true],['galaxy-s9-ultra','Galaxy Tab S9 Ultra · 14.6-inch · 2023','S9 Ultra 14.6"',false],['galaxy-s9-plus','Galaxy Tab S9+ · 12.4-inch · 2023','Tab S9 Plus 12.4"',true],['galaxy-s9-fe-plus','Galaxy Tab S9 FE+ · 12.4-inch · 2023','Tab S9 FE Plus 12.4"',true],['galaxy-s9','Galaxy Tab S9 · 11-inch · 2023','S9 11 S9 FE 10.9"',true],['galaxy-s9-fe','Galaxy Tab S9 FE · 10.9-inch · 2023','S9 11 S9 FE 10.9"',true],['galaxy-s8-ultra','Galaxy Tab S8 Ultra · 14.6-inch · 2022','S8 Ultra 14.6"',false],['galaxy-s8-plus','Galaxy Tab S8+ · 12.4-inch · 2022','Tab S8 Plus 12.4"',true],['galaxy-s8','Galaxy Tab S8 · 11-inch · 2022','Tab S7 11 S8 11"',true],['galaxy-s7','Galaxy Tab S7 · 11-inch · 2020','Tab S7 11 S8 11"',true],['galaxy-s7-plus','Galaxy Tab S7+ · 12.4-inch · 2020','Tab S7 Plus 12.4"',true],['galaxy-s7-fe','Galaxy Tab S7 FE · 12.4-inch · 2021','Tab S7 FE 12.4"',true]
  ].map(d=>({id:d[0],brand:'Galaxy Tab',label:d[1],family:'tablet',group:'Galaxy Tab',fit:{galaxyTablet:d[2]},stand:d[3]}));
  const surfaces = [
    ['surface-pro-12-2025','Surface Pro · 12-inch · 2025','Surface Pro 12'],['surface-pro-11','Surface Pro · 11th Edition · 13-inch · 2024','Surface Pro 9 10 11'],['surface-pro-10','Surface Pro 10 for Business · 13-inch · 2024','Surface Pro 9 10 11'],['surface-pro-9','Surface Pro 9 · 13-inch · 2022','Surface Pro 9 10 11'],['surface-pro-8','Surface Pro 8 · 13-inch · 2021','Surface Pro 8'],['surface-pro-7','Surface Pro 7 · 12.3-inch · 2019','Surface Pro 7'],['surface-pro-6','Surface Pro 6 · 12.3-inch · 2018','Surface Pro 4 5 6'],['surface-pro-5','Surface Pro · 5th Gen · 12.3-inch · 2017','Surface Pro 4 5 6'],['surface-pro-4','Surface Pro 4 · 12.3-inch · 2015','Surface Pro 4 5 6'],['surface-go-4','Surface Go 4 for Business · 10.5-inch · 2023','Surface Go 1 2 3 4'],['surface-go-3','Surface Go 3 · 10.5-inch · 2021','Surface Go 1 2 3 4'],['surface-go-2','Surface Go 2 · 10.5-inch · 2020','Surface Go 1 2 3 4'],['surface-go-1','Surface Go · 1st Gen · 10-inch · 2018','Surface Go 1 2 3 4']
  ].map(d=>({id:d[0],brand:'Microsoft Surface',label:d[1],family:'tablet',group:'Microsoft Surface',fit:{surfaceCase:d[2]},stand:true}));
  const phoneValues = {
    'iPhone':['iPhone 17 Pro Max','iPhone 17 Pro','iPhone 17','iPhone Air'],
    'Samsung Galaxy':['Galaxy S26 Ultra','Galaxy S26 Plus','Galaxy S26','Galaxy S25 Ultra','Galaxy S25 Plus','Galaxy S25 Edge','Galaxy S25','Galaxy S24 Ultra','Galaxy S24 Plus','Galaxy S24','Galaxy S23 Ultra','Galaxy S23+','Galaxy S23','Galaxy S22 Ultra 5G','Galaxy S22+ 5G','Galaxy S22 5G','Galaxy S21 Ultra 5G','Galaxy S21+ 5G','Galaxy S21'],
    'Google Pixel':['Google Pixel 10 Pro XL','Google Pixel 10 Pro','Google Pixel 10','Google Pixel 9 Pro XL','Google Pixel 9 Pro','Google Pixel 9'],
    'Motorola':['Motorola Razr Fold']
  };
  const phoneKeys={'iPhone':'iphone','Samsung Galaxy':'samsungPhone','Google Pixel':'pixelPhone','Motorola':'motorolaPhone'};
  const phones=Object.entries(phoneValues).flatMap(([brand,values])=>values.map(value=>({id:(brand+'-'+value).toLowerCase().replace(/[^a-z0-9]+/g,'-'),brand,label:value,family:'phone',group:brand,fit:{[phoneKeys[brand]]:value},caseKey:phoneKeys[brand]})));
  const watches=[
    ['apple-46','Apple Watch','Series 11 & Series 10 · 46mm','appleWatch','Series 11 & Series 10 46MM'],
    ['apple-42','Apple Watch','Series 11 & Series 10 · 42mm','appleWatch','Series 11 & Series 10 42MM'],
    ['apple-ultra-49','Apple Watch','Ultra 3 / Ultra 2 / Ultra 1 · 49mm','appleWatch','Ultra 3 / Ultra 2 / Ultra 1 49MM'],
    ['apple-45','Apple Watch','Series 11 / 10 / 9 / 8 / 7 · 45mm','appleWatch','Series 11 / 10 / 9 / 8 / 7 45MM'],
    ['apple-41','Apple Watch','Series 11 / 10 / 9 / 8 / 7 · 41mm','appleWatch','Series 11 / 10 / 9 / 8 / 7 41MM'],
    ['apple-44','Apple Watch','Series 4 / 5 / 6 / SE · 44mm','appleWatch','Series 4 5 6 SE 44MM'],
    ['apple-40','Apple Watch','Series 4 / 5 / 6 / SE · 40mm','appleWatch','Series 4 5 6 SE 40MM'],
    ['galaxy-ultra-47','Galaxy Watch','Galaxy Watch Ultra · 47mm','galaxyWatchCase','Galaxy Watch 7 Ultra 47mm'],
    ['garmin-fenix-51','Garmin','fēnix 8 · 51mm','garminCase','51mm Large Case'],
    ['garmin-fenix-47','Garmin','fēnix 8 · 47mm','garminCase','47mm Standard Case'],
    ['garmin-fenix-43','Garmin','fēnix 8 · 43mm','garminCase','43mm Small Case'],
    ['garmin-descent-51','Garmin','Descent Mk3i · 51mm','garminCase','Descent Mk3i 51mm'],
    ['pixel-watch-12','Pixel Watch','Google Pixel Watch / Pixel Watch 2','pixelWatch','Pixel Watch & Pixel Watch 2']
  ].map(d=>({id:d[0],brand:d[1],label:d[2],family:'watch',group:d[1],fit:{[d[3]]:d[4]}}));
  const devices=[...phones,...watches,...ipad,...galaxyTablets,...surfaces];
  const familyDevices=family=>devices.filter(d=>d.family===family);
  const finishTerms={
    graphite:['black-black','black apex','dark gray','black orange','black','graphite','gray'],
    silver:['silver-silver','silver apex','silver titan','silver white','silver','titanium','transparent'],
    gold:['rose gold','gold-gold','silver-gold','titanium orange','gold','orange'],
    blue:['dark blue','steel blue','black blue','blue','navy']
  };
  const categories=['phone','watch','tablet'];
  const state={step:1,maxStep:1,active:{phone:true,watch:false,tablet:false},brands:{phone:'',watch:'',tablet:''},devices:{phone:null,watch:null,tablet:null},lifestyle:'',finish:'graphite',quantity:1,included:{},selected:{}};
  const panels=[...root.querySelectorAll('[data-avls-panel]')];
  const jumps=[...root.querySelectorAll('[data-avls-jump]')];
  const productExists=key=>Boolean(products[key]?.title && products[key]?.variants?.length);
  const variantsFor=(key,fit)=>productExists(key)?products[key].variants.filter(v=>v.available && (!fit || [v.option1,v.option2,v.option3,v.title].includes(fit))):[];
  const variantText=v=>[v.option1,v.option2,v.option3].filter(Boolean).join(' / ') || v.title || 'Default';
  const scoreVariant=(v,fit)=>{
    const text=variantText(v).toLowerCase();
    const terms=finishTerms[state.finish]||[];
    let score=0;
    terms.forEach((term,index)=>{if(text.includes(term))score=Math.max(score,terms.length-index+2)});
    if(fit && [v.option1,v.option2,v.option3].includes(fit))score+=1;
    return score;
  };
  const bestVariant=(key,fit)=>variantsFor(key,fit).sort((a,b)=>scoreVariant(b,fit)-scoreVariant(a,fit))[0]||null;
  const itemId=(key,fit,exact)=>exact?key+':'+String(fit||'exact'):key;
  const line=(key,fit,role,note,required=true,exact=true,source='shared')=>({id:itemId(key,fit,exact),key,fit,role,note,required,exact,source,sources:[source],variant:bestVariant(key,fit)});
  const activeFamilies=()=>categories.filter(family=>state.active[family]);
  const selectedDevices=()=>activeFamilies().map(family=>state.devices[family]).filter(Boolean);
  const selectedIds=()=>Object.fromEntries(categories.map(family=>[family,state.active[family]?state.devices[family]?.id||'':'']));
  const selectionValid=()=>activeFamilies().length>0&&activeFamilies().every(family=>Boolean(state.devices[family]));
  const recommendationsForDevice=(d,source)=>{
    if(!d)return[];
    const lines=[];
    if(d.family==='phone'){
      lines.push(line(d.caseKey,d.fit[d.caseKey],copy.rec.phoneRole,copy.rec.phoneNote,true,true,source));
      if(d.group!=='Motorola')lines.push(line('charging',null,copy.rec.chargingRole,copy.rec.chargingPhone,false,false,source));
    }else if(d.family==='watch'){
      if(d.brand==='Apple Watch')lines.push(line('appleWatch',d.fit.appleWatch,copy.rec.appleRole,copy.rec.appleNote,true,true,source));
      if(d.brand==='Galaxy Watch'){
        lines.push(line('galaxyWatchCase',d.fit.galaxyWatchCase,copy.rec.galaxyCaseRole,copy.rec.galaxyCaseNote,true,true,source));
        lines.push(line('galaxyWatchBand','Galaxy Watch Ultra',copy.rec.galaxyBandRole,copy.rec.galaxyBandNote,true,true,source));
      }
      if(d.brand==='Garmin'){
        lines.push(line('garminCase',d.fit.garminCase,copy.rec.garminCaseRole,copy.rec.garminCaseNote,true,true,source));
        if(d.id==='garmin-fenix-51')lines.push(line('garminBand','26mm',copy.rec.galaxyBandRole,copy.rec.garminBand26,false,true,source));
        if(d.id==='garmin-fenix-47')lines.push(line('garminBand','22mm',copy.rec.galaxyBandRole,copy.rec.garminBand22,false,true,source));
      }
      if(d.brand==='Pixel Watch')lines.push(line('pixelWatch',d.fit.pixelWatch,copy.rec.appleRole,copy.rec.pixelNote,true,true,source));
    }else{
      let caseKey=d.group==='Galaxy Tab'?'galaxyTablet':d.group==='Microsoft Surface'?'surfaceCase':(['executive','everyday'].includes(state.lifestyle)?'ipadArmor':'ipadPro');
      if(!d.fit[caseKey])caseKey=d.fit.ipadPro?'ipadPro':d.fit.ipadArmor?'ipadArmor':caseKey;
      lines.push(line(caseKey,d.fit[caseKey],copy.rec.tabletRole,copy.rec.tabletNote,true,true,source));
      if(d.group==='iPad'&&d.fit.privacy)lines.push(line('privacy',d.fit.privacy,copy.rec.privacyRole,copy.rec.privacyNote,false,true,source));
      lines.push(line('keyboard',null,copy.rec.keyboardRole,copy.rec.keyboardNote,false,false,source));
      lines.push(line('stylus',null,copy.rec.stylusRole,copy.rec.stylusNote,false,false,source));
      if(d.stand)lines.push(line('stand',null,copy.rec.standRole,copy.rec.standNote,false,false,source));
      if(d.group==='iPad')lines.push(line('charging',null,copy.rec.ipadChargeRole,copy.rec.ipadChargeNote,false,false,source));
    }
    return lines.filter(item=>item.variant);
  };
  const recommendations=()=>{
    const merged=new Map();
    activeFamilies().forEach(family=>recommendationsForDevice(state.devices[family],family).forEach(item=>{
      const existing=merged.get(item.id);
      if(!existing){merged.set(item.id,item);return}
      existing.sources=[...new Set([...existing.sources,...item.sources])];
      existing.source=existing.sources.length>1?'shared':existing.source;
      if(existing.source==='shared'){existing.role=copy.rec.sharedRole;existing.note=copy.rec.sharedNote}
      existing.required=existing.required||item.required;
    }));
    return [...merged.values()];
  };
  const defaultIncluded=item=>{
    if(item.required)return true;
    if(item.key==='privacy')return ['executive','travel','healthcare'].includes(state.lifestyle);
    if(item.key==='keyboard')return ['executive','school','everyday'].includes(state.lifestyle);
    if(item.key==='stylus')return ['executive','school','healthcare'].includes(state.lifestyle);
    if(item.key==='stand')return ['executive','school','everyday'].includes(state.lifestyle);
    if(item.key==='charging')return ['executive','travel','everyday'].includes(state.lifestyle);
    if(item.key==='garminBand')return ['executive','travel','everyday'].includes(state.lifestyle);
    return false;
  };
  const currentVariant=item=>{
    const id=Number(state.selected[item.id]);
    return variantsFor(item.key,item.fit).find(v=>v.id===id)||item.variant;
  };
  const persist=()=>{try{localStorage.setItem('avontic-loadout-studio-v2',JSON.stringify({active:state.active,brands:state.brands,devices:Object.fromEntries(categories.map(family=>[family,state.devices[family]?.id||''])),lifestyle:state.lifestyle,finish:state.finish,quantity:state.quantity,included:state.included,selected:state.selected}))}catch(_){}};
  const track=(event,detail={})=>{window.AvonticAnalytics?.track?.('loadout_'+event,detail);document.dispatchEvent(new CustomEvent('avontic:loadout-studio',{detail:{event,...detail}}))};
  const countCopy=count=>count===3?copy.threeDevices:count===2?copy.twoDevices:count===1?copy.oneDevice:copy.zeroDevices;
  const validate=()=>{
    const panel=root.querySelector('[data-avls-panel="'+state.step+'"]');
    const next=panel?.querySelector('[data-avls-next]');
    if(next&&state.step===1)next.disabled=!selectionValid();
    if(next&&state.step===2)next.disabled=!state.lifestyle;
    jumps.forEach(button=>{const n=Number(button.dataset.avlsJump),gatedMax=selectionValid()?state.maxStep:1;button.disabled=n>gatedMax||(n>2&&!state.lifestyle)});
  };
  const showStep=step=>{
    const requested=Math.max(1,Math.min(4,step));
    if(requested>1&&!selectionValid())return;
    if(requested>2&&!state.lifestyle)return;
    state.step=requested;state.maxStep=Math.max(state.maxStep,state.step);
    panels.forEach(panel=>panel.hidden=Number(panel.dataset.avlsPanel)!==state.step);
    jumps.forEach(button=>{const n=Number(button.dataset.avlsJump);if(n===state.step)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current')});
    root.querySelector('[data-avls-progress]').style.setProperty('--progress',(state.step*25)+'%');
    if(state.step===4)renderResult();
    validate();persist();
  };
  const renderLane=family=>{
    const lane=root.querySelector('[data-avls-lane="'+family+'"]'),active=state.active[family],device=state.devices[family];
    const controls=root.querySelector('[data-avls-lane-controls="'+family+'"]'),toggle=root.querySelector('[data-avls-toggle-category="'+family+'"]');
    lane.classList.toggle('is-active',active);lane.classList.toggle('is-ready',active&&Boolean(device));
    controls.hidden=!active;toggle.setAttribute('aria-pressed',String(active));toggle.setAttribute('aria-label',(active?copy.skip:copy.include)+' '+copy[family]);toggle.querySelector('[data-avls-toggle-label]').textContent=active?copy.skip:copy.include;
    root.querySelector('[data-avls-lane-status="'+family+'"]').textContent=!active?copy.skipped:device?copy.ready:copy.needsModel;
    const brandTarget=root.querySelector('[data-avls-brands="'+family+'"]'),brandList=[...new Set(familyDevices(family).map(d=>d.brand))];
    if(!brandList.includes(state.brands[family]))state.brands[family]='';
    brandTarget.innerHTML=brandList.map(brand=>'<button type="button" data-brand="'+clean(brand)+'" class="'+(brand===state.brands[family]?'is-selected':'')+'">'+clean(brand)+'</button>').join('');
    brandTarget.querySelectorAll('[data-brand]').forEach(button=>button.addEventListener('click',()=>{state.brands[family]=button.dataset.brand;state.devices[family]=null;renderSelection();persist();track('brand_selected',{family,brand:state.brands[family]})}));
    const select=root.querySelector('[data-avls-device="'+family+'"]'),list=familyDevices(family).filter(d=>d.brand===state.brands[family]);
    select.replaceChildren();
    const option=document.createElement('option');option.value='';option.textContent=state.brands[family]?copy.selectModel:copy.selectBrand;select.append(option);
    list.forEach(d=>{const model=document.createElement('option');model.value=d.id;model.textContent=d.label;select.append(model)});
    select.disabled=!state.brands[family];select.value=device?.id||'';
    const verified=root.querySelector('[data-avls-verified="'+family+'"]');
    if(active&&device){verified.hidden=false;verified.innerHTML='<span><strong>'+clean(device.label)+'</strong><small>'+clean(copy.verified)+'</small></span>'}else verified.hidden=true;
  };
  const renderSelection=()=>{
    categories.forEach(renderLane);
    const count=activeFamilies().length,ready=selectionValid();
    root.querySelector('[data-avls-system-count]').textContent=countCopy(count);
    root.querySelector('[data-avls-system-status]').textContent=ready?copy.selectionReady:copy.selectionHint;
    const nodes=[...root.querySelectorAll('[data-avls-node]')];nodes.forEach(node=>node.classList.toggle('is-active',state.active[node.dataset.avlsNode]));
    const rails=[...root.querySelectorAll('.avls__ecosystem-rail span')];rails.forEach((rail,index)=>rail.classList.toggle('is-active',count>index+1));
    validate();
  };
  const cardHtml=item=>{
    const product=products[item.key],variant=currentVariant(item),included=state.included[item.id],variants=variantsFor(item.key,item.fit),detailsLabel='View details for '+product.title+' (opens in a new tab)',titleLinkLabel=product.title+' (opens in a new tab)';
    return '<article class="avls__card '+(included?'is-included':'')+'" data-card="'+clean(item.id)+'"><a class="avls__card-media" href="'+clean(product.url)+'" target="_blank" rel="noopener" aria-label="'+clean(detailsLabel)+'"><img src="'+clean(product.image)+'" alt="'+clean(product.title)+'" width="500" height="500" loading="lazy"><span>'+(item.exact?clean(copy.exactFit):clean(copy.systemOption))+'</span></a><div class="avls__card-copy"><div class="avls__card-top"><div><p class="avls__card-role">'+clean(item.role)+'</p><h4><a class="avls__card-title-link" href="'+clean(product.url)+'" target="_blank" rel="noopener" aria-label="'+clean(titleLinkLabel)+'">'+clean(product.title)+'</a></h4></div><button type="button" class="avls__card-toggle" data-toggle="'+clean(item.id)+'" '+(item.required?'disabled':'')+'>'+(item.required?clean(copy.core):included?clean(copy.included):clean(copy.addItem))+'</button></div><p class="avls__card-note">'+clean(item.note)+'</p><label class="avls__field"><span>'+clean(copy.liveOption)+'</span><select data-variant="'+clean(item.id)+'">'+variants.map(v=>'<option value="'+v.id+'" '+(v.id===variant.id?'selected':'')+'>'+clean(variantText(v))+' · '+money(v.price)+'</option>').join('')+'</select></label><div class="avls__card-foot"><strong>'+money(variant.price)+'</strong><a href="'+clean(product.url)+'" target="_blank" rel="noopener" aria-label="'+clean(copy.view+' '+product.title+' (opens in a new tab)')+'">'+clean(copy.view)+' ↗</a></div></div></article>';
  };
  const renderResult=()=>{
    const items=recommendations();
    items.forEach(item=>{
      if(typeof state.included[item.id]!=='boolean')state.included[item.id]=defaultIncluded(item);
      if(item.required)state.included[item.id]=true;
      if(!variantsFor(item.key,item.fit).some(v=>v.id===Number(state.selected[item.id])))state.selected[item.id]=item.variant.id;
    });
    const count=selectedDevices().length,title=count===3?copy.completeTitle:count===2?copy.pairedTitle:copy.focusedTitle;
    root.querySelector('[data-avls-result-title]').textContent=title;
    root.querySelector('[data-avls-result-copy]').textContent=copy.summary;
    root.querySelector('[data-avls-device-chips]').innerHTML=activeFamilies().map(family=>'<span><strong>'+clean(copy[family])+':</strong> '+clean(state.devices[family].label)+'</span>').join('');
    const labels={phone:copy.phoneSystem,watch:copy.watchSystem,tablet:copy.tabletSystem,shared:copy.sharedEssentials};
    const groups=[...activeFamilies(),'shared'].filter(group=>items.some(item=>item.source===group));
    const cards=root.querySelector('[data-avls-cards]');
    cards.innerHTML=groups.map((group,index)=>{
      const groupItems=items.filter(item=>item.source===group),subtitle=group==='shared'?selectedDevices().map(d=>d.label).join(' · '):state.devices[group].label;
      return '<section class="avls__result-group" data-result-group="'+group+'"><header class="avls__group-head"><div><span>0'+(index+1)+'</span><strong>'+clean(labels[group])+'</strong></div><small>'+clean(subtitle)+'</small></header><div class="avls__group-grid">'+groupItems.map(cardHtml).join('')+'</div></section>';
    }).join('');
    cards.querySelectorAll('[data-toggle]').forEach(button=>button.addEventListener('click',()=>{const id=button.dataset.toggle;state.included[id]=!state.included[id];renderResult();persist()}));
    cards.querySelectorAll('[data-variant]').forEach(select=>select.addEventListener('change',()=>{state.selected[select.dataset.variant]=Number(select.value);renderResult();persist()}));
    const empty=root.querySelector('[data-avls-empty]');empty.hidden=items.length>0;cards.hidden=!items.length;
    updateSummary(items);
    const q=new URLSearchParams({source:'loadout-studio',phone:selectedIds().phone,watch:selectedIds().watch,tablet:selectedIds().tablet,quantity:String(state.quantity*selectedDevices().length),devices:JSON.stringify(selectedDevices().map(device=>({model:device.label,quantity:state.quantity}))),use_case:state.lifestyle});
    root.querySelector('[data-avls-business-link]').href='/pages/business-solutions?'+q.toString()+'#avb-quote';
    const business=root.querySelector('[data-avls-business]');business.hidden=state.quantity<10;business.classList.toggle('is-priority',state.quantity>=10);
    track('revealed',{devices:selectedIds(),lifestyle:state.lifestyle,items:items.length});
  };
  const chosenLines=items=>{
    const unique=new Map();
    items.filter(item=>state.included[item.id]).map(item=>({item,variant:currentVariant(item),product:products[item.key]})).filter(entry=>entry.variant?.available).forEach(entry=>{if(!unique.has(entry.variant.id))unique.set(entry.variant.id,entry)});
    return [...unique.values()];
  };
  const updateSummary=items=>{
    const lines=chosenLines(items),total=lines.reduce((sum,entry)=>sum+Number(entry.variant.price||0)*state.quantity,0);
    root.querySelector('[data-avls-total]').textContent=money(total);
    root.querySelector('[data-avls-count]').textContent=lines.length+' '+(lines.length===1?copy.component:copy.components)+' · '+state.quantity;
    const button=root.querySelector('[data-avls-add]');button.disabled=!lines.length;button.textContent=copy.add+' · '+money(total);
  };
  const shareUrl=()=>{
    const u=new URL(window.location.href);u.hash='loadout-builder';u.search='';
    categories.forEach(family=>{if(state.active[family]&&state.devices[family])u.searchParams.set(family,state.devices[family].id)});
    [['lifestyle',state.lifestyle],['finish',state.finish],['quantity',state.quantity]].forEach(([key,value])=>{if(value)u.searchParams.set(key,String(value))});
    u.searchParams.set('included',JSON.stringify(state.included));u.searchParams.set('variants',JSON.stringify(state.selected));
    return u.toString();
  };
  const safeJson=value=>{try{return JSON.parse(value||'')||{}}catch(_){return{}}};
  const assignDevice=(family,id,activate=true)=>{
    const device=devices.find(d=>d.family===family&&d.id===id)||null;
    if(device){state.devices[family]=device;state.brands[family]=device.brand;if(activate)state.active[family]=true}
  };
  const loadState=()=>{
    const params=new URLSearchParams(window.location.search),saved=safeJson(localStorage.getItem('avontic-loadout-studio-v2'));
    if(Object.keys(saved).length){
      categories.forEach(family=>{if(typeof saved.active?.[family]==='boolean')state.active[family]=saved.active[family];state.brands[family]=saved.brands?.[family]||'';assignDevice(family,saved.devices?.[family],false)});
      state.lifestyle=saved.lifestyle||'';state.finish=saved.finish||'graphite';state.quantity=Number(saved.quantity||1);state.included=saved.included||{};state.selected=saved.selected||{};
    }else{
      const legacy=safeJson(localStorage.getItem('avontic-loadout-studio-v1'));
      const legacyDevice=devices.find(d=>d.id===legacy.device);
      if(legacyDevice){categories.forEach(family=>state.active[family]=family===legacyDevice.family);assignDevice(legacyDevice.family,legacyDevice.id)}
      state.lifestyle=legacy.lifestyle||'';state.finish=legacy.finish||'graphite';state.quantity=Number(legacy.quantity||1);
    }
    const hasDeviceParams=categories.some(family=>params.has(family))||params.has('device');
    if(hasDeviceParams){categories.forEach(family=>{state.active[family]=false;state.devices[family]=null;state.brands[family]=''});state.included={};state.selected={}}
    categories.forEach(family=>assignDevice(family,params.get(family)));
    const legacyParamDevice=devices.find(d=>d.id===params.get('device'));if(legacyParamDevice)assignDevice(legacyParamDevice.family,legacyParamDevice.id);
    const requestedFamily=params.get('family');
    if(!hasDeviceParams&&categories.includes(requestedFamily)){categories.forEach(family=>state.active[family]=family===requestedFamily);state.brands[requestedFamily]=params.get('brand')||state.brands[requestedFamily]}
    const lifestyle=params.get('lifestyle');if(['field','executive','travel','fitness','school','healthcare','everyday'].includes(lifestyle))state.lifestyle=lifestyle;
    const finish=params.get('finish');if(Object.keys(finishTerms).includes(finish))state.finish=finish;
    const quantity=Number(params.get('quantity'));if([1,2,5,10,25,50].includes(quantity))state.quantity=quantity;
    if(params.has('included'))state.included=safeJson(params.get('included'));if(params.has('variants'))state.selected=safeJson(params.get('variants'));
    if(![1,2,5,10,25,50].includes(state.quantity))state.quantity=1;
    const productHandle=params.get('product');
    if(productHandle&&!selectedDevices().length){
      const entry=Object.entries(products).find(([,product])=>product.handle===productHandle),key=entry?.[0];
      const candidate=devices.find(device=>(!categories.includes(requestedFamily)||device.family===requestedFamily)&&Object.prototype.hasOwnProperty.call(device.fit,key));
      if(candidate){categories.forEach(family=>state.active[family]=family===candidate.family);state.brands[candidate.family]=candidate.brand}
    }
  };
  root.querySelectorAll('[data-avls-toggle-category]').forEach(button=>button.addEventListener('click',()=>{const family=button.dataset.avlsToggleCategory;state.active[family]=!state.active[family];renderSelection();persist();track(state.active[family]?'category_added':'category_skipped',{family})}));
  root.querySelectorAll('[data-avls-device]').forEach(select=>select.addEventListener('change',()=>{const family=select.dataset.avlsDevice;state.devices[family]=devices.find(d=>d.family===family&&d.id===select.value)||null;renderSelection();persist();track('device_selected',{family,device:state.devices[family]?.id})}));
  root.querySelectorAll('[data-avls-lifestyles] button').forEach(button=>button.addEventListener('click',()=>{state.lifestyle=button.dataset.value;root.querySelectorAll('[data-avls-lifestyles] button').forEach(item=>item.classList.toggle('is-selected',item===button));validate();persist();track('lifestyle_selected',{lifestyle:state.lifestyle})}));
  root.querySelectorAll('[data-avls-finishes] button').forEach(button=>button.addEventListener('click',()=>{state.finish=button.dataset.value;state.selected={};root.querySelectorAll('[data-avls-finishes] button').forEach(item=>item.classList.toggle('is-selected',item===button));persist()}));
  root.querySelector('[data-avls-quantity]').addEventListener('change',event=>{state.quantity=Number(event.target.value);persist()});
  root.querySelectorAll('[data-avls-next]').forEach(button=>button.addEventListener('click',()=>showStep(state.step+1)));
  root.querySelectorAll('[data-avls-back]').forEach(button=>button.addEventListener('click',()=>showStep(state.step-1)));
  jumps.forEach(button=>button.addEventListener('click',()=>{if(!button.disabled)showStep(Number(button.dataset.avlsJump))}));
  root.querySelector('[data-avls-restart]').addEventListener('click',()=>{try{localStorage.removeItem('avontic-loadout-studio-v2');localStorage.removeItem('avontic-loadout-studio-v1')}catch(_){};window.location.href='/pages/build-your-loadout'});
  root.querySelector('[data-avls-save]').addEventListener('click',()=>{persist();root.querySelector('[data-avls-status]').textContent=copy.saved;track('saved',{devices:selectedIds()})});
  root.querySelector('[data-avls-share]').addEventListener('click',async()=>{const url=shareUrl();try{if(navigator.share)await navigator.share({title:copy.defaultTitle,url});else{await navigator.clipboard.writeText(url);root.querySelector('[data-avls-status]').textContent=copy.copied}track('shared',{devices:selectedIds()})}catch(error){if(error?.name!=='AbortError')root.querySelector('[data-avls-status]').textContent=copy.shareFallback}});
  root.querySelector('[data-avls-print]').addEventListener('click',()=>{window.print();track('printed',{devices:selectedIds()})});
  root.querySelector('[data-avls-add]').addEventListener('click',async event=>{
    const button=event.currentTarget,status=root.querySelector('[data-avls-status]'),lines=chosenLines(recommendations());
    if(!lines.length)return;
    button.disabled=true;status.textContent=copy.adding;
    const labels=selectedDevices().map(device=>device.label);
    const properties={'_Avontic Loadout':'Complete Ecosystem','_Devices':labels.join(' · '),'_Phone':state.devices.phone?.label||'Skipped','_Watch':state.devices.watch?.label||'Skipped','_Tablet':state.devices.tablet?.label||'Skipped','_Lifestyle':state.lifestyle,'_Studio':'Loadout Studio'};
    try{
      const shopRoot=window.Shopify?.routes?.root||'/';
      const sections=[];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start',{bubbles:true}));
      const response=await fetch(shopRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:lines.map(entry=>({id:entry.variant.id,quantity:state.quantity,properties})),sections:sections.join(','),sections_url:window.location.pathname})});
      const result=await response.json();if(!response.ok)throw new Error(result.description||'Cart request failed');
      const cartResponse=await fetch(shopRoot+'cart.js',{headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}});if(!cartResponse.ok)throw new Error(copy.error);
      const cart=await cartResponse.json();cart.sections=result.sections||{};
      document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open',cart}}));
      document.dispatchEvent(new CustomEvent('avontic:cart-updated',{detail:{source:'loadout-studio',result,cart,item_count:cart.item_count,sections:cart.sections}}));
      status.innerHTML=clean(copy.added)+' <a href="/cart">'+clean(copy.viewCart)+' →</a>';track('added_to_cart',{devices:selectedIds(),items:lines.length,quantity:state.quantity});
    }catch(error){status.textContent=copy.error+' '+String(error?.message||'')}
    finally{document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end',{bubbles:true}));button.disabled=false}
  });
  loadState();renderSelection();
  root.querySelectorAll('[data-avls-lifestyles] button').forEach(button=>button.classList.toggle('is-selected',button.dataset.value===state.lifestyle));
  root.querySelectorAll('[data-avls-finishes] button').forEach(button=>button.classList.toggle('is-selected',button.dataset.value===state.finish));
  root.querySelector('[data-avls-quantity]').value=String(state.quantity);
  showStep(selectionValid()&&state.lifestyle?4:1);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-native-studio"]) return;
  try {
    
(() => {
  if (customElements.get('avontic-setup-studio')) return;
  





function fittingVariants(product, deviceId) {
  return product.variants.filter(v => v.available && (!deviceId || v.devices.includes(deviceId) || (product.category !== 'case' && product.category !== 'screen' && product.category !== 'mouse-bundle' && !v.fit)));
}

function findVariant(catalog, id) {
  for (const product of catalog.products) { const variant = product.variants.find(v => v.id === id); if (variant) return {product,variant}; }
  return null;
}

function mouseOption(catalog, product, variant, deviceId) {
  const prefix = product.name === 'RhinoGuard Pro' ? 'rhinoguard-pro-workforce-' : product.name === 'RhinoGuard ArmorPro' ? 'rhinoguard-armorpro-workforce-' : product.name === 'RhinoGuard Apex 360 Command' ? 'rhinoguard-apex-command-workforce-' : '';
  if (!prefix || !deviceId) return null;
  const bundle = catalog.products.find(p => p.category === 'mouse-bundle' && p.handle.startsWith(prefix));
  const colorKey = value => value.toLowerCase().replace(/[^a-z]/g,'').replace(/^blackblack$/,'black');
  const match = bundle && fittingVariants(bundle, deviceId).find(v=>colorKey(v.color) === colorKey(variant.color));
  return bundle && match ? {product:bundle,variant:match,stylusIncluded:prefix.includes('apex-command')} : null;
}

function getSetup(catalog, state) {
  if (!state || typeof state.deviceId !== 'string' || !catalog.devices.some(d=>d.id === state.deviceId)) throw new Error('Choose your exact iPad model first.');
  if (!Number.isSafeInteger(state.caseId) || !Array.isArray(state.addons) || state.addons.length>4 || state.addons.some(id=>!Number.isSafeInteger(id)) || typeof state.mouseBundle !== 'boolean') throw new Error('This setup could not be read. Please select your items again.');
  const foundation = findVariant(catalog,state.caseId);
  if (!foundation || foundation.product.category !== 'case' || !fittingVariants(foundation.product,state.deviceId).some(v=>v.id===state.caseId)) throw new Error('Choose an available case for this iPad model.');
  const bundle = state.mouseBundle ? mouseOption(catalog,foundation.product,foundation.variant,state.deviceId) : null;
  if (state.mouseBundle && !bundle) throw new Error('The keyboard and mouse package is not offered for this case, model and color.');
  const lines = [bundle || foundation];
  const categories = new Set();
  for (const id of state.addons) {
    const entry = findVariant(catalog,id);
    if (!entry || !['screen','stylus','keyboard','desk'].includes(entry.product.category) || !fittingVariants(entry.product,state.deviceId).some(v=>v.id===id)) throw new Error('An accessory does not match this iPad model. Please select it again.');
    if (categories.has(entry.product.category)) throw new Error('Choose one accessory from each category.');
    if (entry.product.category==='screen' && foundation.product.screenPolicy !== 'open') throw new Error('An extra screen protector has not been verified with this case.');
    if (entry.product.category==='keyboard' && (foundation.product.keyboardIncluded || bundle)) throw new Error('This setup already includes a keyboard.');
    if (entry.product.category==='stylus' && bundle?.stylusIncluded) throw new Error('This package already includes a stylus.');
    categories.add(entry.product.category); lines.push(entry);
  }
  return {foundation,bundle,lines,totalCents:lines.reduce((sum,line)=>sum+Math.round(line.variant.price*100),0)};
}

function reconcileState(catalog,state) {
  const foundation=findVariant(catalog,state.caseId);
  if (!foundation) return {...state,addons:[],mouseBundle:false};
  const bundle=state.mouseBundle?mouseOption(catalog,foundation.product,foundation.variant,state.deviceId):null;
  const next={...state,mouseBundle:!!bundle,addons:([])};
  for(const id of state.addons){try{getSetup(catalog,{...next,addons:[...next.addons,id]});next.addons.push(id);}catch{ /* The interface reports reset choices. */ }}
  return next;
}

function cartUrl(lines) {
  if (!lines.length || lines.some(l=>!Number.isSafeInteger(l.variant.id)||l.variant.id<=0)) throw new Error('A valid setup is required.');
  return 'https://www.avontic.com/cart/'+lines.map(l=>`${l.variant.id}:1`).join(',')+'?storefront=true';
}

  const esc = value => String(value ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const imageUrl = (src, width=600) => { try { const url=new URL(src,location.origin); if(url.protocol!=='https:' || !/(^|\.)shopify\.com$|(^|\.)shopifycdn\.(com|net)$|(^|\.)avontic\.com$/.test(url.hostname))return ''; url.searchParams.set('width',width);return url.href;}catch{return '';} };
  const color = value => {const colors=[['purple','#ad9ac3'],['pink','#dbb1bd'],['green','#859783'],['blue','#8fa9c0'],['white','#e9e6db'],['yellow','#d8bc68'],['orange','#cc8a56'],['red','#aa4e55'],['grey','#a5a7a5'],['gray','#a5a7a5'],['black','#262727'],['brown','#98724f']]; const matches=colors.filter(([key])=>value.toLowerCase().includes(key)).map(([,hex])=>hex);return matches.length>1?`linear-gradient(135deg,${matches[0]} 50%,${matches[1]} 50%)`:matches[0]||'#a49b88';};
  class AvonticStudio extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      try{
        this.config=JSON.parse(this.querySelector('[data-avs-config]').textContent);
        if(Array.isArray(this.config.strings))this.config.strings=Object.assign({},...this.config.strings.map(value=>{const text=document.createElement('textarea');text.innerHTML=value;return JSON.parse(text.value);}));
        const chunks=[...this.querySelectorAll('[data-avs-catalog]')].map(el=>JSON.parse(el.textContent));
        const raw={...chunks[0],products:chunks.flatMap(part=>part.products)};
        this.catalog={devices:raw.devices,products:raw.products.map(p=>({...p,variants:p.variants.map(v=>({id:v[0],title:raw.strings[v[1]],color:raw.strings[v[2]],fit:raw.strings[v[3]],image:raw.strings[v[4]],devices:v[5].map(i=>raw.devices[i].id),available:!!v[6],price:v[7]/100}))}))};
        this.products=this.catalog.products;this.cases=this.products.filter(p=>p.category==='case');this.live=new Map();this.requests=new Map();this.failures=new Set();
        this.state={deviceId:'',caseId:this.cases[0].variants[0].id,addons:[],mouseBundle:false};this.tab='case';this.family='';this.collection='';this.expanded=false;this.notice='';this.error='';this.quote=null;this.busy=false;this.existing=null;this.pendingCart=false;this.closed=false;
        this.root=this.config.root.endsWith('/')?this.config.root:this.config.root+'/';
        this.moneyFormatter=new Intl.NumberFormat(this.config.locale||'en',{style:'currency',currency:this.config.currency});
        this.host=this.querySelector('[data-avs-app]');
        this.restore();this.render();this.addEventListener('click',this.onClick=this.click.bind(this));this.addEventListener('change',this.onChange=this.change.bind(this));this.addEventListener('input',this.onInput=this.input.bind(this));
        this.addEventListener('error',this.onImageError=e=>{if(e.target instanceof HTMLImageElement)e.target.style.visibility='hidden';},true);
        this.timer=setInterval(()=>{if(this.quote&&Date.now()-this.quote.at>120000){this.quote=null;this.notice=this.t('price_expired');this.render();}},15000);
        this.initCart();this.track('setup_studio_open',{surface:this.source});
      }catch(error){console.error('[Avontic Setup Studio]',error);this.querySelector('[data-avs-app]').textContent=this.config?.strings.network_error||'Please reload the page to open Setup Studio.';}
    }
    disconnectedCallback(){this.closed=true;clearInterval(this.timer);this.removeEventListener('click',this.onClick);this.removeEventListener('change',this.onChange);this.removeEventListener('input',this.onInput);this.removeEventListener('error',this.onImageError,true);}
    t(key,values={}){let text=this.config.strings[key]||key;Object.entries(values).forEach(([k,v])=>text=text.replaceAll('{'+k+'}',String(v)));return text;}
    tx(key,values={}){return esc(this.t(key,values));}
    currency(cents){return this.moneyFormatter.format(cents/100);}
    current(){return findVariant(this.catalog,this.state.caseId);}
    device(){return this.catalog.devices.find(d=>d.id===this.state.deviceId);}
    fit(p){return fittingVariants(p,this.state.deviceId);}
    variant(p,colorName){return this.fit(p).find(v=>v.color===colorName)||this.fit(p)[0];}
    img(v,alt='',width=600,eager=false){return `<img src="${esc(imageUrl(v,width))}" alt="${esc(alt)}" width="${width}" height="${width}" loading="${eager?'eager':'lazy'}" decoding="async">`;}
    price(p,v,from=false){const live=this.live.get(p.handle);if(!live)return this.tx(this.failures.has(p.handle)?'price_error':'price_loading');const item=live.variants.find(x=>x.id===v.id);return item&&item.available?`${from?this.tx('from')+' ':''}${esc(this.currency(item.price))}`:this.tx('unavailable');}
    async read(path,options={}){const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),20000);try{const response=await fetch(this.root+path,{credentials:'same-origin',...options,signal:controller.signal});let value;try{value=await response.json();}catch{throw new Error(this.t('network_error'));}if(!response.ok)throw new Error(value.description||this.t('network_error'));return value;}finally{clearTimeout(timeout);}}
    async loadProduct(p,force=false){
      if(!force&&this.live.has(p.handle))return this.live.get(p.handle);
      if(!force&&this.requests.has(p.handle))return this.requests.get(p.handle);
      const promise=this.read('products/'+encodeURIComponent(p.handle)+'.js').then(value=>{if(value.handle!==p.handle||!Array.isArray(value.variants))throw new Error(this.t('network_error'));this.live.set(p.handle,value);this.failures.delete(p.handle);return value;}).catch(error=>{this.failures.add(p.handle);throw error;}).finally(()=>this.requests.delete(p.handle));this.requests.set(p.handle,promise);return promise;
    }
    async loadVisible(products){const pending=[...new Map(products.map(p=>[p.handle,p])).values()].filter(p=>!this.live.has(p.handle)&&!this.requests.has(p.handle)&&!this.failures.has(p.handle));if(!pending.length)return;await Promise.allSettled(pending.map(p=>this.loadProduct(p)));if(!this.closed)this.render();}
    restore(){
      const query=new URLSearchParams(location.search);this.source=['product','cart','home','collection','navigation','footer'].includes(query.get('source'))?query.get('source'):'direct';
      const handle=query.get('case');const accessory=query.get('accessory');const requested=Number(query.get('variant'));const caseProduct=this.cases.find(p=>p.handle===handle);
      if(caseProduct){const v=caseProduct.variants.find(v=>v.id===requested)||caseProduct.variants.find(v=>v.available);if(v){this.state.caseId=v.id;if(v.devices.length===1)this.state.deviceId=v.devices[0];}}
      const accessoryProduct=this.products.find(p=>p.handle===accessory&&p.category!=='case'&&p.category!=='mouse-bundle');if(accessoryProduct){this.seedAccessory={product:accessoryProduct,variantId:requested};}
      if(!caseProduct&&!accessoryProduct){try{const saved=JSON.parse(sessionStorage.getItem('avontic-studio-v1'));if(saved&&saved.currency===this.config.currency&&Date.now()-saved.at<86400000){getSetup(this.catalog,saved.state);this.state=saved.state;this.notice=this.t('saved');}}catch{}}
      if(query.get('device')&&this.catalog.devices.some(d=>d.id===query.get('device'))){const p=this.current().product;const v=this.variantFor(p,query.get('device'),this.current().variant.color);if(v)this.state={...this.state,deviceId:query.get('device'),caseId:v.id};}
      this.family=this.device()?.family||'';this.cartKey=this.source==='cart'?query.get('cart_line'):null;if(this.cartKey){this.pendingCart=true;this.state.addons=[];this.state.mouseBundle=false;}
    }
    variantFor(p,id,colorName){const options=fittingVariants(p,id);return options.find(v=>v.color===colorName)||options[0];}
    async initCart(){if(!this.cartKey)return;try{const cart=await this.read('cart.js');const item=cart.items.find(i=>i.key===this.cartKey&&i.variant_id===this.state.caseId);if(!item)throw new Error(this.t('existing_missing'));this.existing={key:item.key,id:item.variant_id,items:cart.items};this.notice=this.t('existing_case');this.tab=this.device()?'accessories':'case';}catch(e){this.error=e.message;this.cartBlocked=true;}finally{this.pendingCart=false;this.render();}}
    track(name,payload={}){if(this.config.preview)return;try{window.AvonticAnalytics?.track(name,{...payload,currency:this.config.currency,surface:this.source},{dedupeKey:name+':'+JSON.stringify(payload)});}catch{}}
    save(){if(!this.device()||this.existing||this.cartKey)return;try{sessionStorage.setItem('avontic-studio-v1',JSON.stringify({state:this.state,currency:this.config.currency,at:Date.now()}));}catch{}}
    update(next,notice=''){const clean=next.deviceId?reconcileState(this.catalog,next):next;this.notice=clean.addons.length<next.addons.length?this.t('reset_notice'):notice;this.state=clean;this.photo=null;this.quote=null;this.error='';this.save();this.render();}
    chooseDevice(id){const d=this.catalog.devices.find(d=>d.id===id);if(!d)return;const current=this.current();if(this.existing&&!current.variant.devices.includes(id)){this.error=this.t('unavailable');this.render();return;}let v=this.variantFor(current.product,id,current.variant.color)||this.cases.map(p=>this.variantFor(p,id)).find(Boolean);if(!v){this.error=this.t('no_device_case');this.render();return;}const next={...this.state,deviceId:id,caseId:v.id,mouseBundle:false};if(this.seedAccessory){const p=this.seedAccessory.product;const candidate=fittingVariants(p,id).find(v=>v.id===this.seedAccessory.variantId)||fittingVariants(p,id)[0];if(candidate)next.addons=[candidate.id];this.seedAccessory=null;}
      this.family=d.family;this.collection='';this.expanded=false;this.tab=this.existing?'accessories':'case';this.update(next,this.t('case_changed'));this.track('setup_model_selected',{variant_ids:[v.id]});}
    addon(category,id){const others=this.state.addons.filter(v=>findVariant(this.catalog,v)?.product.category!==category);this.update({...this.state,addons:id?[...others,id]:others});this.track('setup_accessory_selected',{variant_ids:id?[id]:[],action:id?'add':'remove'});}
    go(tab,focus=true){if(!this.device()&&tab!=='case')return;this.tab=tab;this.render();if(focus){const target=this.querySelector('.avs-panel');target?.focus({preventScroll:true});target?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}if(tab==='review')this.track('setup_reviewed',{variant_ids:[this.state.caseId,...this.state.addons]});}
    click(e){const button=e.target.closest('[data-action]');if(!button||this.busy)return;const action=button.dataset.action;
      if(action==='tab')this.go(button.dataset.value);
      if(action==='case'){if(this.existing||this.pendingCart)return;const p=this.products.find(p=>p.id===Number(button.dataset.value));const v=p&&this.variant(p,this.current().variant.color);if(v){this.update({...this.state,caseId:v.id,mouseBundle:false});this.track('setup_case_selected',{variant_ids:[v.id]});}}
      if(action==='color'&&!this.existing)this.update({...this.state,caseId:Number(button.dataset.value),mouseBundle:false});
      if(action==='show'){this.expanded=!this.expanded;this.render();}
      if(action==='photo'){this.photo=button.dataset.value;this.render();}
      if(action==='addon')this.addon(button.dataset.category,Number(button.dataset.value));
      if(action==='model')this.chooseDevice(button.dataset.value);
      if(action==='edit')this.applyEdit(button.dataset.value);
      if(action==='check')this.check();
      if(action==='add')this.addToCart();
      if(action==='retry'){this.failures.clear();this.error='';this.render();}
      if(action==='new'){this.existing=null;this.cartKey=null;this.cartBlocked=false;this.pendingCart=false;history.replaceState(null,'',location.pathname+location.hash);this.update({...this.state,addons:[],mouseBundle:false});this.tab='case';this.render();}
      if(action==='bar'){if(this.device()){if(this.tab==='review'){this.quote?this.addToCart():this.check();}else this.go(this.tab==='case'?'accessories':'review');}else{this.querySelector('[data-field=model]')?.focus();this.querySelector('.avs-picker')?.scrollIntoView({behavior:'smooth',block:'center'});}}
    }
    change(e){if(this.busy)return;const el=e.target;
      if(el.dataset.field==='family'){this.family=el.value;this.tab='case';this.update({...this.state,deviceId:'',addons:[],mouseBundle:false});}
      if(el.dataset.field==='model')this.chooseDevice(el.value);
      if(el.dataset.field==='collection'){this.collection=el.value;this.expanded=false;this.render();}
      if(el.dataset.field==='addon')this.addon(el.dataset.category,Number(el.value));
      if(el.dataset.field==='package'){this.update({...this.state,mouseBundle:el.checked});}
    }
    input(e){if(e.target.dataset.field!=='search')return;const search=e.target.value.toLowerCase().trim();const items=this.catalog.devices.filter(d=>(!this.existing||this.current().variant.devices.includes(d.id))&&`${d.name} ${d.year} ${d.numbers.join(' ')}`.toLowerCase().includes(search));const output=this.querySelector('.avs-model-results');output.innerHTML=items.length?items.slice(0,8).map(d=>`<button type="button" data-action="model" data-value="${esc(d.id)}">${esc(d.name)} · ${esc(d.year)}<br><span class="avs-fine">${esc(d.numbers.join(' / '))}</span></button>`).join(''):`<p>${this.tx('no_match')}</p><a class="avs-link" href="https://support.apple.com/en-us/108043" target="_blank" rel="noopener">${this.tx('apple')} ↗</a>`;}
    applyEdit(kind){if(!this.device()){this.notice=this.t('choose_first');this.render();this.querySelector('[data-field=model]')?.focus();return;}const handles=kind==='focus'?['ultrashield-privacy','avontic-rhinokeys']:kind==='ideas'?['papertouch','apextouch']:['avontic-workforce-fold','apextouch'];const ids=[];for(const prefix of handles){const p=this.products.find(p=>p.handle.startsWith(prefix));const options=p&&this.fit(p);const v=options?.find(v=>v.color===this.current().variant.color)||options?.find(v=>/black/i.test(v.color))||options?.[0];if(v)ids.push(v.id);}this.update({...this.state,addons:ids,mouseBundle:false},this.t('edit_ready'));this.go('accessories');}
    lines(){const setup=getSetup(this.catalog,this.state);return this.existing?setup.lines.slice(1).filter(l=>!this.existing.items.some(i=>i.variant_id===l.variant.id)):setup.lines;}
    async validateLive(force=true){const lines=this.lines();if(!lines.length)throw new Error(this.t('no_additions'));await Promise.all(lines.map(l=>this.loadProduct(l.product,force)));let total=0;const checked=lines.map(l=>{const live=this.live.get(l.product.handle).variants.find(v=>v.id===l.variant.id);if(!live||!live.available||!Number.isInteger(live.price)||live.price<0||live.title!==l.variant.title)throw new Error(this.t('unavailable')+' '+l.product.name);total+=live.price;return {...l,price:live.price};});return {lines:checked,total,at:Date.now(),key:JSON.stringify(this.state)};}
    async check(){if(this.busy||!this.device()||this.cartBlocked)return;this.busy=true;this.error='';this.quote=null;this.render();try{if(this.existing)await this.refreshExisting();this.quote=await this.validateLive();this.notice=this.t('verified');}catch(e){this.error=e.message;}finally{this.busy=false;this.render();}}
    async refreshExisting(){const cart=await this.read('cart.js');if(!cart.items.some(i=>i.key===this.existing.key&&i.variant_id===this.existing.id))throw new Error(this.t('existing_missing'));this.existing.items=cart.items;}
    async addToCart(){if(this.busy||!this.quote||this.uncertain||this.cartBlocked)return;this.busy=true;this.error='';this.adding=true;this.render();let submitted=false;try{
      if(this.existing)await this.refreshExisting();const fresh=await this.validateLive();if(fresh.total!==this.quote.total||fresh.key!==this.quote.key||fresh.lines.map(l=>l.variant.id).join(',')!==this.quote.lines.map(l=>l.variant.id).join(',')){this.quote=fresh;this.notice=this.t('price_changed');return;}
      const token=crypto.randomUUID();const properties={_av_studio:token,_av_studio_device:this.state.deviceId,_av_studio_version:'1'};const items=fresh.lines.map(l=>({id:l.variant.id,quantity:1,properties}));submitted=true;
      try{await this.read('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});}catch(error){const cart=await this.read('cart.js').catch(()=>null);const added=cart?.items.filter(i=>i.properties?._av_studio===token)||[];if(added.length===items.length&&items.every(item=>added.some(i=>i.variant_id===item.id&&i.quantity===1))){/* The first response was lost; the cart is authoritative. */}else{this.uncertain=true;throw new Error(this.t('cart_error'));}}
      this.track('setup_added_to_cart',{variant_ids:items.map(i=>i.id),price_cents:fresh.total,result:'success'});try{sessionStorage.removeItem('avontic-studio-v1');}catch{}location.assign(this.root+'cart');
    }catch(e){this.error=submitted?this.t('cart_error'):e.message;if(submitted)this.uncertain=true;this.quote=null;}finally{this.busy=false;this.adding=false;this.render();}}
    render(){
      if(this.closed)return;const focused=document.activeElement;const focusKey=focused&&this.contains(focused)?focused.getAttribute('data-focus'):null;const modelHelp=this.querySelector('.avs-model-help');const helpOpen=modelHelp?.open;const searchValue=modelHelp?.querySelector('input')?.value||'';const searching=focused?.dataset.field==='search';const current=this.current();if(!current)return;const {product:p,variant:v}=current;const d=this.device();const visible=[];const compatible=this.cases.filter(p=>this.fit(p).length);const filtered=compatible.filter(p=>!this.collection||p.family===this.collection);const shown=this.expanded?filtered:filtered.slice(0,6);const images=[...new Set([v.image,...p.images])].slice(0,5);let setup=null;try{if(d)setup=getSetup(this.catalog,this.state);}catch{}
      const html=`<div class="avs-workspace"><div class="avs-visual"><div class="avs-stage"><div class="avs-stage-top"><span>01 / ${this.tx('foundation')}</span><span>${esc(p.family)}</span></div><img class="avs-stage-image" src="${esc(imageUrl(this.photo||v.image,1000))}" alt="${esc(p.name+' — '+v.color)}" width="1000" height="1000" loading="eager" fetchpriority="high" decoding="async"><div class="avs-stage-bottom"><div><p>${esc(v.color)}</p><h2>${esc(p.name)}</h2></div></div></div><div class="avs-gallery">${images.map((src,i)=>`<button type="button" data-action="photo" data-value="${esc(src)}" data-focus="photo-${i}" aria-label="${this.tx('photo')} ${i+1}" aria-pressed="${(this.photo||v.image)===src}">${this.img(src,'',110)}</button>`).join('')}</div><p class="avs-fine">${this.tx('photo_note')}</p><div class="avs-story"><p>${esc(p.description)}</p><ul>${p.features.map(f=>`<li>${esc(f)}</li>`).join('')}</ul><a class="avs-link" href="${esc(this.root+'products/'+p.handle)}" target="_blank" rel="noopener">${this.tx('details')} ↗</a></div></div><div class="avs-configuration" id="builder"><div class="avs-picker"><div class="avs-picker-heading"><h2>${this.tx('first')}</h2><span class="avs-kicker">AVONTIC</span></div><div class="avs-fields"><label><span class="avs-field-label">${this.tx('family')}</span><select data-field="family" data-focus="family" ${this.existing?'disabled':''}><option value="">${this.tx('all_families')}</option>${['iPad','iPad Air','iPad Pro','iPad mini'].map(f=>`<option ${f===this.family?'selected':''}>${f}</option>`).join('')}</select></label><label><span class="avs-field-label">${this.tx('model')}</span><select data-field="model" data-focus="model"><option value="">${this.tx('choose_model')}</option>${this.catalog.devices.filter(x=>(!this.family||x.family===this.family)&&(!this.existing||v.devices.includes(x.id))).map(x=>`<option value="${esc(x.id)}" ${x.id===this.state.deviceId?'selected':''}>${esc(x.name)} · ${esc(x.year)}</option>`).join('')}</select></label></div><p class="avs-fine">${d?this.tx('design_count',{count:compatible.length}):this.tx('choose_hint')}</p><details class="avs-model-help" open><summary>${this.tx('help')}</summary><p>${document.documentElement.lang.startsWith('en')?'Settings → General → About → tap the part number beside Model Number to reveal the A-number.':this.tx('help_copy')}</p><label><span class="avs-field-label">${this.tx('search')}</span><input type="search" data-field="search" placeholder="${this.tx('search_placeholder')}" autocomplete="off"></label><div class="avs-model-results"></div></details></div>${this.existing?`<div class="avs-lock">${this.tx('existing_case')}<br><button type="button" class="avs-link" data-action="new">${this.tx('start_new')} ↗</button></div>`:''}<div class="avs-notice" role="status" aria-live="polite">${esc(this.notice)}</div><nav class="avs-tabs" aria-label="${this.tx('build')}">${['case','accessories','review'].map((x,i)=>`<button type="button" data-action="tab" data-value="${x}" data-focus="tab-${x}" aria-pressed="${this.tab===x}" ${(!d&&x!=='case')||this.pendingCart?'disabled':''}><span>0${i+1}</span>${this.tx(['case_step','accessory_step','review_step'][i])}</button>`).join('')}</nav><div class="avs-panel" tabindex="-1">${this.tab==='case'?this.renderCases(p,v,d,filtered,shown,visible):this.tab==='accessories'?this.renderAccessories(p,v,setup,visible):this.renderReview(p,v,d,setup,visible)}</div>${this.error?`<div class="avs-error" role="alert">${esc(this.error)}${this.uncertain||this.cartBlocked?`<br><a class="avs-link" href="${esc(this.root+'cart')}">${this.tx('view_bag')} ↗</a>${this.cartBlocked?`<button type="button" class="avs-link" data-action="new">${this.tx('start_new')}</button>`:''}`:`<br><button type="button" class="avs-link" data-action="retry">${this.tx('retry')}</button>`}</div>`:''}</div></div>${this.renderEdits()}${this.renderBar(p,v,setup)}`;
      this.host.innerHTML=html;this.classList.toggle('avs-busy',this.busy);this.host.setAttribute('aria-busy',String(this.busy));if(focusKey)this.querySelector(`[data-focus="${CSS.escape(focusKey)}"]`)?.focus({preventScroll:true});if(helpOpen){const help=this.querySelector('.avs-model-help');help.open=true;const input=help.querySelector('input');input.value=searchValue;if(searchValue)this.input({target:input});if(searching)input.focus({preventScroll:true});}this.loadVisible(visible);
    }
    renderCases(p,v,d,filtered,shown,visible){
      if(this.existing)return `<div class="avs-lock">${esc(p.name)} · ${esc(v.color)}<br>${this.tx('existing_label')}</div><button type="button" class="avs-button avs-next" data-action="tab" data-value="accessories" ${!d?'disabled':''}>${this.tx('next')} →</button>`;
      shown.forEach(p=>visible.push(p));return `<p class="avs-kicker">${this.tx('case_eyebrow')}</p><h2>${this.tx('case_title')}</h2><p class="avs-copy">${this.tx('case_copy')}</p><div class="avs-tools"><label><span class="avs-field-label">${this.tx('collection')}</span><select data-field="collection" data-focus="collection"><option value="">${this.tx('all_designs')}</option>${['FormaLift','RhinoGuard','Axis WorkForce','Folio','Kids'].map(f=>`<option ${this.collection===f?'selected':''}>${esc(f)}</option>`).join('')}</select></label><span class="avs-fine">${d?this.tx('match_note'):this.tx('choose_hint')}</span></div><div class="avs-cases">${shown.map(item=>{const variant=p.id===item.id?v:this.variant(item);const choices=this.fit(item);const cheapest=[...choices].sort((a,b)=>(this.live.get(item.handle)?.variants.find(x=>x.id===a.id)?.price??a.price*100)-(this.live.get(item.handle)?.variants.find(x=>x.id===b.id)?.price??b.price*100))[0];return `<button type="button" class="avs-case" data-action="case" data-value="${item.id}" data-focus="case-${item.id}" aria-pressed="${p.id===item.id}"><span class="avs-case-image">${this.img(variant.image,'',320)}${p.id===item.id?'<span class="avs-check" aria-hidden="true">✓</span>':''}</span><strong>${esc(item.name)}</strong><small>${this.tx('finishes',{count:new Set(choices.map(v=>v.color)).size})}${item.keyboardIncluded?' · '+this.tx('keyboard_included'):''}</small><b>${this.price(item,cheapest,true)}</b></button>`;}).join('')}</div>${!shown.length?`<p class="avs-empty">${this.tx('no_cases')}</p>`:''}${filtered.length>6?`<button type="button" class="avs-show" data-action="show" data-focus="show">${this.expanded?this.tx('show_less'):this.tx('show_all',{count:filtered.length})} ↓</button>`:''}<div class="avs-colors"><h3>${this.tx('color_title')}</h3><p>${esc(v.color)}</p><div class="avs-swatches" aria-label="${this.tx('color_title')}">${[...new Map(this.fit(p).map(v=>[v.color,v])).values()].map(x=>`<button type="button" class="avs-swatch" data-action="color" data-value="${x.id}" data-focus="color-${x.id}" aria-pressed="${x.color===v.color}"><i aria-hidden="true" style="background:${color(x.color)}"></i>${esc(x.color)}</button>`).join('')}</div></div><button type="button" class="avs-button avs-next" data-action="tab" data-value="accessories" ${!d||this.pendingCart?'disabled':''}>${this.tx('next')} →</button>`;
    }
    renderAccessories(p,v,setup,visible){
      const bundle=this.existing?null:mouseOption(this.catalog,p,v,this.state.deviceId);if(bundle)visible.push(bundle.product);
      return `<p class="avs-kicker">${this.tx('accessory_eyebrow')}</p><h2>${this.tx('accessory_title')}</h2><p class="avs-copy">${this.tx('accessory_copy')}</p>${bundle?`<div class="avs-package"><p class="avs-kicker">${this.tx('package_eyebrow')}</p><h3>${this.tx('package_title')}</h3><p>${this.tx('package_copy')}</p><p>${this.tx('package_items')} ${bundle.stylusIncluded?this.tx('package_stylus'):''}</p><strong class="avs-package-price">${this.price(bundle.product,bundle.variant)}</strong><label><input type="checkbox" data-field="package" data-focus="package" ${this.state.mouseBundle?'checked':''}>${this.tx('package_choose')}</label></div>`:''}${['screen','keyboard','stylus','desk'].map(category=>{const selectedId=this.state.addons.find(id=>findVariant(this.catalog,id)?.product.category===category);const chosen=selectedId?findVariant(this.catalog,selectedId):null;const blocked=category==='screen'&&p.screenPolicy!=='open'?'screen_block':category==='keyboard'&&(p.keyboardIncluded||this.state.mouseBundle)?'keyboard_block':category==='stylus'&&setup?.bundle?.stylusIncluded?'stylus_block':'';const products=this.products.filter(p=>p.category===category&&this.fit(p).length);if(!blocked)products.forEach(p=>visible.push(p));return `<section class="avs-accessory-group"><h3>${this.tx(category+'_title')}</h3><p>${this.tx(category+'_copy')}</p>${blocked?`<div class="avs-lock">${this.tx(blocked)}</div>`:!products.length?`<p class="avs-empty">${this.tx('no_accessories')}</p>`:`<button type="button" class="avs-skip" data-action="addon" data-category="${category}" data-value="0" data-focus="none-${category}" aria-pressed="${!chosen}"><span>${this.tx('none')}</span><span>${this.tx('no_addition')}</span></button>${products.map(item=>{const active=chosen?.product.id===item.id;const variant=active?chosen.variant:this.variant(item);const inCart=this.existing?.items.some(i=>i.variant_id===variant.id);return `<div class="avs-addon ${active?'is-selected':''}"><button type="button" class="avs-addon-main" data-action="addon" data-category="${category}" data-value="${active?0:variant.id}" data-focus="addon-${item.id}" aria-pressed="${active}">${this.img(variant.image,'',180)}<span><strong>${esc(item.name)}</strong><small>${esc(item.features[0])}</small><b>${inCart?this.tx('duplicate'):this.price(item,variant)}</b></span><span aria-hidden="true">${active?'✓':'+'}</span></button>${active?`<div class="avs-addon-detail"><p>${esc(item.description)}</p><label><span class="avs-field-label">${esc(item.name)} ${this.tx('option')}</span><select data-field="addon" data-category="${category}" data-focus="option-${item.id}">${this.fit(item).map(x=>`<option value="${x.id}" ${variant.id===x.id?'selected':''}>${esc(x.title)} · ${this.price(item,x)}</option>`).join('')}</select></label><a class="avs-link" href="${esc(this.root+'products/'+item.handle)}" target="_blank" rel="noopener">${this.tx('product_details')} ↗</a></div>`:''}</div>`;}).join('')}`}</section>`;}).join('')}<button type="button" class="avs-button avs-next" data-action="tab" data-value="review">${this.tx('review')} →</button>`;
    }
    renderReview(p,v,d,setup,visible){if(!setup)return `<p class="avs-empty">${this.tx('choose_first')}</p>`;setup.lines.forEach(l=>visible.push(l.product));const lines=this.existing?setup.lines:setup.lines;return `<p class="avs-kicker">${this.tx('review_eyebrow')}</p><h2>${this.tx('review_title')}</h2><p class="avs-copy">${this.tx('review_copy',{model:d.name})}</p><div class="avs-review-device"><span>${esc(d.name)}<br><span class="avs-fine">${esc(v.color)}</span></span><button type="button" class="avs-link" data-action="tab" data-value="case">${this.tx('edit')}</button></div>${lines.map((l,i)=>{const existing=this.existing&&(i===0||this.existing.items.some(x=>x.variant_id===l.variant.id));return `<div class="avs-review-line">${this.img(l.variant.image,'',130)}<div><h3>${esc(l.product.name)}</h3><p>${esc(l.variant.title)}</p>${i===0&&setup.bundle?`<p>${this.tx('package_items')} ${setup.bundle.stylusIncluded?this.tx('package_stylus'):''}</p>`:''}</div><div><strong>${existing?this.tx('existing_label'):this.price(l.product,l.variant)}</strong>${i>0?`<br><button type="button" class="avs-link" data-action="addon" data-category="${l.product.category}" data-value="0" aria-label="${this.tx('remove')} ${esc(l.product.name)}">${this.tx('remove')}</button>`:''}</div></div>`;}).join('')}<div class="avs-total"><span>${this.tx(this.existing?'addition_subtotal':'subtotal')}</span><strong>${this.totalPrice(setup)}</strong></div><p class="avs-fine">${this.tx('total_note')}</p>${this.quote?`<p class="avs-success" role="status">✓ ${this.tx('verified')}</p>`:''}<button type="button" class="avs-button avs-next" data-action="${this.quote?'add':'check'}" ${this.busy||this.uncertain||this.cartBlocked?'disabled':''}>${this.busy?this.tx(this.adding?'adding':'checking'):this.quote?this.tx(this.existing?'add_accessories':'add_to_bag'):this.tx('check')} →</button><button type="button" class="avs-link" data-action="tab" data-value="accessories">← ${this.tx('back')}</button>`;}
    totalPrice(setup){if(this.quote)return esc(this.currency(this.quote.total));if(!setup)return this.tx('pick_model');const lines=this.existing?setup.lines.slice(1).filter(l=>!this.existing.items.some(x=>x.variant_id===l.variant.id)):setup.lines;const live=lines.map(l=>this.live.get(l.product.handle)?.variants.find(v=>v.id===l.variant.id));return live.every(v=>v&&v.available)?esc(this.currency(live.reduce((s,v)=>s+v.price,0))):this.tx('price_loading');}
    renderBar(p,v,setup){const label=!this.device()?'pick_model':this.busy?(this.adding?'adding':'checking'):this.tab==='case'?'next':this.tab==='accessories'?'review':this.quote?(this.existing?'add_accessories':'add_to_bag'):'check';return `<div class="avs-bar"><div class="avs-bar-selection"><small>${this.tx('your_setup')}</small><strong>${esc(p.name)} · ${esc(v.color)}</strong></div><div class="avs-bar-right"><div class="avs-bar-price"><small>${this.tx(this.existing?'addition_subtotal':'subtotal')}</small><strong>${this.totalPrice(setup)}</strong></div><button type="button" class="avs-button" data-action="bar" ${this.busy||this.uncertain||this.cartBlocked||this.pendingCart?'disabled':''}>${this.tx(label)} →</button></div></div>`;}
    renderEdits(){return `<section class="avs-edits"><p class="avs-kicker">${this.tx('edit_eyebrow')}</p><h2>${this.tx('edit_title')}</h2><div class="avs-edit-grid">${[['focus','ultrashield-privacy'],['ideas','papertouch'],['travel','avontic-workforce-fold']].map(([id,prefix])=>{const p=this.products.find(p=>p.handle.startsWith(prefix));return `<button type="button" class="avs-edit" data-action="edit" data-value="${id}"><span class="avs-edit-visual">${this.img(p.image,'',650)}</span><h3>${this.tx(id+'_title')}</h3><p>${this.tx(id+'_copy')}</p><span class="avs-link">${this.tx('edit_action')} ↗</span></button>`;}).join('')}</div><p class="avs-fine">${this.tx('edit_note')}</p></section>`;}
  }
  customElements.define('avontic-setup-studio',AvonticStudio);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-premium-watch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('avontic-watch-campaign')) {
  class AvonticWatchCampaign extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.model = 'all'; this.limit = 24; this.titaniumAll = false; this.womenAll = false;
      this.copy = JSON.parse(this.querySelector('[data-watch-copy]').textContent);
      this.ranks = JSON.parse(this.querySelector('[data-watch-ranks]').textContent);
      this.catalog = new Map();
      this.bind(); this.load();
    }
    q(selector) { return this.querySelector(selector); }
    addCards(template) {
      template.content.querySelectorAll('[data-watch-card]').forEach(card => {
        if (this.catalog.has(card.dataset.id)) return;
        const d = card.dataset;
        this.catalog.set(d.id, {node:card, id:d.id, created:Number(d.created), price:Number(d.price), titaniumPrice:Number(d.titaniumPriceAmount), models:d.models.split('|'), kind:d.kind, titanium:d.titanium === 'true', women:d.women === 'true', womenPriority:d.womenPriority === 'true', rank:Number(this.ranks[d.id]) || Number.MAX_SAFE_INTEGER});
      });
    }
    async load() {
      const template = this.q('[data-watch-catalog]');
      this.addCards(template);
      this.render();
      let next = template.dataset.next;
      const visited = new Set();
      try {
        while (next) {
          const url = new URL(next, location.href);
          url.searchParams.set('view', 'avontic-premium-watch');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          if (visited.has(url.href)) throw new Error('Repeated collection page');
          visited.add(url.href);
          const response = await fetch(url.href, {credentials:'same-origin'});
          if (!response.ok) throw new Error('Collection request failed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const more = page.querySelector('[data-watch-catalog]');
          if (!more) throw new Error('Collection response incomplete');
          this.addCards(more); next = more.dataset.next;
        }
      } catch (error) {
        this.loadError = true;
      }
      this.querySelectorAll('button[disabled],select[disabled]').forEach(control => { control.disabled = false; });
      this.render();
      this.dataset.ready = 'true';
    }
    bind() {
      this.querySelectorAll('[data-model]').forEach(button => button.addEventListener('click', () => {
        this.model = button.dataset.model; this.limit = 24; this.titaniumAll = false; this.womenAll = false;
        this.querySelectorAll('[data-model]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.render();
      }));
      this.q('[data-kind-select]').addEventListener('change', () => { this.limit = 24; this.renderCatalog(); });
      this.q('[data-sort-select]').addEventListener('change', () => { this.limit = 24; this.renderCatalog(); });
      this.q('[data-titanium-sort]').addEventListener('change', () => this.renderTitanium());
      this.q('[data-show-more]').addEventListener('click', () => { this.limit += 24; this.renderCatalog(true); });
      this.q('[data-titanium-more]').addEventListener('click', () => { this.titaniumAll = true; this.renderTitanium(true); });
      this.q('[data-women-more]').addEventListener('click', () => { this.womenAll = true; this.renderWomen(true); });
    }
    products() { return [...this.catalog.values()].filter(p => this.model === 'all' || p.models.includes(this.model)); }
    sorted(items, sort) {
      return [...items].sort((a,b) => {
        if (sort === '2026') return a.rank - b.rank || b.created - a.created;
        const titaniumOnly = this.q('[data-kind-select]').value === 'titanium';
        const priceA = titaniumOnly ? a.titaniumPrice || a.price : a.price;
        const priceB = titaniumOnly ? b.titaniumPrice || b.price : b.price;
        if (sort === 'price-low') return priceA - priceB || b.created - a.created;
        if (sort === 'price-high') return priceB - priceA || b.created - a.created;
        return b.created - a.created;
      });
    }
    paint(target, items, badge, focusNew = false) {
      const grid = this.q(target);
      const previous = grid.children.length;
      const fragment = document.createDocumentFragment();
      items.forEach((item,index) => {
        const node = item.node.cloneNode(true);
        if ((target === '[data-titanium-grid]' || (target === '[data-product-grid]' && this.q('[data-kind-select]').value === 'titanium')) && node.dataset.titaniumPrice) {
          node.querySelector('[data-card-price]').textContent = node.dataset.titaniumPrice;
          node.querySelectorAll('a').forEach(link => { link.href = node.dataset.titaniumUrl; });
          if (node.dataset.titaniumImage) {
            const photo = node.querySelector('img');
            photo.src = node.dataset.titaniumImage; photo.removeAttribute('srcset');
          }
        }
        const label = node.querySelector('[data-card-badge]');
        if (badge === 'new' || (badge === 'best' && index < 4 && item.rank < Number.MAX_SAFE_INTEGER)) {
          label.hidden = false;
          label.textContent = badge === 'new' ? this.copy.newBadge : this.copy.bestBadge;
        }
        fragment.append(node);
      });
      grid.replaceChildren(fragment);
      if (focusNew && items.length > previous) grid.children[previous]?.querySelector('h3 a')?.focus({preventScroll:true});
    }
    render() {
      this.paint('[data-new-grid]', this.sorted(this.products(), 'newest').slice(0,4), 'new');
      this.renderTitanium(); this.renderWomen(); this.renderCases(); this.renderCatalog();
    }
    renderCases() {
      const section = this.q('[data-case-section]');
      if (!section) return;
      let visible = 0;
      section.querySelectorAll('[data-featured-case]').forEach(card => {
        card.hidden = this.model !== 'all' && !card.dataset.caseModels.split('|').includes(this.model);
        if (!card.hidden) visible += 1;
      });
      section.hidden = visible === 0;
      const link = this.q(`a[href="#${section.id}"]`);
      if (link) link.hidden = visible === 0;
    }
    renderTitanium(focusNew = false) {
      const sort = this.q('[data-titanium-sort]').value;
      const products = this.sorted(this.products().filter(p => p.titanium), sort);
      const shown = this.titaniumAll ? products : products.slice(0,12);
      this.paint('[data-titanium-grid]', shown, sort === '2026' ? 'best' : '', focusNew);
      this.querySelectorAll('[data-titanium-total]').forEach(count => { count.textContent = products.length; });
      this.q('[data-titanium-empty]').hidden = products.length > 0;
      this.q('[data-titanium-more]').hidden = shown.length >= products.length;
      this.q('[data-titanium-more-label]').textContent = this.copy.allTitanium.replace('{count}', products.length);
      this.q('[data-titanium-shown]').textContent = products.length ? `${shown.length} / ${products.length} ${this.copy.shown}` : '';
    }
    renderWomen(focusNew = false) {
      const products = this.products().filter(p => p.women).sort((a,b) => Number(b.womenPriority) - Number(a.womenPriority) || a.rank - b.rank || b.created - a.created);
      const shown = this.womenAll ? products : products.slice(0,8);
      this.paint('[data-women-grid]', shown, '', focusNew);
      this.q('[data-women-count]').textContent = `${products.length} ${this.copy.products}`;
      this.q('[data-women-empty]').hidden = products.length > 0;
      this.q('[data-women-more]').hidden = shown.length >= products.length;
    }
    renderCatalog(focusNew = false) {
      const kind = this.q('[data-kind-select]').value;
      const sort = this.q('[data-sort-select]').value;
      const products = this.sorted(this.products().filter(p => kind === 'all' || (kind === 'titanium' ? p.titanium : kind === 'women' ? p.women : p.kind === kind)), sort);
      const shown = products.slice(0,this.limit);
      this.paint('[data-product-grid]', shown, sort === '2026' ? 'best' : '', focusNew);
      this.q('[data-results]').textContent = this.loadError ? this.copy.error : `${products.length} ${this.copy.products}`;
      this.q('[data-shown]').textContent = products.length ? `${shown.length} / ${products.length} ${this.copy.shown}` : '';
      this.q('[data-show-more]').hidden = shown.length >= products.length;
      this.q('[data-empty]').hidden = products.length > 0;
    }
  }
  customElements.define('avontic-watch-campaign', AvonticWatchCampaign);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-rhinoguard-smartfit-product-bridge"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.smartfitBridgeReady === 'true') return;
      root.dataset.smartfitBridgeReady = 'true';
      const device = root.querySelector('[data-avsfp-device]');
      const links = [...root.querySelectorAll('[data-avsfp-link]')];
      const params = new URLSearchParams(window.location.search);
      let model = params.get('smartfit_model') || '';

      if (!model) {
        try {
          model = window.localStorage.getItem('avonticSmartFitIpad') || '';
        } catch (error) {
          model = '';
        }
      }

      if (!model) return;
      if (device) {
        device.textContent = `${root.dataset.devicePrefix}: ${model}`;
        device.hidden = false;
      }
      links.forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('smartfit_model', model);
        link.href = url.toString();
      });
    };

    const boot = () => document.querySelectorAll('.avsfp').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-rhinoguard-smartfit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.smartfitReady === 'true') return;
      root.dataset.smartfitReady = 'true';

      const model = root.querySelector('[data-avsf-model]');
      const routes = [...root.querySelectorAll('[data-avsf-route]')];
      const cards = [...root.querySelectorAll('[data-avsf-card]')];
      const links = [...root.querySelectorAll('[data-avsf-product-link]')];
      const status = root.querySelector('[data-avsf-status]');
      const selectedLabel = root.dataset.selectedLabel || '';

      const setRoute = (route) => {
        routes.forEach((button) => {
          const active = button.dataset.avsfRoute === route;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        cards.forEach((card) => {
          card.classList.toggle('is-recommended', card.dataset.avsfCard === route);
        });
      };

      const applyModel = (value) => {
        links.forEach((link) => {
          const url = new URL(link.href, window.location.origin);
          if (value) {
            url.searchParams.set('smartfit_model', value);
          } else {
            url.searchParams.delete('smartfit_model');
          }
          link.href = url.toString();
        });
        if (status && value) status.textContent = `${selectedLabel}: ${value}`;
        if (value) {
          try {
            window.localStorage.setItem('avonticSmartFitIpad', value);
          } catch (error) {
            return;
          }
        }
      };

      routes.forEach((button) => {
        button.addEventListener('click', () => setRoute(button.dataset.avsfRoute));
      });

      if (model) {
        let saved = '';
        try {
          saved = window.localStorage.getItem('avonticSmartFitIpad') || '';
        } catch (error) {
          saved = '';
        }
        if (saved && [...model.options].some((option) => option.value === saved)) model.value = saved;
        if (model.value) applyModel(model.value);
        model.addEventListener('change', () => applyModel(model.value));
      }
    };

    const boot = () => document.querySelectorAll('.avsf').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avontic-studio-product-feature"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('avontic-studio-feature')){customElements.define('avontic-studio-feature',class extends HTMLElement{
connectedCallback(){if(this.controller)return;this.controller=new AbortController();const options={signal:this.controller.signal};this.addEventListener('click',event=>{const link=event.target.closest('.avsf__button');if(!link||!this.dataset.kind)return;const variant=this.form()?.querySelector('[name="id"]')?.value;this.updateLink(variant);},options);document.addEventListener('variant:change',event=>{if(!this.dataset.kind||event.target!==this.form())return;const variant=event.detail?.variant;if(!variant)return;this.updateLink(variant.id);const image=this.querySelector('.avsf__hero-image');const src=variant.featured_image?.src||variant.featured_media?.preview_image?.src;if(image&&src){const url=new URL(src,location.origin);url.searchParams.set('width','900');image.removeAttribute('srcset');image.src=url.href;}},{...options,capture:true});}
form(){return document.querySelector('form[id^="product-form-main-'+this.dataset.productId+'-"]');}
updateLink(id){if(!id||!/^\d+$/.test(String(id)))return;const link=this.querySelector('.avsf__button');const url=new URL(link.href);url.searchParams.set('variant',id);link.href=url.href;}
disconnectedCallback(){this.controller?.abort();this.controller=null;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avpp_protection_planner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const FALLBACK_PRODUCTS = [
      {
        id: "display-rhinoguard-pro",
        title: "RhinoGuard Pro Rugged iPad Case with Hand Strap Shoulder Strap and Kickstand",
        handle: "rhinoguard-shockproof-ipad-case-with-stand-hand-strap-shoulder-strap-military-grade-protective-cover-for-ipad-pro-ipad-air-ipad-all-sizes",
        productType: "iPad 2026",
        tags: ["iPad", "RhinoGuard"],
        image: "https://cdn.shopify.com/s/files/1/0168/9658/9888/files/ChatGPT_Image_Jun_25_2026_08_55_42_AM_1.png?v=1782392172",
        variants: [
          ["42655012651051", "Black-Black / iPad Air 13 (2024 M2 / 2025 M3 / 2026 M4)"],
          ["42655012618283", "Black-Black / iPad Air 11 (2024 M2 / 2025 M3 / 2026 M4)"],
          ["42655012225067", "Black-Black / iPad 11-inch A16 / 11th Gen (2025)"],
          ["42655012716587", "Black-Black / iPad Pro 13-inch M4/M5 (2024-2025)"],
          ["42655012683819", "Black-Black / iPad Pro 11-inch M4/M5 (2024-2025)"],
          ["42655013863467", "Black-Black / iPad 10th Gen 10.9-inch (2022)"]
        ].map((item) => ({ id: item[0], title: item[1], available: true, price: 89.99, compareAtPrice: 159.99 }))
      },
      {
        id: "display-carbonarc",
        title: "RhinoGuard CarbonArc — Samsung Galaxy Z Fold MagSafe Stand Case",
        handle: "rhinoguard-carbonarc-samsung-galaxy-z-fold-magsafe-stand-case",
        productType: "RhinoGuard Phone Cases",
        tags: ["Samsung Galaxy Z Fold", "MagSafe", "Kickstand"],
        image: "https://cdn.shopify.com/s/files/1/0168/9658/9888/files/rhinoguard-carbonarc-samsung-galaxy-z-fold-magsafe-stand-case-black.jpg?v=1784375148",
        variants: [
          ["44424275230763", "Black / Samsung Galaxy Z Fold8 Ultra"],
          ["44424275820587", "Black / Samsung Galaxy Z Fold8"],
          ["44424275427371", "Black / Samsung Galaxy Z Fold7"],
          ["44424275361835", "Black / Samsung Galaxy Z Fold6"],
          ["44424275394603", "Black / Samsung Galaxy Z Fold5"],
          ["44424275263531", "Black / Samsung Galaxy Z Fold4"],
          ["44424275296299", "Black / Samsung Galaxy Z Fold3 5G"]
        ].map((item) => ({ id: item[0], title: item[1], available: true, price: 89.99, compareAtPrice: null }))
      },
      {
        id: "display-titanforge",
        title: "TitanForge Apex Titanium Elite Band – Precision Crafted for Garmin 22mm 26mm",
        handle: "garminguard-titanium-elite-band-precision-crafted-for-fenix-8-amoled",
        productType: "Garmin Fenix 8",
        tags: ["Garmin", "Titanium", "QuickFit"],
        image: "https://cdn.shopify.com/s/files/1/0168/9658/9888/files/10cc4286-6c1d-4899-9764-b8fae76e56c2.png?v=1778876461",
        variants: [
          ["41192746582059", "Black Apex / 26mm"],
          ["41192746549291", "Black Apex / 22mm"],
          ["41192746516523", "Dark Gray Apex / 26mm"],
          ["41192746483755", "Dark Gray Apex / 22mm"],
          ["41192746647595", "Silver Apex / 26mm"],
          ["41192746614827", "Silver Apex / 22mm"]
        ].map((item) => ({ id: item[0], title: item[1], available: true, price: 149.99, compareAtPrice: null }))
      },
      {
        id: "display-chargestation",
        title: "Avontic ChargeStation 7™ Multi-Device Wireless Charger & iPad Stand",
        handle: "avontic-chargestation-7™-multi-device-wireless-charger-ipad-stand",
        productType: "2026 Charge Station",
        tags: ["Charging", "Multi-device"],
        image: "https://cdn.shopify.com/s/files/1/0168/9658/9888/files/ChatGPT_Image_Jul_15_2026_09_12_41_AM.png?v=1784121205",
        variants: [
          { id: "44405926592555", title: "Black", available: true, price: 79.99, compareAtPrice: 109.99 },
          { id: "44405926559787", title: "White", available: true, price: 79.99, compareAtPrice: 109.99 }
        ]
      }
    ];

    const CATEGORY_PATTERNS = {
      tablet: /ipad|galaxy tab|surface (?:pro|go|book)|tablet/i,
      phone: /iphone|galaxy (?:s|z|note|a)\d|galaxy z (?:fold|flip)|pixel (?:fold|\d)|motorola|razr|phone case/i,
      wearable: /watch|fitbit|garmin|marq|quickfit|wearable|smartwatch|band/i
    };

    const BRAND_PATTERNS = {
      Apple: /apple|ipad|iphone|iwatch/i,
      Samsung: /samsung|galaxy/i,
      Google: /google|pixel/i,
      Microsoft: /microsoft|surface/i,
      Motorola: /motorola|razr/i,
      Fitbit: /fitbit/i,
      Garmin: /garmin|quickfit|fenix|epix|descent/i,
      MARQ: /marq/i
    };

    const SIGNAL_PATTERNS = {
      rugged: /rugged|heavy duty|armor|armored|defender|shockproof/i,
      slim: /slim|ultra.?thin|minimal/i,
      screen: /screen protector|screen guard|tempered glass|screen protection/i,
      hinge: /hinge/i,
      grip: /hand strap|hand grip|secure grip/i,
      stand: /kickstand|built.?in stand|stand case/i,
      rotate: /360|rotating hand strap/i,
      shoulder: /shoulder strap/i,
      keyboard: /keyboard/i,
      magnetic: /magnetic|magsafe/i,
      charging: /charg(?:e|er|ing)|wireless/i,
      light: /lightweight|ultralight/i,
      metal: /titanium|stainless steel|aluminum|alloy/i,
      water: /water|sweat|silicone|fluororubber/i,
      clean: /easy clean|wipe clean/i,
      quick: /quick install|snap.?on|tool.?free/i,
      professional: /professional|executive|leather|titanium|stainless/i,
      fabric: /fabric|nylon|weave|woven/i,
      carbon: /carbon/i
    };

    const CHOICE_TO_SIGNAL = {
      maximum_rugged: "rugged",
      balanced: "rugged",
      slim: "slim",
      screen: "screen",
      hinge: "hinge",
      grip: "grip",
      stand: "stand",
      rotate: "rotate",
      shoulder: "shoulder",
      keyboard: "keyboard",
      magnetic: "magnetic",
      charging: "charging",
      light: "light",
      metal: "metal",
      water: "water",
      clean: "clean",
      quick: "quick",
      professional: "professional",
      rugged: "rugged",
      minimal: "professional",
      premium: "professional",
      sport: "water",
      classic: "metal",
      fabric: "fabric",
      silicone: "water",
      fluororubber: "water",
      titanium: "metal",
      stainless: "metal",
      carbon: "carbon"
    };

    const DEFAULT_ANSWERS = {
      category: "",
      brand: "",
      device: "",
      modelCode: "",
      additionalDevice: "",
      useCases: [],
      priorities: [],
      styles: [],
      materials: [],
      color: "",
      priceRange: "best"
    };

    function normalize(value) {
      return String(value || "")
        .toLowerCase()
        .replace(/[™®©]/g, "")
        .replace(/[^a-z0-9]+/g, " ")
        .trim()
        .replace(/\s+/g, " ");
    }

    function escapeHtml(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function format(template, values) {
      return Object.keys(values).reduce((text, key) => text.split("{" + key + "}").join(String(values[key])), String(template || ""));
    }

    function mapCatalog(data) {
      return (data && Array.isArray(data.products) ? data.products : []).map((product) => {
        const images = (product.images || []).map((image) => typeof image === "string" ? image : image.src).filter(Boolean);
        const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || "").split(",").map((tag) => tag.trim()).filter(Boolean);
        return {
          id: String(product.id),
          title: product.title || "",
          handle: product.handle || "",
          productType: product.product_type || "",
          tags: tags,
          image: images[0] || (product.image && product.image.src) || "",
          variants: (product.variants || []).map((variant) => ({
            id: String(variant.id),
            title: variant.title || "",
            available: variant.available !== false,
            price: Number(variant.price || 0),
            compareAtPrice: variant.compare_at_price ? Number(variant.compare_at_price) : null
          }))
        };
      }).filter((product) => product.handle && product.variants.length);
    }

    function productCorpus(product) {
      return [product.title, product.productType, (product.tags || []).join(" ")].concat((product.variants || []).map((variant) => variant.title)).join(" ");
    }

    function matchesCategory(product, category) {
      return category === "multiple" || Boolean(CATEGORY_PATTERNS[category] && CATEGORY_PATTERNS[category].test(productCorpus(product)));
    }

    function matchesBrand(product, brand) {
      return !BRAND_PATTERNS[brand] || BRAND_PATTERNS[brand].test(productCorpus(product));
    }

    function candidateFromVariant(title) {
      const segments = String(title || "").split(" / ").map((part) => part.trim()).filter(Boolean);
      const start = segments.findIndex((segment, index) => index > 0 && /\d|ipad|iphone|galaxy|pixel|surface|watch|fitbit|garmin|marq|razr|quickfit/i.test(segment));
      return start > 0 ? segments.slice(start).join(" / ") : String(title || "");
    }

    function ipadSignature(value) {
      const source = String(value || "").toLowerCase();
      const text = normalize(source);
      if (!/\bipad\b/.test(text)) return null;
      const family = (text.match(/ipad\s+(air|pro|mini)\b/) || [])[1] || "";
      const size = (text.match(/\bipad(?:\s+(?:air|pro|mini))?\s+(7\.9|8\.3|9\.7|10\.2|10\.5|10\.9|11|12\.9|13)(?:\s*(?:inch|in))?\b/) || [])[1] || "";
      const collect = (pattern) => {
        const values = [];
        let match;
        while ((match = pattern.exec(source))) values.push(match[1]);
        return values.filter((item, index, list) => list.indexOf(item) === index);
      };
      const chips = collect(/\b(m\d+)\b/g);
      const years = collect(/\b(20\d{2})\b/g);
      const generations = collect(/\b(\d+)(?:st|nd|rd|th)\s*(?:generation|gen)?\b/g)
        .concat(collect(/\b(?:generation|gen)\s*(\d+)\b/g))
        .filter((item, index, list) => list.indexOf(item) === index);
      const groups = [];
      if (family === "pro" && size === "11") {
        if (chips.some((chip) => ["m4", "m5"].includes(chip)) || years.some((year) => ["2024", "2025"].includes(year))) groups.push("ipad-pro-11-m4-m5");
        if (generations.some((generation) => ["1", "2"].includes(generation)) || years.some((year) => ["2018", "2020"].includes(year))) groups.push("ipad-pro-11-gen1-2");
        if (generations.some((generation) => ["3", "4"].includes(generation)) || years.some((year) => ["2021", "2022"].includes(year))) groups.push("ipad-pro-11-gen3-4");
      }
      return {
        text: text,
        family: family,
        size: size,
        chips: chips,
        years: years,
        generations: generations,
        fitGroup: groups.length === 1 ? groups[0] : groups.length > 1 ? "conflict" : ""
      };
    }

    function strictDeviceMatch(product, variant, exactDevice) {
      const target = ipadSignature(exactDevice);
      if (!target) return null;

      const variantFit = ipadSignature(candidateFromVariant(variant.title));
      const productFit = ipadSignature(product.title);
      const fit = variantFit || (/^default title$/i.test(variant.title || "") ? productFit : null);
      if (!fit) return false;
      if (target.family && fit.family !== target.family) return false;
      if (target.size && fit.size !== target.size) return false;
      if (!target.chips.length && !target.years.length && !target.generations.length) return false;
      if (target.fitGroup === "conflict" || fit.fitGroup === "conflict") return false;
      if (target.fitGroup && fit.fitGroup && target.fitGroup !== fit.fitGroup) return false;
      if (target.chips.length && !target.chips.some((chip) => fit.chips.includes(chip))) return false;
      if (target.years.length && !target.years.some((year) => fit.years.includes(year))) return false;
      if (target.generations.length && !target.generations.some((generation) => fit.generations.includes(generation))) return false;
      return true;
    }

    function exactVariants(product, exactDevice) {
      const target = normalize(exactDevice);
      if (!target) return [];
      const engine = window.AvonticCompatibility;
      if (engine && typeof engine.resolveDevice === "function" && typeof engine.matchVariant === "function") {
        const profile = engine.resolveDevice(exactDevice);
        if (profile && profile.kind !== "unknown" && profile.groups && profile.groups.length && !profile.ambiguity) {
          return (product.variants || []).filter((variant) => variant.available && engine.matchVariant(product, variant, profile).matched);
        }
      }
      return (product.variants || []).filter((variant) => {
        if (!variant.available) return false;
        const strictMatch = strictDeviceMatch(product, variant, exactDevice);
        if (strictMatch !== null) return strictMatch;
        return normalize(candidateFromVariant(variant.title)) === target || normalize(variant.title) === target;
      });
    }

    function priceScore(price, range) {
      if (!range || range === "best") return 0;
      if (range === "under-50") return price < 50 ? 10 : -25;
      if (range === "50-100") return price >= 50 && price <= 100 ? 10 : -18;
      if (range === "100-150") return price > 100 && price <= 150 ? 10 : -18;
      if (range === "over-150") return price > 150 ? 10 : -10;
      return 0;
    }

    function init(root) {
      if (!root || root.dataset.avppReady === "true") return;
      root.dataset.avppReady = "true";

      const configNode = root.querySelector("[data-avpp-config]");
      if (!configNode) return;
      const config = JSON.parse(configNode.textContent);
      const strings = config.strings;
      const query = (selector) => root.querySelector(selector);
      const queryAll = (selector) => Array.from(root.querySelectorAll(selector));
      const stateKey = "avpp_planner_state_v3";
      const cacheKey = "avpp_catalog_v3";
      const plannerKeys = ["category", "brand", "device", "model", "additional", "uses", "priorities", "styles", "materials", "color", "price", "stage"];
      let products = [];
      let catalogStatus = "loading";
      let catalogFetchedAt = "";
      let answers = Object.assign({}, DEFAULT_ANSWERS);
      let step = 0;
      let comparison = [];
      let currentRecommendations = [];

      const stages = queryAll("[data-avpp-stage]");
      const progressButtons = queryAll("[data-avpp-progress-step]");
      const brandSelect = query("[data-avpp-brand]");
      const deviceInput = query("[data-avpp-device]");
      const modelInput = query("[data-avpp-model]");
      const additionalInput = query("[data-avpp-additional]");
      const colorInput = query("[data-avpp-color]");
      const priceSelect = query("[data-avpp-price]");
      const labels = {};

      queryAll("[data-avpp-list]").forEach((button) => {
        const text = button.querySelector("strong") ? button.querySelector("strong").textContent : button.textContent;
        labels[button.dataset.value] = String(text || "").trim();
      });

      function track(eventName, detail) {
        const payload = Object.assign({ event: eventName }, detail || {});
        window.dispatchEvent(new CustomEvent("avontic:analytics", { detail: payload }));
        try {
          if (window.localStorage.getItem("avpp_analytics_consent") === "granted") {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(payload);
          }
        } catch (error) {
          return;
        }
      }

      function pathWithParams(path, params) {
        const url = new URL(config.root + path.replace(/^\//, ""), window.location.origin);
        Object.keys(params || {}).forEach((key) => {
          if (params[key]) url.searchParams.set(key, params[key]);
        });
        return url.pathname + url.search;
      }

      function money(value) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || "en-US", { style: "currency", currency: config.currency || "USD" }).format(value);
        } catch (error) {
          return "$" + Number(value || 0).toFixed(2);
        }
      }

      function restoreState() {
        const params = new URLSearchParams(window.location.search);
        const hasUrlState = plannerKeys.some((key) => params.has(key));
        if (!hasUrlState) {
          try {
            const stored = JSON.parse(window.sessionStorage.getItem(stateKey) || "null");
            if (stored && stored.answers) {
              answers = Object.assign({}, DEFAULT_ANSWERS, stored.answers);
              step = Math.min(4, Math.max(0, Number(stored.step) || 0));
            }
          } catch (error) {
            answers = Object.assign({}, DEFAULT_ANSWERS);
          }
          return;
        }
        const list = (key) => String(params.get(key) || "").split("|").filter(Boolean);
        const category = params.get("category") || "";
        answers = {
          category: ["tablet", "phone", "wearable", "multiple"].includes(category) ? category : "",
          brand: params.get("brand") || "",
          device: params.get("device") || "",
          modelCode: params.get("model") || "",
          additionalDevice: params.get("additional") || "",
          useCases: list("uses"),
          priorities: list("priorities"),
          styles: list("styles"),
          materials: list("materials"),
          color: params.get("color") || "",
          priceRange: params.get("price") || "best"
        };
        step = Math.min(4, Math.max(0, Number(params.get("stage")) || 0));
      }

      function writeState() {
        const params = new URLSearchParams(window.location.search);
        plannerKeys.forEach((key) => params.delete(key));
        const put = (key, value) => {
          if (value) params.set(key, value);
        };
        put("category", answers.category);
        put("brand", answers.brand);
        put("device", answers.device);
        put("model", answers.modelCode);
        put("additional", answers.additionalDevice);
        put("uses", answers.useCases.join("|"));
        put("priorities", answers.priorities.join("|"));
        put("styles", answers.styles.join("|"));
        put("materials", answers.materials.join("|"));
        put("color", answers.color);
        put("price", answers.priceRange);
        put("stage", String(step));
        try {
          window.history.replaceState({ avpp: true }, "", window.location.pathname + (params.toString() ? "?" + params.toString() : "") + window.location.hash);
          window.sessionStorage.setItem(stateKey, JSON.stringify({ answers: answers, step: step }));
        } catch (error) {
          return;
        }
      }

      function buildDeviceOptions() {
        const optionNode = query("[data-avpp-device-options]");
        if (!optionNode) return;
        if (!answers.category || !answers.brand) {
          optionNode.innerHTML = "";
          query("[data-avpp-device-help]").textContent = catalogStatus === "loading" ? strings.loading : format(strings.availableCount, { count: 0 });
          return;
        }
        const values = new Set();
        products.forEach((product) => {
          if (!matchesCategory(product, answers.category) || !matchesBrand(product, answers.brand)) return;
          product.variants.forEach((variant) => {
            if (!variant.available || /^default title$/i.test(variant.title)) return;
            const value = candidateFromVariant(variant.title);
            if (value.length >= 2 && value.length <= 120) values.add(value);
          });
        });
        const sorted = Array.from(values).sort((a, b) => a.localeCompare(b, undefined, { numeric: true })).slice(0, 600);
        optionNode.innerHTML = sorted.map((value) => '<option value="' + escapeHtml(value) + '"></option>').join("");
        query("[data-avpp-device-help]").textContent = catalogStatus === "loading" ? strings.loading : format(strings.availableCount, { count: sorted.length.toLocaleString() });
      }

      function choiceLabels(values) {
        return values.map((value) => labels[value] || value);
      }

      function canContinue() {
        if (step === 0) return Boolean(answers.category && answers.brand && answers.device);
        if (step === 1) return answers.useCases.length > 0;
        if (step === 2) return answers.priorities.length > 0;
        return true;
      }

      function updateBrandOptions() {
        const options = config.brands[answers.category] || [];
        brandSelect.innerHTML = '<option value="">' + escapeHtml(strings.chooseBrand) + '</option>' + options.map((brand) => '<option value="' + escapeHtml(brand.value) + '"' + (answers.brand === brand.value ? " selected" : "") + '>' + escapeHtml(brand.label) + '</option>').join("");
      }

      function updateSummary() {
        query("[data-avpp-summary-device]").textContent = answers.device ? [answers.brand, answers.device].filter(Boolean).join(" ") : strings.waitingDevice;
        query("[data-avpp-summary-use]").textContent = answers.useCases.length ? choiceLabels(answers.useCases.slice(0, 2)).join(" · ") : strings.addRoutine;
        query("[data-avpp-summary-priorities]").textContent = answers.priorities.length ? choiceLabels(answers.priorities.slice(0, 3)).join(" · ") : strings.addPriorities;
        const styleValues = answers.styles.concat(answers.materials).slice(0, 2);
        query("[data-avpp-summary-style]").textContent = styleValues.length ? choiceLabels(styleValues).join(" · ") : strings.optional;
        query("[data-avpp-edit]").hidden = !answers.device;
      }

      function render() {
        stages.forEach((stageNode, index) => {
          stageNode.hidden = index !== step;
        });
        progressButtons.forEach((button, index) => {
          button.disabled = index > step;
          button.classList.toggle("is-complete", index <= step);
          if (index === step) button.setAttribute("aria-current", "step");
          else button.removeAttribute("aria-current");
        });
        query("[data-avpp-progress-name]").textContent = strings.stages[step];
        queryAll("[data-avpp-category]").forEach((button) => {
          const selected = button.dataset.avppCategory === answers.category;
          button.classList.toggle("is-selected", selected);
          button.setAttribute("aria-pressed", String(selected));
          const icon = button.querySelector("i");
          if (icon) icon.textContent = selected ? "✓" : "+";
        });
        query("[data-avpp-device-form]").hidden = !answers.category;
        query("[data-avpp-additional-field]").hidden = answers.category !== "multiple";
        query("[data-avpp-device-label]").textContent = answers.category === "multiple" ? strings.devicePrimary : strings.deviceExact;
        updateBrandOptions();
        deviceInput.value = answers.device;
        modelInput.value = answers.modelCode;
        additionalInput.value = answers.additionalDevice;
        colorInput.value = answers.color;
        priceSelect.value = answers.priceRange;
        queryAll("[data-avpp-list]").forEach((button) => {
          const list = answers[button.dataset.avppList] || [];
          const selected = list.includes(button.dataset.value);
          button.classList.toggle("is-selected", selected);
          button.setAttribute("aria-pressed", String(selected));
          const icon = button.querySelector("i");
          if (icon) icon.textContent = selected ? "✓" : "+";
        });
        const back = query("[data-avpp-back]");
        back.textContent = step ? strings.back : strings.restart;
        const next = query("[data-avpp-next]");
        next.disabled = step < 4 && !canContinue();
        next.innerHTML = step < 4 ? escapeHtml(strings.continue) + ' <span aria-hidden="true">→</span>' : escapeHtml(strings.startOver);
        query("[data-avpp-skip]").hidden = step !== 3;
        updateSummary();
        if (step === 4) renderResults();
        writeState();
      }

      function recommendations() {
        if (!answers.category || !answers.brand || !answers.device) return [];
        const requested = answers.priorities.concat(answers.styles, answers.materials).map((choice) => CHOICE_TO_SIGNAL[choice]).filter(Boolean);
        const fieldContext = answers.useCases.some((value) => ["construction", "healthcare", "fleet", "fitness"].includes(value));
        const found = [];
        products.forEach((product) => {
          if (!matchesCategory(product, answers.category) || !matchesBrand(product, answers.brand)) return;
          const matches = exactVariants(product, [answers.device, answers.modelCode].filter(Boolean).join(" "));
          if (!matches.length) return;
          const corpus = productCorpus(product);
          const facts = Object.keys(SIGNAL_PATTERNS).filter((key) => SIGNAL_PATTERNS[key].test(corpus)).map((key) => config.signals[key]);
          const uniqueSignals = requested.filter((signal, index, list) => list.indexOf(signal) === index);
          const satisfied = uniqueSignals.filter((signal) => SIGNAL_PATTERNS[signal] && SIGNAL_PATTERNS[signal].test(corpus)).map((signal) => config.signals[signal]);
          const variant = matches[0];
          const score = 100 + satisfied.length * 12 + facts.length * 2 + (fieldContext && SIGNAL_PATTERNS.rugged.test(corpus) ? 8 : 0) + priceScore(variant.price, answers.priceRange);
          found.push({ product: product, variant: variant, facts: facts, satisfied: satisfied, score: score, exactEvidence: variant.title });
        });
        return found.sort((a, b) => b.score - a.score || a.product.title.localeCompare(b.product.title)).slice(0, 4);
      }

      function addOns(recommendationList) {
        const handles = new Set(recommendationList.map((item) => item.product.handle));
        return products.filter((product) => {
          if (handles.has(product.handle)) return false;
          if (!/(screen protector|tempered glass|charger|charging station|mount|stylus|keyboard)/i.test(productCorpus(product))) return false;
          return exactVariants(product, [answers.device, answers.modelCode].filter(Boolean).join(" ")).length > 0;
        }).slice(0, 3);
      }

      function productUrl(product, variant) {
        return pathWithParams("products/" + encodeURIComponent(product.handle), { variant: variant.id });
      }

      function productCard(item, rank) {
        const product = item.product;
        const variant = item.variant;
        const variants = exactVariants(product, [answers.device, answers.modelCode].filter(Boolean).join(" "));
        const selected = comparison.includes(product.handle);
        const compareDisabled = comparison.length >= 3 && !selected;
        const url = productUrl(product, variant);
        const facts = item.facts.slice(0, 3);
        const consider = facts.length ? format(strings.considerTemplate, { facts: facts.join(", ").toLowerCase() }) : strings.considerDefault;
        const media = product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" width="640" height="640" loading="lazy">' : '<span class="avpp-image-fallback" aria-hidden="true">AV</span>';
        const comparePrice = variant.compareAtPrice && variant.compareAtPrice > variant.price ? "<del data-avpp-card-compare-price>" + escapeHtml(money(variant.compareAtPrice)) + "</del>" : '<del data-avpp-card-compare-price hidden></del>';
        const select = variants.length > 1 ? '<label class="avpp-field avpp-field--compact"><span>' + escapeHtml(strings.variant) + '</span><select data-avpp-variant-select>' + variants.map((option) => '<option value="' + escapeHtml(option.id) + '"' + (option.id === variant.id ? " selected" : "") + '>' + escapeHtml(option.title) + '</option>').join("") + "</select></label>" : "";
        const satisfied = item.satisfied.length ? '<div><span>' + escapeHtml(strings.prioritiesSatisfied) + '</span><p>' + escapeHtml(item.satisfied.join(" · ")) + "</p></div>" : "";
        return '<article class="avpp-product-card ' + (rank === 0 ? "avpp-product-card--primary" : "") + '" data-avpp-card data-rec-index="' + rank + '">' +
          '<div class="avpp-product-card__media"><a href="' + escapeHtml(url) + '" data-avpp-product-link aria-label="' + escapeHtml(strings.viewDetails + ": " + product.title) + '">' + media + '</a><span class="avpp-product-card__badge">' + escapeHtml(rank === 0 ? strings.bestMatch : strings.alternative) + "</span></div>" +
          '<div class="avpp-product-card__body"><p class="avpp-kicker">' + escapeHtml(strings.exactConfirmed) + '</p><h3><a href="' + escapeHtml(url) + '" data-avpp-product-link>' + escapeHtml(product.title) + '</a></h3>' +
          '<div class="avpp-price-row"><strong data-avpp-card-price>' + escapeHtml(money(variant.price)) + "</strong>" + comparePrice + '<span class="avpp-availability"><i></i>' + escapeHtml(strings.available) + "</span></div>" +
          '<div class="avpp-evidence"><span>' + escapeHtml(strings.evidence) + '</span><strong data-avpp-card-evidence>' + escapeHtml(variant.title) + "</strong></div>" + select +
          '<div class="avpp-card-explain"><div><span>' + escapeHtml(strings.why) + "</span><p>" + escapeHtml(strings.whyText) + "</p></div>" + satisfied + '<div><span>' + escapeHtml(strings.consider) + "</span><p>" + escapeHtml(consider) + "</p></div></div>" +
          '<div class="avpp-product-card__actions"><form method="post" action="' + escapeHtml(config.cartAdd) + '" data-avpp-cart-form><input type="hidden" name="id" value="' + escapeHtml(variant.id) + '" data-avpp-cart-id><input type="hidden" name="quantity" value="1"><button class="avpp-button avpp-button--gold" type="submit" name="add">' + escapeHtml(strings.addToCart) + ' <span aria-hidden="true">+</span></button></form>' +
          '<a class="avpp-product-link" href="' + escapeHtml(url) + '" data-avpp-product-link>' + escapeHtml(strings.viewDetails) + ' ↗</a>' +
          '<label class="avpp-compare-check ' + (compareDisabled ? "is-disabled" : "") + '"><input type="checkbox" data-avpp-compare="' + escapeHtml(product.handle) + '"' + (selected ? " checked" : "") + (compareDisabled ? " disabled" : "") + ">" + escapeHtml(strings.compare) + '</label><p class="avpp-cart-message" data-avpp-cart-status role="status" aria-live="polite" hidden></p></div></div></article>';
      }

      function connectionCard(path, params, overline, title, eventName) {
        return '<a href="' + escapeHtml(pathWithParams(path, params)) + '"' + (eventName ? ' data-avpp-track="' + escapeHtml(eventName) + '"' : "") + '><span>' + escapeHtml(overline) + "</span><strong>" + escapeHtml(title) + '</strong><i aria-hidden="true">→</i></a>';
      }

      function renderConnections() {
        const size = (answers.device.match(/\d+(?:\.\d+)?(?:-inch|\s?mm|\s?inch)/i) || [""])[0];
        let html = connectionCard("pages/my-devices", { category: answers.category, brand: answers.brand, family: answers.device.split(" ").slice(0, 3).join(" "), model: answers.device, size: size, code: answers.modelCode }, strings.saveOverline, strings.save, "saved_to_my_devices");
        if (answers.category === "tablet") {
          html += connectionCard("pages/build-your-setup", { device: answers.device }, strings.tabletOverline, strings.tablet, "bundle_builder_clicked");
        }
        if (answers.category === "multiple" || answers.additionalDevice) {
          html += connectionCard("pages/build-your-loadout", { device: answers.device, additional: answers.additionalDevice }, strings.bundleOverline, strings.bundle, "bundle_builder_clicked");
        }
        if (answers.useCases.includes("fleet")) {
          html += connectionCard("pages/business-solutions", { device: answers.device }, strings.businessOverline, strings.business, "b2b_path_clicked");
        }
        return '<div class="avpp-connection-grid">' + html + "</div>";
      }

      function renderResults() {
        const target = query("[data-avpp-results]");
        currentRecommendations = recommendations();
        const hasMatches = currentRecommendations.length > 0;
        const heading = '<div class="avpp-results__heading"><div><p class="avpp-kicker">' + escapeHtml(strings.resultsKicker) + "</p><h2>" + escapeHtml(hasMatches ? strings.titleMatch : strings.titleNoMatch) + "</h2><p>" + escapeHtml(hasMatches ? format(strings.leadMatch, { device: [answers.brand, answers.device].filter(Boolean).join(" ") }) : strings.leadNoMatch) + '</p></div><button type="button" class="avpp-text-button" data-avpp-edit-results>' + escapeHtml(query("[data-avpp-edit]").textContent) + "</button></div>";
        if (!hasMatches) {
          const contactUrl = pathWithParams("pages/contact-us", { device: answers.device, model: answers.modelCode });
          target.innerHTML = heading + '<div class="avpp-no-match"><div class="avpp-no-match__lens" aria-hidden="true">?</div><div><h3>' + escapeHtml(strings.noMatchTitle) + "</h3><p>" + escapeHtml(strings.noMatchText) + '</p><a class="avpp-button avpp-button--gold" href="' + escapeHtml(contactUrl) + '">' + escapeHtml(strings.noMatchCta) + "</a></div></div>" + renderConnections();
          bindResults();
          return;
        }

        const cards = currentRecommendations.map(productCard).join("");
        const compareUrl = pathWithParams("pages/compare-products", { device: answers.device, compare: comparison.join(",") });
        const compareBar = '<div class="avpp-compare-bar"><div><span>' + escapeHtml(format(strings.selectedCount, { count: comparison.length })) + "</span><p>" + escapeHtml(strings.compareHelp) + '</p></div><a class="avpp-button ' + (comparison.length >= 2 ? "avpp-button--gold" : "is-disabled") + '" aria-disabled="' + String(comparison.length < 2) + '"' + (comparison.length < 2 ? ' tabindex="-1"' : "") + ' href="' + (comparison.length >= 2 ? escapeHtml(compareUrl) : "#") + '" data-avpp-compare-link>' + escapeHtml(strings.compareCta) + "</a></div>";
        const top = currentRecommendations[0];
        const priorityText = top.satisfied.length ? top.satisfied.join(", ") : strings.priorityEmpty;
        const why = '<div class="avpp-why"><div><p class="avpp-kicker">' + escapeHtml(strings.whyKicker) + "</p><h3>" + escapeHtml(strings.whyTitle) + '</h3></div><div class="avpp-why__steps"><div><span>' + escapeHtml(strings.deviceLabel) + "</span><p>" + escapeHtml(format(strings.deviceText, { evidence: top.exactEvidence })) + "</p></div><div><span>" + escapeHtml(strings.priorityLabel) + "</span><p>" + escapeHtml(priorityText) + "</p></div><div><span>" + escapeHtml(strings.tradeoffLabel) + "</span><p>" + escapeHtml(strings.tradeoffText) + "</p></div></div></div>";
        const additions = addOns(currentRecommendations);
        const addonHtml = additions.length ? '<div class="avpp-addons"><div class="avpp-section-heading"><p class="avpp-kicker">' + escapeHtml(strings.completeKicker) + "</p><h3>" + escapeHtml(strings.completeTitle) + '</h3></div><div class="avpp-addon-grid">' + additions.map((product) => {
          const variant = exactVariants(product, [answers.device, answers.modelCode].filter(Boolean).join(" "))[0];
          const url = variant ? productUrl(product, variant) : pathWithParams("products/" + encodeURIComponent(product.handle), {});
          const image = product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" width="280" height="280" loading="lazy">' : '<span class="avpp-image-fallback" aria-hidden="true">AV</span>';
          return '<a href="' + escapeHtml(url) + '" class="avpp-addon-card">' + image + "<span><strong>" + escapeHtml(product.title) + "</strong><small>" + escapeHtml(variant ? variant.title + " · " + money(variant.price) : strings.verifyOptions) + '</small></span><i aria-hidden="true">↗</i></a>';
        }).join("") + "</div></div>" : "";
        target.innerHTML = heading + '<div class="avpp-results__grid">' + cards + "</div>" + compareBar + why + addonHtml + renderConnections();
        bindResults();
      }

      function bindResults() {
        const target = query("[data-avpp-results]");
        const edit = target.querySelector("[data-avpp-edit-results]");
        if (edit) edit.addEventListener("click", () => {
          step = 0;
          render();
        });
        target.querySelectorAll("[data-avpp-product-link]").forEach((link) => link.addEventListener("click", () => {
          const card = link.closest("[data-avpp-card]");
          const item = card ? currentRecommendations[Number(card.dataset.recIndex)] : null;
          track("product_details_clicked", item ? { product_handle: item.product.handle } : {});
        }));
        target.querySelectorAll("[data-avpp-cart-form]").forEach((form) => form.addEventListener("submit", async (event) => {
          event.preventDefault();
          const card = form.closest("[data-avpp-card]");
          const item = card ? currentRecommendations[Number(card.dataset.recIndex)] : null;
          const variantId = form.querySelector("[data-avpp-cart-id]").value;
          const button = form.querySelector("button[type='submit']");
          const status = card.querySelector("[data-avpp-cart-status]");
          const idleHtml = button.innerHTML;
          button.disabled = true;
          button.textContent = strings.adding;
          status.hidden = true;
          status.textContent = "";
          track("add_to_cart_clicked", item ? { product_handle: item.product.handle, variant_id: variantId } : {});
          try {
            const shopRoot = config.root || "/";
            const sections = [];
            document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sections } }));
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
            const response = await fetch(shopRoot + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
              body: JSON.stringify({
                items: [{
                  id: Number(variantId),
                  quantity: 1,
                  properties: { "_Source": "Protection Planner", "_Device": answers.device }
                }],
                sections: sections.join(","),
                sections_url: window.location.pathname
              })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || strings.cartError);
            const cartResponse = await fetch(shopRoot + "cart.js", { headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" } });
            if (!cartResponse.ok) throw new Error(strings.cartError);
            const cart = await cartResponse.json();
            cart.sections = result.sections || {};
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "variant:add", onSuccessDo: "force_open", cart: cart } }));
            document.dispatchEvent(new CustomEvent("avontic:cart-updated", { detail: { source: "protection-planner", result: result, cart: cart, item_count: cart.item_count, sections: cart.sections } }));
            button.textContent = strings.added;
            status.hidden = false;
            status.textContent = strings.added;
            track("planner_add_to_cart", item ? { product_handle: item.product.handle, variant_id: variantId, currency: config.currency } : { variant_id: variantId, currency: config.currency });
            window.setTimeout(() => { button.innerHTML = idleHtml; }, 1800);
          } catch (error) {
            button.innerHTML = idleHtml;
            status.hidden = false;
            status.textContent = strings.cartError;
          } finally {
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
            button.disabled = false;
          }
        }));
        target.querySelectorAll("[data-avpp-variant-select]").forEach((select) => select.addEventListener("change", () => {
          const card = select.closest("[data-avpp-card]");
          const index = Number(card.dataset.recIndex);
          const item = currentRecommendations[index];
          const variant = item.product.variants.find((candidate) => candidate.id === select.value);
          if (!variant) return;
          item.variant = variant;
          item.exactEvidence = variant.title;
          card.querySelector("[data-avpp-card-price]").textContent = money(variant.price);
          const compareNode = card.querySelector("[data-avpp-card-compare-price]");
          if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
            compareNode.hidden = false;
            compareNode.textContent = money(variant.compareAtPrice);
          } else {
            compareNode.hidden = true;
            compareNode.textContent = "";
          }
          card.querySelector("[data-avpp-card-evidence]").textContent = variant.title;
          card.querySelector("[data-avpp-cart-id]").value = variant.id;
          const url = productUrl(item.product, variant);
          card.querySelectorAll("[data-avpp-product-link]").forEach((link) => link.setAttribute("href", url));
        }));
        target.querySelectorAll("[data-avpp-compare]").forEach((checkbox) => checkbox.addEventListener("change", () => {
          const handle = checkbox.dataset.avppCompare;
          if (checkbox.checked) comparison = comparison.concat(handle).slice(0, 3);
          else comparison = comparison.filter((item) => item !== handle);
          track("comparison_started", { product_count: comparison.length });
          renderResults();
        }));
        const compareLink = target.querySelector("[data-avpp-compare-link]");
        if (compareLink) compareLink.addEventListener("click", (event) => {
          if (comparison.length < 2) event.preventDefault();
        });
        target.querySelectorAll("[data-avpp-track]").forEach((link) => link.addEventListener("click", () => track(link.dataset.avppTrack)));
      }

      function updateStatus() {
        const title = query("[data-avpp-status-title]");
        const detail = query("[data-avpp-status-detail]");
        const dot = query("[data-avpp-status-dot]");
        title.textContent = catalogStatus === "live" ? strings.live : catalogStatus === "loading" ? strings.connecting : strings.fallback;
        detail.textContent = catalogFetchedAt ? format(strings.refreshed, { time: new Date(catalogFetchedAt).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) }) : strings.strict;
        dot.classList.toggle("is-live", catalogStatus === "live");
        query("[data-avpp-notice]").hidden = catalogStatus !== "fallback";
      }

      function renderOrbit() {
        const pick = (pattern, fallbackIndex) => products.find((product) => pattern.test(product.title + " " + product.productType) && product.image) || FALLBACK_PRODUCTS[fallbackIndex];
        const orbitProducts = [pick(/ipad|tablet/i, 0), pick(/phone|fold|iphone|galaxy s/i, 1), pick(/watch|garmin|fitbit|band/i, 2), pick(/charg/i, 3)];
        query("[data-avpp-orbit-products]").innerHTML = orbitProducts.map((product, index) => '<a class="avpp-orbit__product avpp-orbit__product--' + (index + 1) + '" href="' + escapeHtml(pathWithParams("products/" + encodeURIComponent(product.handle), {})) + '" aria-label="' + escapeHtml(product.title) + '"><img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" width="360" height="360"></a>').join("");
      }

      async function loadCatalog(force) {
        catalogStatus = "loading";
        catalogFetchedAt = "";
        updateStatus();
        if (!force) {
          try {
            const cached = JSON.parse(window.sessionStorage.getItem(cacheKey) || "null");
            if (cached && Date.now() - cached.savedAt < 20 * 60 * 1000 && cached.products && cached.products.length) {
              products = cached.products;
              catalogFetchedAt = cached.fetchedAt;
              catalogStatus = "live";
              updateStatus();
              buildDeviceOptions();
              renderOrbit();
              if (step === 4) renderResults();
              return;
            }
          } catch (error) {
            products = [];
          }
        }
        try {
          const combined = [];
          for (let page = 1; page <= 4; page += 1) {
            const response = await fetch(config.root + "products.json?limit=250&page=" + page, { headers: { Accept: "application/json" }, credentials: "same-origin" });
            if (!response.ok) throw new Error("catalog unavailable");
            const data = await response.json();
            const batch = mapCatalog(data);
            combined.push.apply(combined, batch);
            if (!data.products || data.products.length < 250) break;
          }
          if (!combined.length) throw new Error("empty catalog");
          products = combined;
          catalogFetchedAt = new Date().toISOString();
          catalogStatus = "live";
          try {
            window.sessionStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), fetchedAt: catalogFetchedAt, products: products }));
          } catch (error) {
            catalogFetchedAt = new Date().toISOString();
          }
        } catch (error) {
          products = [];
          catalogStatus = "fallback";
        }
        updateStatus();
        buildDeviceOptions();
        renderOrbit();
        if (step === 4) renderResults();
      }

      queryAll("[data-avpp-start]").forEach((button) => button.addEventListener("click", () => {
        track("protection_planner_started");
        query("[data-avpp-stage='0']").scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
      }));
      queryAll("[data-avpp-category]").forEach((button) => button.addEventListener("click", () => {
        answers.category = button.dataset.avppCategory;
        answers.brand = "";
        answers.device = "";
        track("device_category_selected", { category: answers.category });
        buildDeviceOptions();
        render();
      }));
      brandSelect.addEventListener("change", () => {
        answers.brand = brandSelect.value;
        answers.device = "";
        track("device_brand_selected", { brand: answers.brand });
        buildDeviceOptions();
        render();
      });
      deviceInput.addEventListener("input", () => {
        answers.device = deviceInput.value;
        updateSummary();
        query("[data-avpp-next]").disabled = !canContinue();
        writeState();
      });
      modelInput.addEventListener("input", () => {
        answers.modelCode = modelInput.value;
        writeState();
      });
      additionalInput.addEventListener("input", () => {
        answers.additionalDevice = additionalInput.value;
        writeState();
      });
      colorInput.addEventListener("input", () => {
        answers.color = colorInput.value;
        writeState();
      });
      priceSelect.addEventListener("change", () => {
        answers.priceRange = priceSelect.value;
        writeState();
      });
      queryAll("[data-avpp-list]").forEach((button) => button.addEventListener("click", () => {
        const listName = button.dataset.avppList;
        const value = button.dataset.value;
        const list = answers[listName];
        answers[listName] = list.includes(value) ? list.filter((item) => item !== value) : list.concat(value);
        if (listName === "useCases") track("use_case_selected", { use_case: value });
        if (listName === "priorities") track("protection_priority_selected", { priority: value });
        render();
      }));
      query("[data-avpp-back]").addEventListener("click", () => {
        if (step > 0) step -= 1;
        else {
          answers = Object.assign({}, DEFAULT_ANSWERS);
          comparison = [];
          track("planner_restarted");
          buildDeviceOptions();
        }
        render();
      });
      query("[data-avpp-next]").addEventListener("click", () => {
        if (step === 4) {
          answers = Object.assign({}, DEFAULT_ANSWERS);
          comparison = [];
          step = 0;
          track("planner_restarted");
          buildDeviceOptions();
          render();
          return;
        }
        if (!canContinue()) return;
        if (step === 0) track("exact_device_confirmed", { category: answers.category, brand: answers.brand });
        step = Math.min(4, step + 1);
        if (step === 4) {
          const count = recommendations().length;
          track("planner_results_viewed", { match_count: count });
          track(count ? "planner_completed" : "no_exact_match", { category: answers.category, brand: answers.brand });
        }
        render();
      });
      query("[data-avpp-skip]").addEventListener("click", () => {
        step = 4;
        track("planner_results_viewed", { match_count: recommendations().length });
        render();
      });
      query("[data-avpp-edit]").addEventListener("click", () => {
        step = 0;
        render();
      });
      progressButtons.forEach((button) => button.addEventListener("click", () => {
        const requested = Number(button.dataset.avppProgressStep);
        if (requested < step) {
          step = requested;
          render();
        }
      }));
      query("[data-avpp-retry]").addEventListener("click", () => loadCatalog(true));
      queryAll("[data-avpp-track]").forEach((link) => link.addEventListener("click", () => track(link.dataset.avppTrack)));

      const orbit = query("[data-avpp-orbit]");
      orbit.addEventListener("pointermove", (event) => {
        const rect = orbit.getBoundingClientRect();
        orbit.style.setProperty("--tilt-x", String(((event.clientY - rect.top) / rect.height - .5) * -10) + "deg");
        orbit.style.setProperty("--tilt-y", String(((event.clientX - rect.left) / rect.width - .5) * 10) + "deg");
      });
      orbit.addEventListener("pointerleave", () => {
        orbit.style.setProperty("--tilt-x", "0deg");
        orbit.style.setProperty("--tilt-y", "0deg");
      });
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
          orbit.dataset.active = String(entries[0].isIntersecting);
        }, { threshold: .12 });
        observer.observe(orbit);
      }

      restoreState();
      render();
      buildDeviceOptions();
      renderOrbit();
      updateStatus();
      loadCatalog(false);
      track("protection_planner_viewed");
      window.addEventListener("popstate", () => {
        restoreState();
        buildDeviceOptions();
        render();
      });
    }

    function initialize(scope) {
      const context = scope || document;
      if (context.matches && context.matches("[data-avpp-root]")) init(context);
      Array.from(context.querySelectorAll ? context.querySelectorAll("[data-avpp-root]") : []).forEach(init);
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initialize(document));
    else initialize(document);
    document.addEventListener("shopify:section:load", (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  const drawerSelector = 'cart-drawer.avontic-cart-drawer';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let drawer = null;
  let drawerObserver = null;
  let stateObserver = null;
  let stateNode = null;
  let bodyObserver = null;
  let attachFrame = 0;
  let wasOpen = false;
  let returnFocusTarget = null;
  let lastState = null;
  let lastLineAnnouncementAt = -Infinity;
  let lastAcceleratedTrackAt = -Infinity;

  const cartState = () => drawer?.querySelector('[data-av-cart-state]');

  const drawerIsOpen = () => Boolean(
    drawer &&
    (drawer.hasAttribute('open') ||
      drawer.getAttribute('aria-hidden') === 'false' ||
      drawer.classList.contains('is-open'))
  );

  const track = (eventName, detail = {}) => {
    window.AvonticAnalytics?.track?.(eventName, {
      component: 'cart_drawer',
      surface: 'cart_drawer',
      ...detail
    });
  };

  const rememberOpenTrigger = (event) => {
    const trigger = event.target?.closest?.('[aria-controls="cart-drawer"]');
    if (trigger) returnFocusTarget = trigger;
  };

  const setBackgroundInert = (open) => {
    if (open && drawer) {
      [...document.body.children].forEach((child) => {
        if (child === drawer || child.contains(drawer) || child.inert) return;
        child.inert = true;
        child.setAttribute('data-av-cart-inert', 'true');
      });
      return;
    }

    document.querySelectorAll('[data-av-cart-inert]').forEach((child) => {
      child.inert = false;
      child.removeAttribute('data-av-cart-inert');
    });
  };

  const syncViewport = () => {
    if (!drawer) return;
    const viewport = window.visualViewport;
    drawer.style.setProperty('--av-cart-visual-height', `${Math.round(viewport?.height || window.innerHeight)}px`);
    drawer.style.setProperty('--av-cart-visual-offset', `${Math.round(viewport?.offsetTop || 0)}px`);
  };

  const tuneDrawerMotion = () => {
    window.requestAnimationFrame(() => {
      [
        drawer?.shadowRoot?.querySelector('[part="overlay"]'),
        drawer?.shadowRoot?.querySelector('[part="content"]')
      ].filter(Boolean).forEach((part) => {
        part.getAnimations().forEach((animation) => {
          try {
            if (reducedMotion.matches) animation.finish();
            else animation.effect?.updateTiming({ duration: 240, easing: 'ease' });
          } catch (_error) {}
        });
      });
    });
  };

  const announce = (message) => {
    if (!message || !drawer) return;
    const region = drawer.querySelector('[data-av-cart-live]');
    if (!region) return;
    region.textContent = '';
    window.requestAnimationFrame(() => {
      region.textContent = message;
    });
  };

  const readState = () => {
    const state = cartState();
    if (!state) return null;
    return {
      count: Number(state.dataset.itemCount || 0),
      value: Number(state.dataset.cartValue || 0),
      currency: state.dataset.currency || '',
      quantityLabel: state.dataset.quantityLabel || '',
      removeLabel: state.dataset.removeLabel || ''
    };
  };

  const syncState = (announceChange = false) => {
    const nextState = readState();
    if (!nextState) return;

    if (
      announceChange &&
      lastState &&
      nextState.count !== lastState.count &&
      performance.now() - lastLineAnnouncementAt > 800
    ) {
      const label = nextState.count < lastState.count
        ? nextState.removeLabel
        : nextState.quantityLabel;
      announce(`${label}. ${nextState.count}`);
    }

    lastState = nextState;
  };

  const observeState = () => {
    const nextStateNode = cartState();
    if (nextStateNode === stateNode) return;
    stateObserver?.disconnect();
    stateNode = nextStateNode;

    if (!stateNode) return;
    syncState(true);
    stateObserver = new MutationObserver(() => syncState(true));
    stateObserver.observe(stateNode, {
      attributes: true,
      attributeFilter: ['data-item-count', 'data-cart-value']
    });
  };

  const sync = () => {
    const open = drawerIsOpen();
    const opening = open && !wasOpen;
    const closing = !open && wasOpen;

    if (opening) {
      const activeElement = document.activeElement;
      if (!returnFocusTarget && activeElement && !drawer?.contains(activeElement)) {
        returnFocusTarget = activeElement;
      }

      window.requestAnimationFrame(() => {
        const selector = drawer?.getAttribute('initial-focus');
        const initialFocus = selector ? drawer?.querySelector(selector) : null;
        if (drawerIsOpen() && initialFocus) initialFocus.focus({ preventScroll: true });
      });
    }

    document.documentElement.classList.toggle('av-cart-drawer-open', open);
    setBackgroundInert(open);
    if (open) syncViewport();

    if (opening) {
      const state = readState();
      track('av_cart_drawer_open', {
        cart_item_count: state?.count || 0,
        price_cents: state?.value || 0,
        currency: state?.currency || ''
      });
    }

    if (closing) {
      const focusTarget = returnFocusTarget?.matches?.('[aria-controls="cart-drawer"]')
        ? returnFocusTarget
        : document.querySelector('[aria-controls="cart-drawer"]');

      if (!focusTarget?.isConnected) {
        returnFocusTarget = null;
        wasOpen = open;
        return;
      }

      window.requestAnimationFrame(() => {
        focusTarget.focus({ preventScroll: true });
        if (document.activeElement !== focusTarget) {
          window.setTimeout(() => focusTarget.focus({ preventScroll: true }), 0);
        }
      });
      window.setTimeout(() => {
        if (!drawerIsOpen() && focusTarget.isConnected) focusTarget.focus({ preventScroll: true });
      }, 160);
      returnFocusTarget = null;
    }

    wasOpen = open;
    window.requestAnimationFrame(() => window.AvonticStorefrontGuard?.syncChatLayer?.());
  };

  const onLineChanged = (event) => {
    lastLineAnnouncementAt = performance.now();
    const line = event.target?.closest?.('line-item');
    const state = cartState();
    const quantity = Number(event.detail?.quantity ?? line?.querySelector('[data-line-key]')?.value ?? 0);
    const title = line?.dataset?.lineTitle || '';
    const label = quantity > 0 ? state?.dataset?.quantityLabel : state?.dataset?.removeLabel;
    if (label) announce(quantity > 0 ? `${label}: ${title}, ${quantity}` : `${title}: ${label}`);
    window.requestAnimationFrame(scheduleAttach);
  };

  const onClick = (event) => {
    const shortcut = event.target?.closest?.('.avc-empty__shortcut');
    if (shortcut && drawer?.contains(shortcut)) {
      const shortcutNav = shortcut.closest('.avc-empty__shortcuts');
      const shortcuts = [...(shortcutNav?.children || [])]
        .filter((item) => item.matches?.('.avc-empty__shortcut'));

      track('av_empty_cart_shortcut_click', {
        ecosystem: shortcutNav?.dataset?.avEcosystem || 'unresolved',
        destination: shortcut.getAttribute('href') || '',
        label: shortcut.textContent.trim(),
        position: shortcuts.indexOf(shortcut) + 1
      });
    }

    const checkout = event.target?.closest?.('button[name="checkout"]');
    if (checkout) track('av_checkout_click', { action: 'standard' });
  };

  const onPointerDown = (event) => {
    if (!event.target?.closest?.('[data-av-accelerated-checkout]')) return;
    const now = performance.now();
    if (now - lastAcceleratedTrackAt < 500) return;
    lastAcceleratedTrackAt = now;
    track('av_dynamic_checkout_click', { action: 'accelerated' });
  };

  const enhance = () => {
    if (!drawer) return;
    drawer.addEventListener('line-item:change', onLineChanged);
    drawer.addEventListener('click', onClick, { passive: true });
    drawer.addEventListener('pointerdown', onPointerDown, { passive: true });
    drawer.addEventListener('dialog:after-show', () => {
      const selector = drawer?.getAttribute('initial-focus');
      const initialFocus = selector ? drawer?.querySelector(selector) : null;
      if (initialFocus && !drawer.contains(document.activeElement)) {
        initialFocus.focus({ preventScroll: true });
      }
      tuneDrawerMotion();
      sync();
    });
    drawer.addEventListener('dialog:before-hide', () => setBackgroundInert(false));
    drawer.addEventListener('dialog:after-hide', sync);

    drawerObserver = new MutationObserver(sync);
    drawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['open', 'aria-hidden', 'class']
    });

    observeState();
    syncViewport();
    tuneDrawerMotion();
    sync();
  };

  const cleanup = (resetOpen = true) => {
    drawerObserver?.disconnect();
    stateObserver?.disconnect();
    drawerObserver = null;
    stateObserver = null;
    stateNode = null;
    setBackgroundInert(false);
    document.documentElement.classList.remove('av-cart-drawer-open');
    drawer = null;
    if (resetOpen) {
      wasOpen = false;
      returnFocusTarget = null;
    }
  };

  const attach = () => {
    attachFrame = 0;
    const nextDrawer = document.querySelector(drawerSelector);

    if (nextDrawer !== drawer) {
      const preserveOpenState = Boolean(nextDrawer);
      cleanup(!preserveOpenState);
      drawer = nextDrawer;
      if (drawer) enhance();
      return;
    }

    if (drawer) {
      observeState();
      sync();
    }
  };

  function scheduleAttach() {
    if (attachFrame) return;
    attachFrame = window.requestAnimationFrame(attach);
  }

  const start = () => {
    attach();
    bodyObserver = new MutationObserver((mutations) => {
      const drawerChanged = mutations.some((mutation) => (
        mutation.target === drawer ||
        drawer?.contains?.(mutation.target) ||
        [...mutation.addedNodes, ...mutation.removedNodes].some((node) => (
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.(drawerSelector) || node.querySelector?.(drawerSelector))
        ))
      ));
      if (drawerChanged || !drawer?.isConnected) scheduleAttach();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  ['cart:refresh', 'cart:change', 'shopify:section:load'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleAttach);
  });

  document.addEventListener('click', rememberOpenTrigger, true);

  document.addEventListener('avontic:recommendation', (event) => {
    if (event.detail?.surface !== 'cart_drawer' || event.detail?.event !== 'recommendation_offer_add_success') return;
    const addedLabel = drawer?.querySelector('[data-av-recommendation-engine]')?.dataset?.labelAdded;
    if (addedLabel) announce(addedLabel);
  });

  window.visualViewport?.addEventListener('resize', syncViewport, { passive: true });
  window.visualViewport?.addEventListener('scroll', syncViewport, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(() => {
  const track = (eventName, detail = {}) => {
    window.AvonticAnalytics?.track?.(eventName, {
      component: 'cart_page',
      surface: 'cart_page',
      ...detail
    });
  };

  const setStickyVisible = (stickyCheckout, visible) => {
    if (!stickyCheckout) return;

    if (visible) {
      stickyCheckout.hidden = false;
      stickyCheckout.inert = false;
      stickyCheckout.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(() => {
        if (!stickyCheckout.hidden) stickyCheckout.classList.add('is-visible');
      });
      return;
    }

    stickyCheckout.classList.remove('is-visible');
    stickyCheckout.inert = true;
    stickyCheckout.setAttribute('aria-hidden', 'true');
    stickyCheckout.hidden = true;
  };

  const enhance = (experience) => {
    const stickyCheckout = experience.querySelector('[data-av-mobile-checkout]');
    const primaryCheckout = experience.querySelector('.av-cart-checkout');
    const cartForm = experience.querySelector('.av-cart-layout');
    const existing = experience._avCartPageEnhancement;

    if (
      existing?.stickyCheckout === stickyCheckout &&
      existing?.primaryCheckout === primaryCheckout &&
      existing?.cartForm === cartForm
    ) return;

    existing?.checkoutObserver?.disconnect();
    setStickyVisible(stickyCheckout, false);

    let checkoutObserver = null;
    if (stickyCheckout && primaryCheckout && 'IntersectionObserver' in window) {
      checkoutObserver = new IntersectionObserver(([entry]) => {
        setStickyVisible(stickyCheckout, !entry.isIntersecting);
      }, { threshold: 0.15 });
      checkoutObserver.observe(primaryCheckout);
    }

    if (cartForm && cartForm.dataset.avQuantitySubmitReady !== 'true') {
      cartForm.dataset.avQuantitySubmitReady = 'true';
      cartForm.addEventListener('change', (event) => {
        const input = event.target?.closest?.('.av-cart-page-line__quantity input[name="updates[]"]');
        if (!input || cartForm.dataset.avCartUpdating === 'true') return;

        cartForm.dataset.avCartUpdating = 'true';
        experience.setAttribute('aria-busy', 'true');
        experience.querySelectorAll('button[name="checkout"]').forEach((button) => {
          button.disabled = true;
        });

        track('av_cart_quantity_update', {
          action: 'quantity_change',
          line_key: input.dataset.lineKey || '',
          quantity: Number(input.value || 0)
        });

        window.requestAnimationFrame(() => {
          if (typeof cartForm.requestSubmit === 'function') cartForm.requestSubmit();
          else cartForm.submit();
        });
      });
    }

    experience.querySelectorAll('button[name="checkout"]').forEach((button) => {
      if (button.dataset.avCheckoutTrackReady === 'true') return;
      button.dataset.avCheckoutTrackReady = 'true';
      button.addEventListener('click', () => {
        track('av_checkout_click', {
          action: button.closest('[data-av-mobile-checkout]') ? 'sticky_standard' : 'standard'
        });
      }, { passive: true });
    });

    const express = experience.querySelector('.av-cart-express');
    if (express && express.dataset.avCheckoutTrackReady !== 'true') {
      express.dataset.avCheckoutTrackReady = 'true';
      express.addEventListener('pointerdown', () => {
        track('av_dynamic_checkout_click', { action: 'accelerated' });
      }, { passive: true });
    }

    experience._avCartPageEnhancement = {
      stickyCheckout,
      primaryCheckout,
      cartForm,
      checkoutObserver
    };
  };

  const init = (root = document) => {
    if (root.matches?.('.av-cart-experience')) enhance(root);
    root.querySelectorAll?.('.av-cart-experience').forEach(enhance);
  };

  let initFrame = 0;
  const scheduleInit = () => {
    if (initFrame) return;
    initFrame = window.requestAnimationFrame(() => {
      initFrame = 0;
      init();
    });
  };

  const start = () => {
    init();
    const main = document.querySelector('#main');
    if (!main) return;

    new MutationObserver(scheduleInit).observe(main, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  ['cart:refresh', 'cart:change', 'shopify:section:load'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleInit);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-banner"]) return;
  try {
    
(() => {
  if (window.AvonticPrivacyCartCoordination) return;
  window.AvonticPrivacyCartCoordination = true;
  const start = () => {
    const banner = document.querySelector('privacy-banner.av-privacy');
    const drawer = document.querySelector('cart-drawer.avontic-cart-drawer');
    if (!banner || !drawer) return;
    const sync = () => {
      const suspended = drawer.hasAttribute('open') || drawer.getAttribute('aria-hidden') === 'false' || drawer.classList.contains('is-open');
      banner.toggleAttribute('data-av-suspended', suspended);
      if (suspended) banner.setAttribute('inert', '');
      else banner.removeAttribute('inert');
    };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['open', 'aria-hidden', 'class'] });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  if (!window.AvonticRecentlyViewedFamilyFilter) {
    window.AvonticRecentlyViewedFamilyFilter = true;

    const valuesOverlap = (left, right) => {
      const a = String(left || '').split('|').map((value) => value.trim().toLowerCase()).filter(Boolean);
      const b = String(right || '').split('|').map((value) => value.trim().toLowerCase()).filter(Boolean);
      if (!a.length || !b.length) return false;
      return a.some((first) => b.includes(first));
    };

    const deviceAllowed = (contextRoot, card) => {
      const contextFamily = contextRoot?.dataset.avRecentContextFamily || '';
      const cardFamily = card.dataset.avRecentFamily || '';
      if (!contextFamily || !cardFamily || contextFamily === 'universal-accessory' || cardFamily === 'universal-accessory') return false;
      if (contextFamily !== cardFamily) return false;
      if (!valuesOverlap(contextRoot.dataset.avRecentContextModels, card.dataset.avRecentModels)) return false;
      return valuesOverlap(contextRoot.dataset.avRecentContextGenerations, card.dataset.avRecentGenerations);
    };

    const filterSection = (section) => {
      const contextRoot = section.querySelector('[data-av-recent-context-family]');
      const cards = [...section.querySelectorAll('[data-av-recent-family]')];
      if (!cards.length) return;

      let visibleCount = 0;
      cards.forEach((card) => {
        const visible = deviceAllowed(contextRoot, card) && card.dataset.avCommercialTier !== 'review';
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      section.hidden = visibleCount === 0;
    };

    const sync = () => {
      document.querySelectorAll('.shopify-section--recently-viewed-products').forEach(filterSection);
    };

    let frame = 0;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        sync();
      });
    };

    const recentSections = document.querySelectorAll('.shopify-section--recently-viewed-products');
    const recentObserver = new MutationObserver(schedule);
    recentSections.forEach((section) => recentObserver.observe(section, { childList: true, subtree: true }));
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  }

  } catch(e) { console.error(e); }
})();
})();
